import { Capacitor } from "@capacitor/core";

/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface SigninInput {
  email: string;
  password: string;
  callbackURL: string;
  rememberMe: boolean;
}

export interface SessionUser {
  /** Unique identifier of the user */
  id: string;
  /** Name of the user */
  name: string;
  /** Email of the user */
  email: string;
  /** Email verification status */
  emailVerified: boolean;
  /** User image URL */
  image: object | null;
  /**
   * Creation date of the user
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the user
   *
   * @format date-time
   */
  updatedAt: string;
  /** First name of the user */
  firstname: string;
  /** Last name of the user */
  lastname: string;
  /** Organization ID of the user */
  organizationId: string;
  /** User permissions */
  permissions: string[];
}

export interface SigninResponse {
  /** Unique identifier of the session */
  id: string;
  /**
   * Expiration date of the session
   *
   * @format date-time
   */
  expiresAt: string;
  /** Session token */
  token: string;
  /**
   * Creation date of the session
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the session
   *
   * @format date-time
   */
  updatedAt: string;
  /** IP address of the session */
  ipAddress: string;
  /** User agent of the session */
  userAgent: string;
  /** Organization ID this session is scoped to (for multi-tenant support) */
  organizationId?: string;
  /** User ID associated with the session */
  userId: string;
  /** User associated with the session */
  user: SessionUser;
}

export interface SignoutResponse {
  success: boolean;
}

export interface AuthSession {
  /** Unique identifier of the session */
  id: string;
  /**
   * Expiration date of the session
   *
   * @format date-time
   */
  expiresAt: string;
  /** Session token */
  token: string;
  /**
   * Creation date of the session
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the session
   *
   * @format date-time
   */
  updatedAt: string;
  /** IP address of the session */
  ipAddress: string;
  /** User agent of the session */
  userAgent: string;
  /** Organization ID this session is scoped to (for multi-tenant support) */
  organizationId?: string;
}

export interface SessionResponse {
  /** Unique identifier of the session */
  id: string;
  /**
   * Expiration date of the session
   *
   * @format date-time
   */
  expiresAt: string;
  /** Session token */
  token: string;
  /**
   * Creation date of the session
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the session
   *
   * @format date-time
   */
  updatedAt: string;
  /** IP address of the session */
  ipAddress: string;
  /** User agent of the session */
  userAgent: string;
  /** Organization ID this session is scoped to (for multi-tenant support) */
  organizationId?: string;
  /** User associated with the session */
  session: AuthSession;
  /** User associated with the session */
  user: SessionUser;
}

export interface AcceptEmployeeInviteInput {
  /** User email */
  firstname: string;
  /** User email */
  lastname: string;
  /** Invitation token */
  token: string;
  /** Password for the new account */
  password: string;
  /** Phone number */
  phone?: string;
  /** Address line */
  addressLine?: string;
  /** City */
  city?: string;
  /** State */
  state?: string;
  /** Zip code */
  zipCode?: string;
  /** Country code */
  countryCode?: string;
  /** Date of birth */
  dayOfBirth?: string;
}

export interface UserBase {
  /** Unique identifier of the user */
  id: string;
  /**
   * Creation date of the user
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the user
   *
   * @format date-time
   */
  updatedAt: string;
  /** Email address of the user */
  email: string;
  /** First name of the user */
  firstname: string;
  /** Last name of the user */
  lastname: string;
  /** Full name of the user */
  name: string;
  /** Email verification status of the user */
  emailVerified: boolean;
  /** Profile image URL of the user */
  image?: string | null;
  /** Signed URL for the profile image (when includeSignedUrls is true) */
  imageUrl?: string | null;
  /** Organization ID */
  organizationId?: string | null;
  /** User permissions */
  permissions: string[];
}

export interface AcceptInviteResponse {
  user: UserBase;
}

export interface AcceptRelationInviteInput {
  /** User first name */
  firstname: string;
  /** User last name */
  lastname: string;
  /** Invitation token */
  token: string;
  /** Password for the new account */
  password: string;
  /** Phone number */
  phone?: string;
}

export interface AcceptAdminInviteInput {
  /** User first name */
  firstname: string;
  /** User last name */
  lastname: string;
  /** Invitation token */
  token: string;
  /** Password for the new account */
  password: string;
  /** Phone number */
  phone?: string;
}

export interface SwitchOrganizationInput {
  /** The organization ID to switch to. User must have access to this organization. */
  organizationId: string;
}

export interface ValidateResetTokenInput {
  /**
   * Password reset token from the reset link
   *
   * @example
   *   abc123xyz456...
   */
  token: string;
}

export interface ValidateResetTokenResponse {
  /** Whether the token is valid and not expired */
  valid: boolean;
  /**
   * Token expiration date (only present if token is valid)
   *
   * @format date-time
   */
  expiresAt?: string;
  /** Email associated with the reset token (only present if token is valid) */
  email?: string;
}

export interface SendMessageDto {
  /**
   * Channel to send message through
   *
   * @example
   *   WHATSAPP;
   */
  channel: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  /**
   * Recipient identifier (phone, email, etc based on channel)
   *
   * @example
   *   +31612345678;
   */
  to: string;
  /**
   * Message content
   *
   * @example
   *   Hello, this is a test message
   *
   * @maxLength 4096
   */
  body: string;
  /** Optional metadata for the message */
  metadata?: object;
  /** Media URLs to attach (if supported by channel) */
  mediaUrls?: string[];
}

export interface AddDeviceDto {
  token?: string | null;
  deviceIdentifier: string;
  name: string;
  platform?: string | null;
}

export interface UserDevice {
  id: string;
  token?: string | null;
  deviceIdentifier: string;
  name: string;
  platform?: string | null;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
}

export interface UserDevicesDto {
  devices: UserDevice[];
}

export interface NotificationTypeResponse {
  /**
   * List of all available notification types
   *
   * @example
   *   {undefined}
   *   "shift_assigned", "expense_claim_approved";
   */
  types: (
    | "shift_assigned"
    | "shift_unassigned"
    | "shift_reassigned_removed"
    | "shift_reassigned_assigned"
    | "shift_time_changed"
    | "shift_time_entry_status_changed"
    | "application_status_changed"
    | "expense_claim_submitted"
    | "expense_claim_approved"
    | "expense_claim_rejected"
  )[];
}

export interface NotificationDescriptionResponse {
  /**
   * Notification type identifier
   *
   * @example
   *   shift_assigned;
   */
  type:
    | "shift_assigned"
    | "shift_unassigned"
    | "shift_reassigned_removed"
    | "shift_reassigned_assigned"
    | "shift_time_changed"
    | "shift_time_entry_status_changed"
    | "application_status_changed"
    | "expense_claim_submitted"
    | "expense_claim_approved"
    | "expense_claim_rejected";
  /**
   * Human-readable title
   *
   * @example
   *   Shift Assignment
   */
  title: string;
  /**
   * Detailed description of when this notification is sent
   *
   * @example
   *   Sent when an employee is assigned to a shift
   */
  description: string;
  /**
   * Notification category
   *
   * @example
   *   shift;
   */
  category: "shift" | "application" | "expense" | "time_entry";
  /**
   * Metadata fields included with this notification type
   *
   * @example
   *   {
   *     "projectId": { "type": "string", "description": "Project ID", "required": true },
   *     "shiftId": { "type": "string", "description": "Shift ID", "required": false }
   *   }
   */
  metadata: Record<
    string,
    {
      type?: string;
      description?: string;
      required?: boolean;
    }
  >;
}

export interface NotificationDescriptionsResponse {
  /** Detailed descriptions of all notification types */
  notifications: NotificationDescriptionResponse[];
}

export interface NotificationCategoriesResponse {
  /**
   * Notifications grouped by category
   *
   * @example
   *   {
   *     "shift": ["shift_assigned", "shift_unassigned"],
   *     "expense": ["expense_claim_submitted", "expense_claim_approved"]
   *   }
   */
  categories: object;
}

export interface SignedUrl {
  /** The signed URL */
  url: string;
}

export interface MediaUploadResponse {
  /**
   * URL for immediate display in the frontend (CDN URL)
   *
   * @example
   *   https://bucket.cdn.digitaloceanspaces.com/org-slug/conversations/conv-123/media/uuid.jpg
   */
  mediaUrl: string;
  /**
   * URL to pass to Twilio WhatsApp API (same as mediaUrl)
   *
   * @example
   *   https://bucket.cdn.digitaloceanspaces.com/org-slug/conversations/conv-123/media/uuid.jpg
   */
  twilioUrl: string;
  /**
   * Original filename
   *
   * @example
   *   photo.jpg;
   */
  fileName: string;
  /**
   * MIME type of the file
   *
   * @example
   *   image / jpeg;
   */
  contentType: string;
  /**
   * File size in bytes
   *
   * @example
   *   1024000;
   */
  fileSize: number;
}

export interface StringFilter {
  operator?:
    | "equals"
    | "in"
    | "notIn"
    | "lt"
    | "lte"
    | "gt"
    | "gte"
    | "contains"
    | "startsWith"
    | "endsWith"
    | "mode"
    | "not";
  value?: string;
  values?: string[];
}

export interface BooleanFilter {
  operator?: "equals" | "not";
  value?: boolean;
}

export interface DateFilter {
  operator?: "equals" | "in" | "notIn" | "lt" | "lte" | "gt" | "gte" | "not";
  value?: string;
}

export interface ProjectFilterKeys {
  id?: StringFilter;
  name?: StringFilter;
  isArchived?: BooleanFilter;
  isPublished?: BooleanFilter;
  isFeatured?: BooleanFilter;
  autoAcceptApplications?: BooleanFilter;
  allowEmployeeSubmitHours?: BooleanFilter;
  allowEmployeeSubmitDeclarations?: BooleanFilter;
  startDate?: DateFilter;
  endDate?: DateFilter;
  "relation.id"?: StringFilter;
}

export interface ProjectSort {
  field?: "id" | "name" | "createdAt" | "updatedAt" | "startDate" | "endDate" | "isFeatured";
  order?: "asc" | "desc";
}

export interface PaginationFilter {
  /**
   * Page number (1-indexed)
   *
   * @default 1
   * @min 1
   */
  page?: number;
  /**
   * Number of items per page
   *
   * @default 10
   * @min 1
   * @max 100
   */
  take?: number;
}

export interface Include {
  /** Default is false */
  select?: boolean;
}

export interface RelationInclude {
  /** Default is false */
  select?: boolean;
  projects?: Include;
}

export interface ProjectIncludeKeys {
  relation?: RelationInclude;
}

export interface Aggregate {
  /** Default is false */
  compute?: boolean;
}

export interface ProjectAggregateKeys {
  totalCapacity?: Aggregate;
  totalApplications?: Aggregate;
  totalShifts?: Aggregate;
  filledShifts?: Aggregate;
  uniqueUserFunctions?: Aggregate;
}

export interface Relation {
  /** Address line of the entity */
  addressLine?: string | null;
  /** City of the entity */
  city?: string | null;
  /** State of the entity */
  state?: string | null;
  /** Zip code of the entity */
  zipCode?: string | null;
  /** Country code of the entity */
  countryCode?: string | null;
  /** Unique identifier of the relation */
  id: string;
  /** Name of the relation */
  name: string;
  /** Email of the relation */
  email?: string;
  /** Phone of the relation */
  phone?: string;
  /**
   * Creation date of the relation
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the relation
   *
   * @format date-time
   */
  updatedAt: string;
  /** Archived status of the relation */
  isArchived: boolean;
  /** Image of the relation */
  image?: string | null;
  /** Invoice email of the relation */
  invoiceEmail?: string | null;
  /** KVK number of the relation */
  kvk?: string | null;
  /** Bank of the relation */
  bank?: string | null;
  /** BTW number of the relation */
  btw?: string | null;
}

export interface ProjectStats {
  /** Total capacity of availability slots */
  totalCapacity: number;
  /** Total number of applications */
  totalApplications: number;
  /** Total number of shifts */
  totalShifts: number;
  /** Number of shifts with assigned employees */
  filledShifts: number;
  /** List of unique user functions */
  uniqueUserFunctions: string[];
}

export interface Project {
  /** Unique identifier of the project */
  id: string;
  /** Name of the project */
  name: string;
  /**
   * Creation date of the project
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the project
   *
   * @format date-time
   */
  updatedAt: string;
  /** Archived status of the project */
  isArchived: boolean;
  /** Image URL of the project */
  image?: string | null;
  /** Description of the project */
  description?: string | null;
  /** Timezone of the project */
  timeZone?: string | null;
  /** Scheduling method of the project */
  schedulingMethod: string;
  /**
   * Start date of the project
   *
   * @format date-time
   */
  startDate?: string | null;
  /**
   * End date of the project
   *
   * @format date-time
   */
  endDate?: string | null;
  /** Published status of the project */
  isPublished: boolean;
  /** Featured status of the project */
  isFeatured: boolean;
  /** Auto accept applications of the project */
  autoAcceptApplications: boolean;
  /** Allow employee to submit hours of the project */
  allowEmployeeSubmitHours: boolean;
  /** Allow employee to submit declarations of the project */
  allowEmployeeSubmitDeclarations: boolean;
  /** Enable QR code clocking of the project */
  enableQRCodeClocking: boolean;
  /** Whatsapp group link of the project */
  whatsappGroupLink?: string | null;
  /** Status of the project */
  status: string;
  /** Code of the project */
  code?: string | null;
  /** Address line of the project */
  addressLine?: string | null;
  /** State of the project */
  state?: string | null;
  /** City of the project */
  city?: string | null;
  /** Zip code of the project */
  zipCode?: string | null;
  /** Relation of the project */
  relation?: Relation | null;
  /** Project statistics */
  stats?: ProjectStats | null;
}

export interface PaginatedProject {
  /** Total number of items */
  totalAmount: number;
  items?: Project[];
}

export interface ProjectDay {
  /** Unique identifier of the project */
  id: string;
  /** Name of the project */
  name: string;
  /** Date of the stats in YYYY-MM-DD format */
  day: string;
  /** Total capacity of availability slots for the day */
  totalCapacity: number;
  /** Total number of applications for the day */
  totalApplications: number;
  /** Total number of shifts for the day */
  totalShifts: number;
  /** Number of shifts filled with assigned employees for the day */
  filledShifts: number;
  /** Project image */
  image?: string | null;
}

export interface ProjectDays {
  items?: ProjectDay[];
}

export enum ProjectSchedulingMethod {
  AVAILABILITY_BASED = "AVAILABILITY_BASED",
  DIRECT_SIGNUP = "DIRECT_SIGNUP",
}

export interface ProjectInfoCreateInput {
  /** Address line of the entity */
  addressLine?: string | null;
  /** City of the entity */
  city?: string | null;
  /** State of the entity */
  state?: string | null;
  /** Zip code of the entity */
  zipCode?: string | null;
  /** Country code of the entity */
  countryCode?: string | null;
  name: string;
  /** Description of the project */
  description?: string | null;
  /** Relation ID */
  relationId?: string | null;
  schedulingMethod: ProjectSchedulingMethod;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  /** Whatsapp group link of the project */
  whatsappGroupLink?: string | null;
}

export interface AdditionalFieldInput {
  title: string;
  description: string;
  customIcon: string;
  defaultIconName: string;
}

export interface ProjectDetailCreateInput {
  /** Array of additional fields */
  additionalFields?: AdditionalFieldInput[];
}

export enum ProjectStatus {
  OPEN = "OPEN",
  FINALIZED = "FINALIZED",
}

export interface ProjectSettingsCreateInput {
  isFeatured: boolean;
  isPublished?: boolean;
  autoAcceptApplications?: boolean;
  allowEmployeeSubmitHours?: boolean;
  allowEmployeeSubmitDeclarations?: boolean;
  enableQRCodeClocking?: boolean;
  status?: ProjectStatus;
}

export interface ShiftCreateInput {
  /** UserFunction ID */
  userFunctionId?: string | null;
  /** Employee ID */
  employeeId?: string | null;
  /** Position ID */
  positionId?: string | null;
  projectId: string;
  startAt: string;
  endAt: string;
  date: string;
  amount: number;
  /**
   * Convert created shifts to availability slots immediately
   *
   * @default false
   */
  convertToSlots?: boolean;
}

export interface AvailabilitySlotCreateInput {
  /** UserFunction ID */
  userFunctionId?: string | null;
  /** Position ID */
  positionId?: string | null;
  projectId: string;
  startAt: string;
  endAt: string;
  date: string;
  capacity: number;
  /** Status of the slot */
  status: "DRAFT" | "PUBLISHED";
  allowReserves: boolean;
}

export interface PositionCreateInput {
  projectId: string;
  name: string;
  tempId?: string;
}

export interface ProjectCreateInput {
  info: ProjectInfoCreateInput;
  detail: ProjectDetailCreateInput;
  settings: ProjectSettingsCreateInput;
  /** @format binary */
  image?: File;
  documents?: File[];
  shifts?: ShiftCreateInput[];
  availabilitySlots?: AvailabilitySlotCreateInput[];
  positions?: PositionCreateInput[];
}

export interface ProjectDuplicateInput {
  positions?: boolean;
  documents?: boolean;
  additionalFields?: boolean;
  availabilitySlots?: boolean;
  shifts?: boolean;
  /** @format date-time */
  startDate: string;
}

export interface ProjectSettingsUpdateInput {
  isFeatured: boolean;
  isPublished?: boolean;
  autoAcceptApplications?: boolean;
  allowEmployeeSubmitHours?: boolean;
  allowEmployeeSubmitDeclarations?: boolean;
  enableQRCodeClocking?: boolean;
  status?: ProjectStatus;
}

export interface ProjectAddressUpdateInput {
  /** Address line of the project */
  addressLine?: string | null;
  /** City of the project */
  city?: string | null;
  /** State of the project */
  state?: string | null;
  /** Zip code of the project */
  zipCode?: string | null;
  /** Country code of the project */
  countryCode?: string | null;
}

export interface ProjectUpdateInput {
  /** Address line of the entity */
  addressLine?: string | null;
  /** City of the entity */
  city?: string | null;
  /** State of the entity */
  state?: string | null;
  /** Zip code of the entity */
  zipCode?: string | null;
  /** Country code of the entity */
  countryCode?: string | null;
  name: string;
  /** Description of the project */
  description?: string | null;
  /** Relation ID */
  relationId?: string | null;
  schedulingMethod: ProjectSchedulingMethod;
  /** @format date-time */
  startDate: string;
  /** @format date-time */
  endDate: string;
  /** @format binary */
  image?: File;
  /** Whatsapp group link of the project */
  whatsappGroupLink?: string | null;
  /** Code of the project */
  code?: string | null;
}

export interface AdditionalField {
  id: string;
  title: string;
  /** Description */
  description?: string | null;
  /** Custom Icon */
  customIcon?: string | null;
  /** Default Icon Name */
  defaultIconName?: string | null;
}

export interface ValidatedShift {
  /** @format date-time */
  startAt: string;
  /** @format date-time */
  endAt: string;
  /** Date of the shift in DD-MM-YYYY format */
  date: string;
  /** User function for the shift (can be null) */
  userFunction?: string | null;
  /** Position name for the shift (can be null) */
  position?: string | null;
  /** Employee email for the shift (can be null) */
  employeeEmail?: string | null;
}

export interface ShiftValidationError {
  field: "startAt" | "endAt" | "userFunction" | "employeeEmail";
  errorCode:
    | "START_TIME_REQUIRED"
    | "END_TIME_REQUIRED"
    | "START_TIME_BEFORE_END_TIME"
    | "START_TIME_VALID"
    | "END_TIME_VALID"
    | "USER_FUNCTION_REQUIRED"
    | "USER_FUNCTION_EXISTS"
    | "EMPLOYEE_EMAIL_REQUIRED"
    | "EMPLOYEE_EMAIL_EXISTS"
    | "POSITION_EXISTS";
  exampleAllowedValue: string;
}

export interface ShiftValidationResult {
  rowIndex: number;
  shift: ValidatedShift | null;
  errors: ShiftValidationError[];
}

export interface TimeEntryStatusEnumFilter {
  operator?: "equals" | "in" | "notIn" | "not" | null;
  value?: "PENDING" | "ACCEPTED" | "REJECTED" | null;
  values?: ("PENDING" | "ACCEPTED" | "REJECTED")[] | null;
}

export interface ExistFilter {
  operator?: "exists" | "notExists";
}

export interface StringManyFilter {
  operator?: "some" | "every" | "none";
  value?: StringFilter;
}

export interface ShiftFilterKeys {
  startAt?: DateFilter;
  "userFunction.name"?: StringFilter;
  "project.name"?: StringFilter;
  projectId?: StringFilter;
  endAt?: DateFilter;
  "shiftTimeEntry.status"?: TimeEntryStatusEnumFilter;
  employeeId?: StringFilter;
  employee?: ExistFilter;
  "employee.user.name"?: StringFilter;
  "employee.teams.name"?: StringManyFilter;
  "position.name"?: StringFilter;
}

export type AndOperation = object;

export type OrOperation = object;

export interface ShiftSort {
  field?:
    | "id"
    | "startAt"
    | "endAt"
    | "position.name"
    | "employee.user.name"
    | "project.name"
    | "userFunction.name";
  order?: "asc" | "desc";
}

export interface EmployeeInclude {
  /** Default is false */
  select?: boolean;
  user?: Include;
  teams?: Include;
  functions?: Include;
}

export interface ShiftInclude {
  userFunction?: Include;
  position?: Include;
  employee?: EmployeeInclude;
  project?: Include;
  shiftTimeEntry?: Include;
  campaignTargets?: Include;
}

export interface ShiftAggregateKeys {
  campaignInvitations?: Aggregate;
}

export interface Team {
  /** Unique identifier of the team */
  id: string;
  /** Name of the team */
  name: string;
  /**
   * Creation date of the team
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the team
   *
   * @format date-time
   */
  updatedAt: string;
  /** Archived status of the team */
  isArchived: boolean;
}

export interface EmployeeStats {
  /** Total number of shifts assigned to employee */
  totalAmountOfShifts: number;
  /** Average rating from accepted and linked shift time entry cards */
  averageRating: object;
  /** Total number of rejected applications */
  totalAmountOfRejectedApplications: number;
}

export interface Employee {
  /** Address line of the entity */
  addressLine?: string | null;
  /** City of the entity */
  city?: string | null;
  /** State of the entity */
  state?: string | null;
  /** Zip code of the entity */
  zipCode?: string | null;
  /** Country code of the entity */
  countryCode?: string | null;
  /** User of the employee */
  id: string;
  /**
   * Creation date of the app user
   *
   * @format date-time
   */
  createdAt?: string | null;
  /**
   * Last update date of the app user
   *
   * @format date-time
   */
  updatedAt?: string | null;
  /**
   * Day of birth of the app user
   *
   * @format date-time
   */
  dayOfBirth?: string | null;
  /** Phone number of the app user */
  phone?: string | null;
  /** Note for the app user */
  note?: string | null;
  /** Phone country of the app user */
  phoneCountry?: string | null;
  /** Archive status of the employee in this organization */
  isArchived?: boolean | null;
  /** Functions */
  functions: UserFunction[];
  /** Teams of the employee */
  teams: Team[];
  /** User of the employee */
  user?: UserBase | null;
  /** Employee statistics */
  stats?: EmployeeStats | null;
}

export interface Rate {
  id: string;
  hourlyRate: number;
}

export interface UserFunction {
  /** Unique identifier of the user function */
  id: string;
  /** Name of the user function */
  name: string;
  /**
   * Creation date of the user function
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the user function
   *
   * @format date-time
   */
  updatedAt: string;
  /** Archived status of the user function */
  isArchived: boolean;
  /** Employees that have this function */
  members: Employee[];
  defaultSalesRate: Rate;
}

export interface Position {
  /** Unique identifier of the position */
  id: string;
  /** Name of the position */
  name: string;
  /** Relevant project */
  project?: Project | null;
}

export interface ExpenseClaim {
  /** Unique identifier of the expense claim */
  id: string;
  /**
   * Creation date of the expense claim
   *
   * @format date-time
   */
  createdAt?: string;
  /**
   * Last update date of the expense claim
   *
   * @format date-time
   */
  updatedAt?: string;
  /** Type of the expense claim */
  type?: "CAR" | "PUBLIC_TRANSPORT" | "OTHER";
  /** Status of the expense claim */
  status?: "PENDING" | "ACCEPTED" | "REJECTED";
  /** Amount of the expense claim */
  amount?: number;
  /** File link of the expense claim */
  fileLink?: object;
  /** Note of the expense claim */
  note?: object;
}

export interface ShiftTimeEntry {
  /** Unique identifier of the shift time entry */
  id: string;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  /** @format date-time */
  startAt?: string | null;
  /** End time of the shift time entry */
  endAt?: string | null;
  breakTimeMinutes?: number | null;
  bonus?: number | null;
  /** Relevant Position */
  position?: Position | null;
  status?: "PENDING" | "ACCEPTED" | "REJECTED" | null;
  enteredBy?: "Employee" | "Manager";
  /**
   * @min 1
   * @max 5
   */
  rating?: number | null;
  /** Expense claim of the shift time entry */
  expenseClaim?: ExpenseClaim | null;
}

export interface CampaignTarget {
  /** Unique ID of the campaign target */
  id: string;
  /** Type of target (AVAILABILITY_SLOT or SHIFT) */
  type: "AVAILABILITY_SLOT" | "SHIFT" | "PROJECT";
  /** Campaign ID this target belongs to */
  campaignId?: object;
  /** Project ID this target belongs to */
  projectId?: object;
  /** Availability slot ID (if type is AVAILABILITY_SLOT) */
  availabilitySlotId?: object;
  /** Shift ID (if type is SHIFT) */
  shiftId?: object;
  /** The availability slot being targeted (populated if included) */
  availabilitySlot?: object;
  /** The shift being targeted (populated if included) */
  shift?: object;
  /** The project this target belongs to (populated if included) */
  project?: object;
}

export interface ShiftTargetStats {
  /** Linked campaign target id if any */
  campaignTargetId?: object;
  /** Total invitations linked to target */
  invitationTotalCount?: number;
  /** Pending invitations linked to target */
  invitationPendingCount?: number;
  /** Whether there are pending invitations */
  hasOpenInvitations?: boolean;
}

export interface Shift {
  /** Unique identifier of the shift */
  id: string;
  /** Relevant projectId */
  projectId?: string | null;
  /** Relevant employeeId */
  employeeId?: string | null;
  /**
   * Creation date of the shift
   *
   * @format date-time
   */
  createdAt?: string | null;
  /**
   * Last update date of the shift
   *
   * @format date-time
   */
  updatedAt: string;
  /**
   * Start date/time of the shift
   *
   * @format date-time
   */
  startAt: string;
  /**
   * End date/time of the shift
   *
   * @format date-time
   */
  endAt: string;
  /** Time zone of the project */
  timeZone?: string | null;
  /** Note of the shift */
  note?: string | null;
  /** Changelog of the shift */
  changelog?: string | null;
  /** Relevant UserFunction */
  userFunction?: UserFunction | null;
  /** Relevant Position */
  position?: Position | null;
  /** Relevant Employee */
  employee?: Employee | null;
  /** Relevant project */
  project?: Project | null;
  /** Relevant ShiftTimeEntry */
  shiftTimeEntry?: ShiftTimeEntry | null;
  /** Campaign targets linked to this shift (present when included) */
  campaignTargets?: CampaignTarget[];
  /** Aggregated stats for campaign invitations (when requested) */
  stats?: ShiftTargetStats;
}

export interface PaginatedShift {
  /** Total number of items */
  totalAmount: number;
  items?: Shift[];
  /** Time zone of the project */
  timeZone: string;
}

export interface UserShiftOverview {
  /** Most recent shifts for the user */
  recent: Shift[];
  /** Upcoming shifts for the user */
  upcoming: Shift[];
}

export interface ShiftBulkCreateInput {
  /** Array of shifts to create */
  shifts: ShiftCreateInput[];
  /**
   * Convert created shifts to availability slots immediately
   *
   * @default false
   */
  convertToSlots?: boolean;
}

export interface ShiftBulkDeleteInput {
  /**
   * Array of shift IDs to delete
   *
   * @example
   *   {undefined}
   *   "uuid-1", "uuid-2", "uuid-3";
   */
  ids: string[];
}

export interface ShiftConvertToSlotsInput {
  /**
   * Array of shift IDs to convert to availability slots
   *
   * @example
   *   {undefined}
   *   "uuid-1", "uuid-2", "uuid-3";
   */
  shiftIds: string[];
}

export interface ShiftUpdateInput {
  /** UserFunction ID */
  userFunctionId?: string | null;
  /** Employee ID */
  employeeId?: string | null;
  startAt?: string;
  endAt?: string;
  date?: string;
  projectId?: string;
  /** Employee ID */
  positionId?: string | null;
}

export interface ShiftNoteUpdateInput {
  note: string;
}

export interface SolverShiftDto {
  /** Unique identifier of the shift */
  shift_id: string;
  /**
   * Start time of the shift
   *
   * @format date-time
   */
  start: string;
  /**
   * End time of the shift
   *
   * @format date-time
   */
  end: string;
  /** Function identifiers for the shift */
  functions_ids: string[];
  /** Position name/label */
  position?: string;
  /** If true, this shift is fixed and may not be reassigned */
  fixed_flag: boolean;
  /** Pre-assigned employee identifier (optional) */
  assigned_employee_id?: string;
}

export interface SolverEmployeeDto {
  /** Unique identifier of the employee */
  employee_id: string;
  /** Function identifiers for the employee */
  function_ids: string[];
  /** Friend identifiers for grouping */
  friends_ids: string[];
}

export interface AvailabilityEntryDto {
  /** Origin application slot id (not unique) */
  application_slot_id?: string;
  /** Employee identifier */
  employee_id: string;
  /**
   * Start time
   *
   * @format date-time
   */
  start: string;
  /**
   * End time
   *
   * @format date-time
   */
  end: string;
  /** Whether the employee is available in this interval */
  available: boolean;
}

export interface SolverOptimizationFactorDto {
  /**
   * The optimization factor name
   *
   * @example
   *   FRIENDSHIP;
   */
  name: string;
  /**
   * Priority of this factor (1 = highest, 2 = medium, 3 = lowest)
   *
   * @example
   *   1;
   */
  priority: number;
}

export interface SolverOptionsDto {
  /** Whether to assign all shifts or only the unassigned shifts */
  assignAllShifts?: boolean;
  /** Optimization factors with priorities (max 3 factors) */
  optimizationFactors?: SolverOptimizationFactorDto[];
}

export interface WorkforceProblemDataDto {
  /** Shifts to plan */
  shifts: SolverShiftDto[];
  /** Employees to consider */
  employees: SolverEmployeeDto[];
  /** Availability entries */
  availability: AvailabilityEntryDto[];
  /** Solver options */
  options?: SolverOptionsDto;
}

export interface ShiftAssignmentDto {
  /** Shift identifier */
  shift_id: string;
  /** Assigned employee identifier */
  employee_id?: string;
}

export interface SolutionMetricsDto {
  /** Percentage of shifts covered (0-100) */
  coverage_percentage?: number;
  /** Resource utilization rate (0-100) */
  utilization_rate?: number;
  /** Number of unassigned shifts */
  unassigned_shifts?: number;
  /** Total number of shifts in the problem */
  total_shifts?: number;
  /** Total cost of the solution */
  total_cost?: number;
  /** Satisfaction score (0-100, higher is better) */
  satisfaction_score?: number;
  /** Time taken to solve in seconds */
  solve_time?: number;
  /** Number of friends/team members scheduled together */
  friends_together?: number;
  /** Average size of friend groups in the solution */
  average_friend_group_size?: number;
}

export interface SolverResultDataDto {
  /** List of shift assignments */
  shift_assignment?: ShiftAssignmentDto[];
  /** Solution metrics */
  solution_metrics?: SolutionMetricsDto;
  /** Whether a feasible solution was found */
  feasible?: boolean;
  /** Warnings about the solution */
  warnings?: string[];
  /** Whether the solver run was successful */
  success?: boolean;
  /** Program errors (if any) */
  errors?: string[];
}

export interface SolverJobQueueDataDto {
  /** The workforce problem to solve */
  problem: WorkforceProblemDataDto;
  /**
   * ID of the user who submitted the job
   *
   * @example
   *   user - uuid - 123;
   */
  userId: string;
  /**
   * ID of the organization
   *
   * @example
   *   org - uuid - 456;
   */
  organizationId: string;
  /**
   * ID of the project being planned
   *
   * @example
   *   project - uuid - 789;
   */
  projectId: string;
  /**
   * Timestamp when the job was submitted
   *
   * @format date-time
   */
  submittedAt: string;
  /** Job options */
  options?: object;
}

export interface SolverQueueProgressEventDto {
  /** Solver job identifier */
  jobId: string;
  /** Progress percentage (0-100) */
  progress: number;
  /** Current stage description */
  stage: string;
  /** Optional human readable message */
  message?: string;
  /** User identifier that created the job */
  userId: string;
  /** Organization identifier for the job */
  organizationId: string;
  /**
   * Timestamp for when the progress update occurred
   *
   * @format date-time
   */
  timestamp: string;
}

export interface SolverQueueFailedEventDto {
  /** Solver job identifier */
  jobId: string;
  /** Error message explaining why the job failed */
  error: string;
  /** Optional structured error details */
  errorDetails?: object;
  /** User identifier that created the job */
  userId?: string;
  /** Organization identifier for the job */
  organizationId?: string;
  /**
   * Timestamp for when the failure happened
   *
   * @format date-time
   */
  timestamp: string;
}

export interface VersionCreatorDto {
  /** Admin user ID */
  id: string;
  /** User name */
  name: string;
  /** User email */
  email: string;
}

export interface VersionStatisticsDto {
  /** Total number of shifts in this version */
  total_shifts: number;
  /** Number of assigned shifts */
  assigned_shifts: number;
}

export interface PlanningVersionListItemDto {
  /** Version ID */
  id: string;
  /** Version name */
  name: string;
  /** Version description */
  description: object | null;
  /** Version status */
  status: "generated" | "approved";
  /** Creation timestamp */
  created_at: string;
  /** Creator information */
  created_by: VersionCreatorDto;
  /** Parent version ID */
  parent_id: object | null;
  /** Whether this is the HEAD version */
  is_head: boolean;
  /** Version statistics */
  statistics?: VersionStatisticsDto;
}

export interface PaginationDto {
  /** Total number of items */
  total: number;
  /** Current page number */
  page: number;
  /** Items per page */
  limit: number;
}

export interface ListPlanningVersionsResponseDto {
  /** List of planning versions */
  versions: PlanningVersionListItemDto[];
  /** Current HEAD version ID */
  current_head_id: string;
  /** Pagination information */
  pagination?: PaginationDto;
}

export interface PlanningVersionDetailDto {
  /** Version ID */
  id: string;
  /** Version name */
  name: string;
  /** Version description */
  description: object | null;
  /** Version status */
  status: "generated" | "approved";
  /** Creation timestamp */
  created_at: string;
  /** Last update timestamp */
  updated_at: string;
  /** Creator information */
  created_by: VersionCreatorDto;
  /** Parent version ID */
  parent_id: object | null;
  /** Whether this is the HEAD version */
  is_head: boolean;
  /** Version snapshot with shift assignments and assignment events */
  snapshot: Record<
    string,
    {
      employee_id?: string | null;
      employee_name?: string | null;
      employee_email?: string | null;
      start_time?: string;
      end_time?: string;
      role?: string;
      location?: string | null;
      /** Assignment events for this shift in this version (blame tracking) */
      events?: AssignmentEventDto[];
    }
  >;
}

export interface GetPlanningVersionResponseDto {
  /** Version details */
  version: PlanningVersionDetailDto;
}

export interface BulkFetchVersionsRequestDto {
  /** Array of version IDs to fetch */
  version_ids: string[];
}

export interface BulkFetchVersionsResponseDto {
  /** List of versions with snapshots */
  versions: PlanningVersionDetailDto[];
}

export interface ApproveVersionResponseDto {
  /** Success indicator */
  success: boolean;
  /** Previous HEAD version ID */
  previous_head: string;
  /** New HEAD version ID */
  new_head: string;
  /** Applied changes summary */
  applied_changes: object;
}

export interface DeleteVersionResponseDto {
  /** Success indicator */
  success: boolean;
  /** Deleted version ID */
  deleted_version: string;
}

export interface UpdateVersionRequestDto {
  /** Version name */
  name?: string;
  /** Version description */
  description?: string;
}

export interface UpdateVersionResponseDto {
  /** Updated version */
  version: PlanningVersionDetailDto;
}

export interface RevertVersionResponseDto {
  /** Success indicator */
  success: boolean;
  /** Previous HEAD version ID */
  previous_head: string;
  /** New HEAD version ID */
  new_head: string;
  /** Number of versions deleted */
  deleted_versions_count: number;
  /** Applied changes summary */
  applied_changes: object;
}

export interface AssignmentEventDto {
  /** Event ID */
  id: string;
  /** Event type */
  event_type: "ASSIGN" | "UNASSIGN";
  /** Event reason */
  reason: "PLANNER_PROPOSAL" | "MANUAL_CHANGE" | "WORKER_CANCELLATION" | "AUTO_REPLACEMENT";
  /** Previous employee ID (for reassignments) */
  previous_employee_id: object | null;
  /** When the event occurred */
  created_at: string;
  /** Who created the event */
  created_by: VersionCreatorDto | null;
  /** Event source */
  source: "ADMIN_USER" | "AI_AGENT" | "SYSTEM";
}

export interface SolverJobStatusResponseDto {
  /**
   * Unique identifier of the solver job
   *
   * @example
   *   1234567890;
   */
  id: string;
  /**
   * Current state of the job
   *
   * @example
   *   completed;
   */
  state: "waiting" | "active" | "completed" | "failed" | "delayed";
  /**
   * Job progress (0-100)
   *
   * @example
   *   100;
   */
  progress: object;
  /** Job data (problem definition) */
  data: object;
  /** Job result (solution) */
  result?: object;
  /**
   * Failure reason if job failed
   *
   * @example
   *   Solver timeout exceeded
   */
  failedReason?: string;
  /**
   * Timestamp when job was created
   *
   * @example
   *   1706616000000;
   */
  timestamp: number;
  /**
   * Timestamp when job finished
   *
   * @example
   *   1706616003500;
   */
  finishedOn?: number;
  /**
   * Timestamp when job started processing
   *
   * @example
   *   1706616001000;
   */
  processedOn?: number;
}

export interface SolverJobCancellationResponseDto {
  /**
   * Confirmation message
   *
   * @example
   *   Job cancelled successfully
   */
  message: string;
  /**
   * ID of the cancelled job
   *
   * @example
   *   1234567890;
   */
  jobId: string;
}

export interface OptimizationFactorDto {
  /**
   * The optimization factor type
   *
   * @example
   *   FRIENDSHIP;
   */
  name: "FRIENDSHIP" | "COMMUTE" | "AGE" | "DAYS_REGISTERED";
  /**
   * Priority of this factor (1 = highest priority, 2 = medium, 3 = lowest)
   *
   * @example
   *   1;
   *
   * @min 1
   * @max 3
   */
  priority: number;
}

export interface PlanningOptionsDto {
  /**
   * Whether to assign all shifts (true) or leave some unassigned
   *
   * @default false
   */
  assignAllShifts?: boolean;
  /**
   * Optimization factors to use, with priorities (max 3 factors allowed)
   *
   * @maxItems 3
   */
  optimizationFactors?: OptimizationFactorDto[];
}

export interface SolverJobSubmissionResponseDto {
  /**
   * Unique identifier of the submitted solver job
   *
   * @example
   *   1234567890;
   */
  jobId: string;
}

export interface AvailableFactorDto {
  /** The optimization factor type */
  name: "FRIENDSHIP" | "COMMUTE" | "AGE" | "DAYS_REGISTERED";
  /** Whether this factor is available for the project */
  available: boolean;
  /**
   * The human readable label for the optimization factor
   *
   * @example
   *   Friendship;
   */
  label: string;
  /** Human-readable reason why the factor is not available */
  reason?: string;
}

export interface AvailableFactorsResponseDto {
  /** List of optimization factors with availability status */
  factors: AvailableFactorDto[];
  /** Additional notes about rejected factors */
  rejectionReasons?: string[];
}

export interface ApplicationFilterKeys {
  "employee.user.name"?: StringFilter;
  "employee.id"?: StringFilter;
  status?: StringFilter;
  "availabilitySlot.id"?: StringFilter;
  "availabilitySlot.startAt"?: StringFilter;
  "availabilitySlot.endAt"?: StringFilter;
  "availabilitySlot.projectId"?: StringFilter;
  "availabilitySlot.userFunction.name"?: StringFilter;
  "employee.teams.name"?: StringManyFilter;
}

export interface ApplicationSort {
  field?:
    | "id"
    | "createdAt"
    | "updatedAt"
    | "startAt"
    | "endAt"
    | "status"
    | "employee.dayOfBirth"
    | "employee.city"
    | "employee.phone"
    | "employee.user.email"
    | "employee.user.name"
    | "availabilitySlot.userFunction.name"
    | "availabilitySlot.startAt"
    | "availabilitySlot.endAt";
  order?: "asc" | "desc";
}

export interface AvailabilitySlotWithBaseInclude {
  /** Default is false */
  select?: boolean;
  project?: Include;
  userFunction?: Include;
}

export interface ApplicationInclude {
  availabilitySlot?: AvailabilitySlotWithBaseInclude;
  employee?: EmployeeInclude;
  teams?: Include;
}

export interface AvailabilitySlotStats {
  /** Number of accepted applications for this slot */
  acceptedApplications: number;
  /** Linked campaign target id if any */
  campaignTargetId?: object;
  /** Total invitations linked to target */
  invitationTotalCount?: number;
  /** Pending invitations linked to target */
  invitationPendingCount?: number;
  /** Whether there are pending invitations or active campaign */
  hasOpenInvitations?: boolean;
  /** ID of the distribution conversation linked to the campaign (for campaign-targeted messaging) */
  distributionConversationId?: object;
}

export interface AvailabilitySlot {
  /** Unique identifier of the project */
  id: string;
  /** Relevant project */
  project?: Project | null;
  /** Relevant UserFunction */
  userFunction?: UserFunction | null;
  /** Relevant Position */
  position?: Position | null;
  /** Position ID */
  positionId?: object;
  applications: Application[];
  /**
   * Creation date of the slot
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the slot
   *
   * @format date-time
   */
  updatedAt: string;
  /** @format date-time */
  startAt: string;
  /** @format date-time */
  endAt: string;
  capacity: number;
  /** Status of the slot */
  status: "DRAFT" | "PUBLISHED";
  /** If reserves are allowed */
  allowReserves: boolean;
  /** Availability slot statistics */
  stats?: AvailabilitySlotStats | null;
  /** Campaign targets linked to this slot (present when included) */
  campaignTargets?: CampaignTarget[];
}

export interface Application {
  /** Unique identifier of the Availability */
  id: string;
  /** Relevant Employee */
  employee?: Employee | null;
  /**
   * Creation date of the Availability
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the Availability
   *
   * @format date-time
   */
  updatedAt: string;
  /**
   * Start date/time of the Availability
   *
   * @format date-time
   */
  startAt: string;
  /**
   * End date/time of the Availability
   *
   * @format date-time
   */
  endAt: string;
  /** Status of the Availability */
  status: "PENDING" | "RESERVE" | "ACCEPTED" | "REJECTED";
  /** Availability Slot ID */
  availabilitySlotId: string;
  /** Relevant Availability Slot */
  availabilitySlot?: AvailabilitySlot | null;
  /** Note of the application */
  note: object;
}

export interface PaginatedApplication {
  /** Total number of items */
  totalAmount: number;
  items?: Application[];
  /** Total number of items with the status accepted */
  totalAccepted: number;
  /** Total number of items with the status reserve */
  totalReserve: number;
  /** Total number of items with the status pending */
  totalPending: number;
  /** Total number of items with the status rejected */
  totalRejected: number;
}

export interface ApplicationCreateInput {
  availabilitySlotId: string;
  employeeId: string;
  startAt: string;
  endAt: string;
  /** Status of the application */
  status: "PENDING" | "RESERVE" | "ACCEPTED" | "REJECTED";
}

export interface ApplicationCreateEmployeeInput {
  /** Array of availability slot IDs */
  availabilitySlotIds: string[];
}

export interface ApplicationUpdateInput {
  /** Status of the application */
  status?: "PENDING" | "RESERVE" | "ACCEPTED" | "REJECTED";
}

export interface ValidatedEmployee {
  email: string;
  firstname: string;
  lastname: string;
  phone: string | null;
  phoneCountry: string | null;
  /** @format date-time */
  dayOfBirth: string | null;
  addressLine: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
}

export interface EmployeeValidationError {
  field:
    | "email"
    | "firstname"
    | "lastname"
    | "phone"
    | "phoneCountry"
    | "dayOfBirth"
    | "addressLine"
    | "city"
    | "state"
    | "zipCode"
    | "countryCode"
    | "functions";
  errorCode:
    | "EMAIL_REQUIRED"
    | "EMAIL_VALID"
    | "EMAIL_ALREADY_EXISTS"
    | "FIRSTNAME_REQUIRED"
    | "LASTNAME_REQUIRED"
    | "PHONE_VALID"
    | "DAY_OF_BIRTH_VALID";
  exampleAllowedValue: string;
}

export interface EmployeeValidationResult {
  rowIndex: number;
  employee: ValidatedEmployee | null;
  errors: EmployeeValidationError[];
}

export interface EmployeeFilterKeys {
  id?: StringFilter;
  createdAt?: DateFilter;
  updatedAt?: DateFilter;
  addressLine?: StringFilter;
  city?: StringFilter;
  state?: StringFilter;
  zipCode?: StringFilter;
  countryCode?: StringFilter;
  dayOfBirth?: DateFilter;
  phone?: StringFilter;
  phoneCountry?: StringFilter;
  isArchived?: BooleanFilter;
  "teams.id"?: StringManyFilter;
  "relations.id"?: StringManyFilter;
  "functions.id"?: StringManyFilter;
  "user.id"?: StringFilter;
  "user.name"?: StringFilter;
  "user.email"?: StringFilter;
  "teams.name"?: StringManyFilter;
  "functions.name"?: StringManyFilter;
  "applications.availabilitySlotId"?: StringManyFilter;
}

export interface EmployeeSort {
  field?:
    | "id"
    | "createdAt"
    | "updatedAt"
    | "addressLine"
    | "city"
    | "state"
    | "zipCode"
    | "countryCode"
    | "dayOfBirth"
    | "phone"
    | "note"
    | "phoneCountry"
    | "user.name"
    | "user.email";
  order?: "asc" | "desc";
}

export interface EmployeeAggregateKeys {
  totalAmountOfShifts?: Aggregate;
  averageRating?: Aggregate;
  totalAmountOfRejectedApplications?: Aggregate;
}

export interface PaginatedEmployee {
  /** Total number of items */
  totalAmount: number;
  items?: Employee[];
}

export interface IntFilter {
  operator?: "equals" | "in" | "notIn" | "lt" | "lte" | "gt" | "gte" | "not";
  value?: number | number[];
}

export interface EmployeeAvailableFilterKeys {
  name?: StringFilter;
  team?: StringFilter;
  hasPhoneNumber?: BooleanFilter;
  ageMin?: IntFilter;
  ageMax?: IntFilter;
  hourlyRateMin?: IntFilter;
  hourlyRateMax?: IntFilter;
  city?: StringFilter;
  maxDistanceKm?: IntFilter;
}

export interface AvailableEmployee {
  /** Unique identifier of the employee */
  id: string;
  /** Name of the user */
  name: string;
  /** First name of the user */
  firstname: string;
  /** Last name of the user */
  lastname: string;
  /** Profile image URL of the user */
  image?: string | null;
  /**
   * Day of birth of the employee
   *
   * @format date-time
   */
  dayOfBirth?: string | null;
  /** Phone number of the employee */
  phone?: string | null;
  /** City of the employee */
  city?: string | null;
  /** Address line of the employee */
  addressLine?: string | null;
  /** Zip code of the employee */
  zipCode?: string | null;
  /** Country code of the employee */
  countryCode?: string | null;
  /** Age of the employee */
  age?: object;
  /** Hourly rate of the employee */
  hourlyRate?: object;
  /** Distance in kilometers from search location */
  distance_km?: object;
  /** ID of the application */
  applicationId?: string;
  /** Status of the application */
  applicationStatus?: string;
  /** Note of the application */
  applicationNote?: string;
  /** ID of the availability slot */
  availabilitySlotId?: string;
  /**
   * Start date of the availability slot
   *
   * @format date-time
   */
  availabilitySlotStartAt?: string | null;
  /**
   * End date of the availability slot
   *
   * @format date-time
   */
  availabilitySlotEndAt?: string | null;
  /** Teams of the employee */
  teams: Team[];
  /** User of the employee */
  user?: UserBase | null;
}

export interface PaginatedAvailableEmployee {
  /** Total number of items */
  totalAmount: number;
  items?: AvailableEmployee[];
}

export interface UserInput {
  email: string;
  firstname: string;
  lastname: string;
  image?: string;
  name?: string;
}

export interface EmployeeInput {
  user?: UserInput;
  addressLine?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  countryCode?: string;
  /** @format date-time */
  dayOfBirth?: string;
  phone?: string;
  note?: string;
  phoneCountry?: string;
  procurementRateAmount?: number;
}

export interface AddOrRemoveInput {
  isConnect: boolean;
  ids: string[];
}

export interface UpdateRateInput {
  rateAmount: number;
  rateTarget: "userFunction" | "organization" | "relation";
  rateEntityType: "procurement" | "sales";
  targetEntityId: string;
}

export interface UserFunctionProcurementRate {
  id: string;
  userFunction: UserFunction;
  ageFrom: number;
  ageTo: number;
  rate: Rate;
}

export interface UserFunctionSalesRate {
  userFunction: UserFunction;
  rate: Rate;
}

export interface CreateProcurementRateInput {
  rateAmount: number;
  ageFrom: number;
  ageTo: number;
}

export interface OrganizationProcurementRate {
  id: string;
  rateId: string;
  rate: Rate;
  ageFrom: number;
  ageTo: number;
}

export interface OrganizationSalesRate {
  defaultSalesRate: Rate;
  userFunctions: UserFunctionSalesRate[];
}

export interface CreateRelationSalesRateInput {
  relationId: string;
  userFunctionId: string;
  rateAmount: number;
}

export interface RelationSalesRate {
  id: string;
  relation: object;
  rate: Rate;
  userFunction: UserFunction;
}

export interface TeamFilterKeys {
  name?: StringFilter;
  isArchived?: BooleanFilter;
  "members.id"?: StringManyFilter;
}

export interface TeamSort {
  field?: "id" | "name" | "createdAt" | "updatedAt";
  order?: "asc" | "desc";
}

export interface PaginatedTeam {
  /** Total number of items */
  totalAmount: number;
  items?: Team[];
}

export interface TeamCreateInput {
  name: string;
}

export interface TeamUpdateInput {
  name: string;
}

export interface ApplyForShiftKeys {
  /**
   * Shift identifier
   *
   * @example
   *   shift - uuid - 123;
   */
  shiftId: string;
  /**
   * Project name
   *
   * @example
   *   Lowlands 2025
   */
  projectName: string;
  /**
   * Project identifier
   *
   * @example
   *   project - uuid - 456;
   */
  projectId: string;
  /**
   * Start date and time in ISO format
   *
   * @example
   *   2025-08-07T12:00:00Z
   */
  startAt: string;
  /**
   * End date and time in ISO format
   *
   * @example
   *   2025-08-07T16:00:00Z
   */
  endAt: string;
  /**
   * User function/role
   *
   * @example
   *   Entreemedewerker;
   */
  userFunction: string;
  /**
   * Position title
   *
   * @example
   *   Nieuwe medewerker
   */
  position: string;
}

export interface ApplyForShiftActionType {
  /**
   * The action type
   *
   * @example
   *   APPLY_FOR_SHIFT;
   */
  type: "APPLY_FOR_SHIFT";
  /**
   * Version of the action type
   *
   * @example
   *   1;
   */
  version: string;
  /** Key-value map for ApplyForShift action */
  keys: ApplyForShiftKeys;
}

export interface CancelShiftKeys {
  /**
   * User ID of the employee requesting the cancellation
   *
   * @example
   *   user - uuid - 123;
   */
  userId: string;
  /**
   * Shift identifier to cancel
   *
   * @example
   *   shift - uuid - 789;
   */
  shiftId: string;
  /**
   * Project name of the shift
   *
   * @example
   *   Pinkpop 2025
   */
  projectName: string;
  /**
   * Start date and time of the shift
   *
   * @example
   *   2025-06-15T14:00:00Z
   */
  startAt: string;
  /**
   * End date and time of the shift
   *
   * @example
   *   2025-06-15T22:00:00Z
   */
  endAt: string;
  /**
   * Reason for cancellation
   *
   * @example
   *   Ziek;
   */
  cancellationReason: string;
}

export interface CancelShiftActionType {
  /**
   * The action type
   *
   * @example
   *   CANCEL_SHIFT;
   */
  type: "CANCEL_SHIFT";
  /**
   * Version of the action type
   *
   * @example
   *   1;
   */
  version: string;
  /** Key-value map for CancelShift action */
  keys: CancelShiftKeys;
}

export interface AssignShiftKeys {
  /**
   * Shift identifier
   *
   * @example
   *   shift - uuid - 123;
   */
  shiftId: string;
  /**
   * Project name
   *
   * @example
   *   Lowlands 2025
   */
  projectName: string;
  /**
   * Project identifier
   *
   * @example
   *   project - uuid - 456;
   */
  projectId: string;
  /**
   * Start date and time in ISO format
   *
   * @example
   *   2025-08-07T12:00:00Z
   */
  startAt: string;
  /**
   * End date and time in ISO format
   *
   * @example
   *   2025-08-07T16:00:00Z
   */
  endAt: string;
  /**
   * User function/role
   *
   * @example
   *   Entreemedewerker;
   */
  userFunction: string;
  /**
   * Position title
   *
   * @example
   *   Nieuwe medewerker
   */
  position: string;
}

export interface AssignShiftActionType {
  /**
   * The action type
   *
   * @example
   *   ASSIGN_SHIFT;
   */
  type: "ASSIGN_SHIFT";
  /**
   * Version of the action type
   *
   * @example
   *   1;
   */
  version: string;
  /** Key-value map for AssignShift action */
  keys: AssignShiftKeys;
}

export interface StartCancelledShiftCampaignKeys {
  /**
   * Shift identifier that was cancelled and needs workers
   *
   * @example
   *   shift - uuid - 789;
   */
  shiftId: string;
  /**
   * Project name of the cancelled shift
   *
   * @example
   *   Pinkpop 2025
   */
  projectName: string;
  /**
   * Start date and time of the shift
   *
   * @example
   *   2025-06-15T14:00:00Z
   */
  startAt: string;
  /**
   * End date and time of the shift
   *
   * @example
   *   2025-06-15T22:00:00Z
   */
  endAt: string;
  /**
   * Reason why the shift was cancelled
   *
   * @example
   *   Employee called in sick
   */
  cancellationReason: string;
  /**
   * Priority level for finding replacement workers
   *
   * @example
   *   high;
   */
  priority: string;
}

export interface StartCancelledShiftCampaignActionType {
  /**
   * The action type
   *
   * @example
   *   START_CANCELLED_SHIFT_CAMPAIGN;
   */
  type: "START_CANCELLED_SHIFT_CAMPAIGN";
  /**
   * Version of the action type
   *
   * @example
   *   1;
   */
  version: string;
  /** Key-value map for StartCancelledShiftCampaign action */
  keys: StartCancelledShiftCampaignKeys;
}

export interface ActionTypesResponse {
  /** All available action types with their typed key-value maps */
  actionTypes: (
    | ApplyForShiftActionType
    | CancelShiftActionType
    | AssignShiftActionType
    | StartCancelledShiftCampaignActionType
  )[];
}

export interface CampaignFilterKeys {
  name?: StringFilter;
  projectId?: StringFilter;
  "project.name"?: StringFilter;
  isActive?: BooleanFilter;
  isArchived?: BooleanFilter;
  currentRound?: IntFilter;
  createdAt?: DateFilter;
  updatedAt?: DateFilter;
}

export interface CampaignSort {
  /** Field to sort by */
  field?: "name" | "createdAt" | "updatedAt" | "currentRound" | "project.name";
  order?: "asc" | "desc";
  /** Sort direction (asc or desc) */
  direction?: "asc" | "desc";
}

export interface CampaignInclude {
  project?: Include;
  organization?: Include;
  invitations?: Include;
  rounds?: Include;
  targetSlots?: Include;
}

export interface CampaignStrategy {
  /** Strategy type (e.g., auto-suggest) */
  type: string;
  /** Interval in hours between rounds */
  intervalHours: number;
  /** Total target slots for the campaign */
  totalTargetSlots?: number;
  /** Total estimated invites for the campaign */
  totalInvites?: number;
}

export interface CampaignFilters {
  /** User function ID filter */
  functionId?: string;
  /** Filter by phone number availability */
  hasPhoneNumber?: boolean;
  /** Minimum age filter */
  ageMin?: number;
  /** Maximum age filter */
  ageMax?: number;
  /** Minimum hourly rate filter */
  hourlyRateMin?: number;
  /** Maximum hourly rate filter */
  hourlyRateMax?: number;
  /** City filter */
  city?: string;
  /** Maximum distance in kilometers */
  maxDistanceKm?: number;
}

export interface CampaignMetadata {
  /** Campaign strategy configuration */
  strategy?: CampaignStrategy;
  /** Message template for campaign invitations */
  messageTemplate?: string;
  /** Employee filtering criteria */
  filters?: CampaignFilters;
}

export interface CampaignProgress {
  /** Total number of slots (sum of capacity) */
  totalSlots: number;
  /** Number of filled slots (accepted applications) */
  filledSlots: number;
  /** Total number of invitations sent */
  totalInvitationsSent: number;
}

export interface CampaignWithProgress {
  /** Unique identifier of the campaign */
  id: string;
  /** Name of the campaign */
  name: string;
  /** Description of the campaign */
  description?: string | null;
  /** Organization ID that owns the campaign */
  organizationId: string;
  /** Active status of the campaign */
  isActive: boolean;
  /** Current round number */
  currentRound: number;
  /**
   * Start date of the campaign
   *
   * @format date-time
   */
  startDate: string;
  /**
   * End date of the campaign
   *
   * @format date-time
   */
  endDate: string;
  /** Campaign metadata including filters, templates, and configuration */
  metadata: CampaignMetadata | null;
  /** Archived status of the campaign */
  isArchived: boolean;
  /**
   * Creation date of the campaign
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the campaign
   *
   * @format date-time
   */
  updatedAt: string;
  /**
   * Message channel for campaign messages
   *
   * @default "BOOMER"
   */
  messageChannel: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  /** Message template ID */
  messageTemplateId: object;
  /**
   * Maximum number of invitations to send throughout the campaign
   *
   * @default 100
   */
  maxInvitations: number;
  /** Campaign progress aggregates for display */
  progress: CampaignProgress;
}

export interface PaginatedCampaign {
  /** Total number of items */
  totalAmount: number;
  /** Array of recruitment campaigns with progress */
  items?: CampaignWithProgress[];
}

export interface CampaignCreateInput {
  /** Name of the recruitment campaign */
  name: string;
  /** Description of the campaign */
  description?: string;
  /** Start date of the campaign */
  startDate: string;
  /** End date of the campaign */
  endDate: string;
  /**
   * Maximum number of invitations to send throughout the campaign
   *
   * @default 100
   */
  maxInvitations?: number;
  /**
   * Message channel for campaign messages (WHATSAPP, BOOMER, etc.)
   *
   * @default "BOOMER"
   */
  messageChannel?: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  /** Project ID for the campaign */
  projectId: string;
  /** Array of AvailabilitySlot IDs to target for recruitment */
  targetSlotIds?: string[];
  /** Whether the campaign is active */
  isActive?: boolean;
  /** Employee filter criteria for campaign */
  filters?: CampaignFilters;
  /** Message template for campaign messages */
  messageTemplate?: string;
}

export interface CampaignRoundMetadata {
  /** Planned size for this round */
  plannedSize?: number;
}

export interface CampaignRound {
  /** Unique identifier of the campaign round */
  id: string;
  /**
   * Creation date of the campaign round
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the campaign round
   *
   * @format date-time
   */
  updatedAt: string;
  /** Campaign ID this round belongs to */
  campaignId: string;
  /** Round number within the campaign */
  roundNumber: number;
  /** Target number of invites for this round */
  targetInvites: number;
  /** Scheduled execution time for this round */
  executionTime: object | null;
  /** Current status of the campaign round */
  status: "PLANNED" | "EXECUTING" | "EXECUTED" | "FAILED";
  /** Redis queue job ID for this round */
  jobId: object | null;
  /** Number of employees contacted in this round */
  employeesContacted: number;
  /** Number of employees who accepted invitations */
  employeesAccepted: number;
  /** Number of employees who declined invitations */
  employeesDeclined: number;
  /** Round metadata including planned size and other configuration */
  metadata: CampaignRoundMetadata | null;
}

export interface CampaignCreateResponse {
  /** Unique identifier of the campaign */
  id: string;
  /** Name of the campaign */
  name: string;
  /** Description of the campaign */
  description?: string | null;
  /** Organization ID that owns the campaign */
  organizationId: string;
  /** Active status of the campaign */
  isActive: boolean;
  /** Current round number */
  currentRound: number;
  /**
   * Start date of the campaign
   *
   * @format date-time
   */
  startDate: string;
  /**
   * End date of the campaign
   *
   * @format date-time
   */
  endDate: string;
  /** Campaign metadata including filters, templates, and configuration */
  metadata: CampaignMetadata | null;
  /** Archived status of the campaign */
  isArchived: boolean;
  /**
   * Creation date of the campaign
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the campaign
   *
   * @format date-time
   */
  updatedAt: string;
  /**
   * Message channel for campaign messages
   *
   * @default "BOOMER"
   */
  messageChannel: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  /** Message template ID */
  messageTemplateId: object;
  /**
   * Maximum number of invitations to send throughout the campaign
   *
   * @default 100
   */
  maxInvitations: number;
  /** Campaign rounds (always included in create response) */
  rounds: CampaignRound[];
  /** Campaign targets (slots/shifts) with nested data (always included in create response) */
  targets: CampaignTarget[];
}

export interface CampaignGetResponse {
  /** Unique identifier of the campaign */
  id: string;
  /** Name of the campaign */
  name: string;
  /** Description of the campaign */
  description?: string | null;
  /** Organization ID that owns the campaign */
  organizationId: string;
  /** Active status of the campaign */
  isActive: boolean;
  /** Current round number */
  currentRound: number;
  /**
   * Start date of the campaign
   *
   * @format date-time
   */
  startDate: string;
  /**
   * End date of the campaign
   *
   * @format date-time
   */
  endDate: string;
  /** Campaign metadata including filters, templates, and configuration */
  metadata: CampaignMetadata | null;
  /** Archived status of the campaign */
  isArchived: boolean;
  /**
   * Creation date of the campaign
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the campaign
   *
   * @format date-time
   */
  updatedAt: string;
  /**
   * Message channel for campaign messages
   *
   * @default "BOOMER"
   */
  messageChannel: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  /** Message template ID */
  messageTemplateId: object;
  /**
   * Maximum number of invitations to send throughout the campaign
   *
   * @default 100
   */
  maxInvitations: number;
  /** Campaign rounds (always included in get response) */
  rounds: CampaignRound[];
  /** Campaign targets (slots/shifts) with nested data (always included in get response) */
  targets: CampaignTarget[];
}

export interface CampaignUpdateInput {
  /** Name of the campaign */
  name?: string;
  /** Description of the campaign */
  description?: string;
  /** Start date of the campaign */
  startDate?: string;
  /** End date of the campaign */
  endDate?: string;
  /** Array of AvailabilitySlot IDs to target for campaign */
  targetSlotIds?: string[];
  /** Whether the campaign is active */
  isActive?: boolean;
  /** Employee filter criteria for campaign */
  filters?: CampaignFilters;
  /** Message template for campaign messages */
  messageTemplate?: string;
  /** Delay in hours between rounds */
  roundDelayHours?: number;
  /** Maximum number of invitations to send throughout the campaign */
  maxInvitations?: number;
  /** Message channel for campaign messages (WHATSAPP, BOOMER, etc.) */
  messageChannel?: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
}

export interface Campaign {
  /** Unique identifier of the campaign */
  id: string;
  /** Name of the campaign */
  name: string;
  /** Description of the campaign */
  description?: string | null;
  /** Organization ID that owns the campaign */
  organizationId: string;
  /** Active status of the campaign */
  isActive: boolean;
  /** Current round number */
  currentRound: number;
  /**
   * Start date of the campaign
   *
   * @format date-time
   */
  startDate: string;
  /**
   * End date of the campaign
   *
   * @format date-time
   */
  endDate: string;
  /** Campaign metadata including filters, templates, and configuration */
  metadata: CampaignMetadata | null;
  /** Archived status of the campaign */
  isArchived: boolean;
  /**
   * Creation date of the campaign
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the campaign
   *
   * @format date-time
   */
  updatedAt: string;
  /**
   * Message channel for campaign messages
   *
   * @default "BOOMER"
   */
  messageChannel: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  /** Message template ID */
  messageTemplateId: object;
  /**
   * Maximum number of invitations to send throughout the campaign
   *
   * @default 100
   */
  maxInvitations: number;
}

export interface CampaignStats {
  /** Campaign ID */
  campaignId: string;
  /** Total number of invitations sent */
  totalInvitationsSent: number;
  /** Current round number */
  currentRound: number;
  /** Total number of rounds (calculated dynamically) */
  totalRounds: number;
  /** Active status of the campaign */
  isActive: boolean;
  /** Date when the last round was sent */
  lastRoundSentAt: object | null;
  /** Total number of target slots */
  totalTargetSlots: number;
  /** Number of filled slots */
  filledSlots: number;
}

export interface CampaignJob {
  /** Job identifier */
  jobId: string;
  /** Round number for this job */
  roundNumber: number;
  /**
   * Scheduled execution date
   *
   * @format date-time
   */
  scheduledFor: string;
  /** Job status */
  status: string;
  /** Number of attempts */
  attempts: number;
}

export interface MessageTemplateFilterKeys {
  name?: StringFilter;
  description?: StringFilter;
  language?: StringFilter;
  status?: StringFilter;
  target?: StringFilter;
  organizationId?: StringFilter;
  createdAt?: DateFilter;
  updatedAt?: DateFilter;
  parentId?: StringFilter;
  isFolder?: BooleanFilter;
  path?: StringFilter;
  depth?: IntFilter;
  category?: StringFilter;
  source?: StringFilter;
}

export interface MessageTemplateSort {
  order?: "asc" | "desc";
  field?: "createdAt" | "updatedAt" | "name" | "language" | "status";
}

export interface MessageTemplateInclude {
  organization?: Include;
  variables?: Include;
  campaigns?: Include;
}

export interface MessageTemplateProviderEntity {
  /** Provider record ID */
  id: string;
  /** Provider type */
  providerType: "TWILIO" | "META_WHATSAPP" | "SENDGRID" | "TELEGRAM_BOT" | "BOOMER";
  /** Provider-specific template ID (Twilio Content SID or Meta template ID) */
  externalTemplateId?: object;
  /** Provider-specific template name (required for Meta WhatsApp sending) */
  externalTemplateName?: object;
  /** Approval status on this provider */
  status: "PENDING" | "SUBMITTED" | "APPROVED" | "REJECTED" | "FAILED";
  /** Error code if submission failed */
  errorCode?: object;
  /** Error message if submission failed */
  errorMessage?: object;
  /**
   * Record creation timestamp
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Record last update timestamp
   *
   * @format date-time
   */
  updatedAt: string;
}

export interface MessageTemplateEntity {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  description?: object;
  /** Parent folder ID */
  parentId?: object;
  /** Whether this is a folder (true) or template (false) */
  isFolder: boolean;
  /** Materialized path (e.g., "shift/invite/tomorrow") */
  path?: object;
  /** Pre-computed parent path */
  parentPath?: object;
  /** Depth level (0 = root folders) */
  depth: number;
  /** Base category for hierarchical organization */
  category: "SHIFT" | "AVAILABILITY_SLOT" | "INVITATION" | "GENERAL" | "UNCATEGORIZED";
  /** Sort order within folder */
  sortOrder: number;
  /** Template source tracking */
  source: "CREATED_LOCALLY" | "IMPORTED_PROVIDER" | "IMPORTED_LEGACY";
  /** External provider original name (for imported templates) */
  externalName?: object;
  /** Provider-specific template ID (e.g., Twilio Content SID) */
  templateId?: object;
  /** Auto-generated unique name for WhatsApp/provider submission */
  providerName?: object;
  /** Template body text (null for folders) */
  templateText?: object;
  language: string;
  status: string;
  templateCategory?: object;
  /** Target type for the template (SHIFT, AVAILABILITY_SLOT, INVITATION, GENERAL) */
  target: "SHIFT" | "AVAILABILITY_SLOT" | "INVITATION" | "GENERAL";
  templateButtons?: object;
  organizationId: string;
  /** Provider-specific records for this template */
  providers?: MessageTemplateProviderEntity[];
}

export interface PaginatedMessageTemplate {
  items: MessageTemplateEntity[];
  count: number;
}

export interface MessageTemplateSearchResult {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  name: string;
  description?: object;
  /** Parent folder ID */
  parentId?: object;
  /** Whether this is a folder (true) or template (false) */
  isFolder: boolean;
  /** Materialized path (e.g., "shift/invite/tomorrow") */
  path?: object;
  /** Pre-computed parent path */
  parentPath?: object;
  /** Depth level (0 = root folders) */
  depth: number;
  /** Base category for hierarchical organization */
  category: "SHIFT" | "AVAILABILITY_SLOT" | "INVITATION" | "GENERAL" | "UNCATEGORIZED";
  /** Sort order within folder */
  sortOrder: number;
  /** Template source tracking */
  source: "CREATED_LOCALLY" | "IMPORTED_PROVIDER" | "IMPORTED_LEGACY";
  /** External provider original name (for imported templates) */
  externalName?: object;
  /** Provider-specific template ID (e.g., Twilio Content SID) */
  templateId?: object;
  /** Auto-generated unique name for WhatsApp/provider submission */
  providerName?: object;
  /** Template body text (null for folders) */
  templateText?: object;
  language: string;
  status: string;
  templateCategory?: object;
  /** Target type for the template (SHIFT, AVAILABILITY_SLOT, INVITATION, GENERAL) */
  target: "SHIFT" | "AVAILABILITY_SLOT" | "INVITATION" | "GENERAL";
  templateButtons?: object;
  organizationId: string;
  /** Provider-specific records for this template */
  providers?: MessageTemplateProviderEntity[];
  /**
   * Similarity score (0.0 to 1.0) - higher is more similar
   *
   * @example
   *   0.85;
   */
  score: number;
}

export interface MessageTemplateSearchResponse {
  items: MessageTemplateSearchResult[];
  /** Total number of results found */
  count: number;
  /** The search query used */
  query: string;
}

export interface TemplateButtonInput {
  /** Button type */
  type: "QUICK_REPLY" | "URL" | "PHONE_NUMBER";
  /** Button text (max 25 characters for WhatsApp) */
  text: string;
  /**
   * URL mode for URL button type: FIXED for static URLs provided by user, DYNAMIC_PROJECT for
   * system-generated project deeplinks using {{projectId}}
   *
   * @default "FIXED"
   */
  urlMode?: "FIXED" | "DYNAMIC_PROJECT";
  /**
   * URL for URL button type. Required when urlMode is FIXED, ignored when urlMode is
   * DYNAMIC_PROJECT
   */
  url?: string;
  /** Phone number for PHONE_NUMBER button type */
  phoneNumber?: string;
}

export interface CreateTemplateInput {
  /**
   * User-friendly display name for the template
   *
   * @example
   *   Shift Invitation
   */
  name: string;
  /**
   * Optional description of the template
   *
   * @example
   *   Template for inviting employees to new shifts
   */
  description?: string;
  /**
   * Template body text with variables like {{1}}, {{2}} for positional or {{name}} for named
   *
   * @example
   *   Hi {{1}}, you have been invited to a new shift on {{2}}.
   */
  templateText: string;
  /**
   * Template language code (e.g., "en", "nl", "en_US")
   *
   * @example
   *   nl;
   *
   * @default "nl"
   */
  language: string;
  /**
   * Path to the folder where the template should be placed (e.g., "onboarding", "shift/invite"). If
   * not provided, template is created at root level.
   *
   * @example
   *   onboarding;
   */
  path?: string;
  /**
   * Internal category for organizing and filtering templates. Independent of folder structure.
   *
   * @example
   *   GENERAL;
   *
   * @default "GENERAL"
   */
  category?: "SHIFT" | "AVAILABILITY_SLOT" | "INVITATION" | "GENERAL" | "UNCATEGORIZED";
  /**
   * Template category for WhatsApp approval. Defaults to MARKETING if not provided.
   *
   * @example
   *   MARKETING;
   *
   * @default "MARKETING"
   */
  templateCategory?: "UTILITY" | "MARKETING" | "AUTHENTICATION";
  /**
   * Target type for the template
   *
   * @default "GENERAL"
   */
  target?: "SHIFT" | "AVAILABILITY_SLOT" | "INVITATION" | "GENERAL";
  /** Array of button configurations (max 3 buttons for WhatsApp) */
  templateButtons?: TemplateButtonInput[];
  /**
   * Example values for template variables (required by WhatsApp for approval). Keys should be
   * variable indices (1, 2, 3) or names.
   *
   * @example
   *   { "1": "John", "2": "Monday, December 4th" }
   */
  exampleVariables?: object;
  /**
   * Target message channel for this template. When specified, the template is only created for
   * providers that support this channel. If not specified, the template is created for all
   * configured WhatsApp providers. Use BOOMER for internal chat templates that do not require
   * external provider approval.
   *
   * @example
   *   WHATSAPP;
   */
  channel?: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
}

export interface TemplateStructureVariableEntity {
  /**
   * Variable name as used in template (e.g., "shiftDate")
   *
   * @example
   *   shiftDate;
   */
  name: string;
  /**
   * Human-readable name for display
   *
   * @example
   *   Shift Date
   */
  friendlyName: string;
  /**
   * Which data table this variable comes from
   *
   * @example
   *   SHIFT;
   */
  table: "USER" | "ORGANIZATION" | "EMPLOYEE" | "SHIFT" | "PROJECT" | "CAMPAIGN";
  /**
   * Whether this variable is always available (USER, ORGANIZATION, EMPLOYEE)
   *
   * @example
   *   false;
   */
  isAlwaysAvailable: boolean;
}

export interface TemplateStructureButtonEntity {
  /**
   * Button type
   *
   * @example
   *   URL;
   */
  type: "QUICK_REPLY" | "URL" | "PHONE_NUMBER";
  /**
   * Button display text
   *
   * @example
   *   View Project
   */
  text: string;
}

export interface TemplateProviderStatusEntity {
  /** Type of provider (TWILIO, META_WHATSAPP, BOOMER) */
  providerType: "TWILIO" | "META_WHATSAPP" | "SENDGRID" | "TELEGRAM_BOT" | "BOOMER";
  /** Approval status for this provider */
  status: "PENDING" | "SUBMITTED" | "APPROVED" | "REJECTED" | "FAILED";
  /** Error message if status is FAILED or REJECTED */
  errorMessage?: object | null;
}

export interface TemplateStructureItemEntity {
  /** Unique identifier */
  id: string;
  /** Display name */
  name: string;
  /** Materialized path (e.g., "shift/invite/tomorrow") */
  path?: object | null;
  /** Parent folder ID */
  parentId?: object | null;
  /** Whether this is a folder (true) or template (false) */
  isFolder: boolean;
  /** Depth level (0 = root folders) */
  depth: number;
  /** Base category for hierarchical organization */
  category: "SHIFT" | "AVAILABILITY_SLOT" | "INVITATION" | "GENERAL" | "UNCATEGORIZED";
  /** Sort order within folder */
  sortOrder: number;
  /** Template/folder description */
  description?: object | null;
  /** First 200 chars of templateText (null for folders) */
  previewText?: object | null;
  /**
   * Entity types that require user selection before sending (null for folders or templates with no
   * context needs)
   *
   * @example
   *   {undefined}
   *   "SHIFT";
   */
  requiredEntities?: ("SHIFT" | "PROJECT" | "AVAILABILITY_SLOT")[] | null;
  /** Whether this template has variables requiring context (null for folders) */
  hasContextVariables?: object | null;
  /** Variables found in the template with their context info (null for folders) */
  variables?: TemplateStructureVariableEntity[] | null;
  /** Minimal button info for preview rendering (null for folders or templates without buttons) */
  buttons?: TemplateStructureButtonEntity[] | null;
  /** Computed overall status (null for folders). APPROVED only if all providers are APPROVED. */
  status?: "CREATED" | "APPROVED" | "REJECTED" | null;
  /** Provider-specific statuses (null for folders). Shows approval status per provider. */
  providerStatuses?: TemplateProviderStatusEntity[] | null;
  /**
   * Last update timestamp
   *
   * @format date-time
   */
  updatedAt: string;
}

export interface TemplateStructureIndexesEntity {
  /** Map of item ID to item object */
  byId: Record<string, TemplateStructureItemEntity>;
  /** Map of parent ID to array of child IDs */
  byParentId: Record<string, string[]>;
  /** Map of path to item ID */
  byPath: Record<string, string>;
}

export interface TemplateStructureMetadataEntity {
  /** Total number of items in the structure */
  totalItems: number;
  /** ISO timestamp of when the structure was built */
  updatedAt: string;
}

export interface TemplateStructureResponseEntity {
  /** Flat list of all templates and folders */
  items: TemplateStructureItemEntity[];
  /** Pre-computed indexes for instant filtering */
  indexes: TemplateStructureIndexesEntity;
  /** Metadata about the structure */
  metadata: TemplateStructureMetadataEntity;
}

export interface RequiredEntityDto {
  /**
   * The type of entity that needs to be selected
   *
   * @example
   *   SHIFT;
   */
  entityType: "SHIFT" | "PROJECT" | "AVAILABILITY_SLOT";
  /**
   * Human-readable explanation of why this entity is required
   *
   * @example
   *   Template uses shift variables: shiftDate, shiftStartTime
   */
  reason: string;
  /**
   * If this entity can be auto-resolved from another entity selection
   *
   * @example
   *   SHIFT;
   */
  dependsOn?: "SHIFT" | "PROJECT" | "AVAILABILITY_SLOT";
  /**
   * True if this entity will be auto-resolved from another selection
   *
   * @example
   *   false;
   */
  isAutoResolved: boolean;
  /**
   * List of variable names that require this entity
   *
   * @example
   *   {undefined}
   *   "shiftDate", "shiftStartTime", "shiftEndTime";
   */
  relatedVariables: string[];
}

export interface TemplateVariableDto {
  /**
   * Variable name as used in template (e.g., "shiftDate")
   *
   * @example
   *   shiftDate;
   */
  name: string;
  /**
   * Human-readable name for UI display
   *
   * @example
   *   Shift Date
   */
  friendlyName: string;
  /**
   * Which data table this variable references
   *
   * @example
   *   SHIFT;
   */
  table: "USER" | "ORGANIZATION" | "EMPLOYEE" | "SHIFT" | "PROJECT" | "CAMPAIGN";
  /**
   * True if this variable is always available (USER, ORGANIZATION, EMPLOYEE)
   *
   * @example
   *   false;
   */
  isAlwaysAvailable: boolean;
}

export interface TemplateWarningDto {
  /**
   * The variable name this warning relates to
   *
   * @example
   *   campaignName;
   */
  variable: string;
  /**
   * Human-readable warning message
   *
   * @example
   *   This template uses campaign variables which are not available when sending from a conversation.
   */
  message: string;
  /**
   * Severity level of the warning
   *
   * @example
   *   error;
   */
  severity: "info" | "warning" | "error";
}

export interface AnalyzeContextResultDto {
  /**
   * Template ID that was analyzed
   *
   * @example
   *   123e4567-e89b-12d3-a456-426614174000
   */
  templateId: string;
  /**
   * Template display name
   *
   * @example
   *   Shift Invitation
   */
  templateName: string;
  /** Entities the user must manually select (not auto-resolved) */
  requiredEntities: RequiredEntityDto[];
  /** Entities that will be auto-resolved from other selections */
  autoResolvedEntities: RequiredEntityDto[];
  /**
   * True if the template can be sent without any entity selection
   *
   * @example
   *   true;
   */
  canSendWithoutContext: boolean;
  /** All variables found in the template */
  variables: TemplateVariableDto[];
  /** Warnings about potential issues */
  warnings: TemplateWarningDto[];
  /**
   * True if the template is valid for sending from a conversation
   *
   * @example
   *   true;
   */
  isValid: boolean;
}

export interface CreateFolderInput {
  /**
   * Folder name (unique within same parent folder)
   *
   * @example
   *   Morning Templates
   */
  name: string;
  /** Parent folder ID. If not provided, creates folder at root level. */
  parentId?: string;
  /**
   * Optional description of the folder
   *
   * @example
   *   Templates for morning shift communications
   */
  description?: string;
  /**
   * Sort order within parent folder (lower = higher priority)
   *
   * @default 0
   */
  sortOrder?: number;
  /**
   * Optional category for the folder. Defaults to GENERAL if not provided. Category is independent
   * of folder location.
   *
   * @example
   *   GENERAL;
   *
   * @default "GENERAL"
   */
  category?: "SHIFT" | "AVAILABILITY_SLOT" | "INVITATION" | "GENERAL" | "UNCATEGORIZED";
}

export interface UpdateTemplateInput {
  /**
   * New name for the template or folder
   *
   * @example
   *   Updated Template Name
   */
  name?: string;
  /**
   * New description
   *
   * @example
   *   Updated description for the template
   */
  description?: string;
  /** Sort order within parent folder (lower = higher priority) */
  sortOrder?: number;
}

export interface MoveTemplateInput {
  /** Target folder ID. Use null to move to base category root (only for folders) */
  parentId?: object | null;
  /** Sort order within target folder (lower = higher priority) */
  sortOrder?: number;
}

export interface ValidateTemplateVariablesInput {
  /**
   * Template body text with variables like {{employeeName}}, {{shiftDate}}
   *
   * @example
   *   Hi {{employeeName}}, your shift on {{shiftDate}} starts at {{shiftStartTime}}.
   */
  templateText: string;
  /** Array of button configurations to check for URL variables */
  templateButtons?: TemplateButtonInput[];
}

export interface VariableInfo {
  /**
   * Variable name as it appears in the template
   *
   * @example
   *   shiftDate;
   */
  name: string;
  /**
   * Whether the variable exists in the organization
   *
   * @example
   *   true;
   */
  found: boolean;
  /**
   * The data table this variable references (if found)
   *
   * @example
   *   SHIFT;
   */
  table?: "USER" | "ORGANIZATION" | "EMPLOYEE" | "SHIFT" | "PROJECT" | "CAMPAIGN";
  /**
   * Whether this variable is always available (ORGANIZATION, USER, EMPLOYEE)
   *
   * @example
   *   false;
   */
  isAlwaysAvailable: boolean;
  /**
   * Human-friendly name for UI display
   *
   * @example
   *   Shift Date
   */
  friendlyName?: string;
}

export interface VariableWarning {
  /**
   * Variable name that has a warning
   *
   * @example
   *   shiftDate;
   */
  variable: string;
  /**
   * Warning message for the user
   *
   * @example
   *   This variable requires a shift to be associated when sending the message.
   */
  message: string;
  /**
   * Severity level of the warning
   *
   * @example
   *   warning;
   */
  severity: "info" | "warning" | "error";
}

export interface ValidateTemplateVariablesResult {
  /** Information about each variable found in the template */
  variables: VariableInfo[];
  /**
   * Data tables required at send time for this template to work correctly
   *
   * @example
   *   {undefined}
   *   "SHIFT", "PROJECT";
   */
  requiredContext: ("USER" | "ORGANIZATION" | "EMPLOYEE" | "SHIFT" | "PROJECT" | "CAMPAIGN")[];
  /** Warnings about variables that require specific context */
  warnings: VariableWarning[];
  /**
   * Whether all variables were found and are valid
   *
   * @example
   *   true;
   */
  isValid: boolean;
}

export interface FeatureFlagsResponse {
  /**
   * Whether WhatsApp integration is enabled
   *
   * @example
   *   true;
   */
  whatsappEnabled: boolean;
  /**
   * Whether AI features are enabled
   *
   * @example
   *   true;
   */
  aiEnabled: boolean;
  /**
   * Whether the communication module is enabled
   *
   * @example
   *   false;
   */
  communicationEnabled: boolean;
  /**
   * Whether the autoplanner is enabled
   *
   * @example
   *   false;
   */
  autoplannerEnabled: boolean;
  /**
   * Whether campaigns are enabled
   *
   * @example
   *   true;
   */
  campaignEnabled: boolean;
  /**
   * Whether group chats are enabled
   *
   * @example
   *   true;
   */
  groupChatsEnabled: boolean;
  /**
   * Whether broadcast chats are enabled
   *
   * @example
   *   false;
   */
  broadCastEnabled: boolean;
  /**
   * Whether employees can create chats
   *
   * @example
   *   true;
   */
  allowEmployeeChats: boolean;
  /**
   * Whether messages from strangers can be received
   *
   * @example
   *   false;
   */
  allowStrangerMessages: boolean;
  /**
   * List of available message channels configured for this organization
   *
   * @example
   *   {undefined}
   *   "WHATSAPP", "SMS";
   */
  availableChannels: string[];
}

export interface UpdateFeatureFlagsDto {
  /**
   * Whether WhatsApp integration is enabled
   *
   * @example
   *   true;
   */
  whatsappEnabled?: boolean;
  /**
   * Whether AI features are enabled
   *
   * @example
   *   true;
   */
  aiEnabled?: boolean;
  /**
   * Whether the communication module is enabled
   *
   * @example
   *   false;
   */
  communicationEnabled?: boolean;
  /**
   * Whether the autoplanner is enabled
   *
   * @example
   *   false;
   */
  autoplannerEnabled?: boolean;
  /**
   * Whether campaigns are enabled
   *
   * @example
   *   true;
   */
  campaignEnabled?: boolean;
  /**
   * Whether group chats are enabled
   *
   * @example
   *   true;
   */
  groupChatsEnabled?: boolean;
  /**
   * Whether broadcast chats are enabled
   *
   * @example
   *   false;
   */
  broadCastEnabled?: boolean;
  /**
   * Whether employees can create chats
   *
   * @example
   *   true;
   */
  allowEmployeeChats?: boolean;
  /**
   * Whether messages from strangers can be received
   *
   * @example
   *   false;
   */
  allowStrangerMessages?: boolean;
}

export interface MessageChannelEnumFilter {
  operator?: "equals" | "in" | "notIn" | "not" | null;
  value?: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER" | null;
  values?: ("WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER")[] | null;
}

export interface MessageStatusEnumFilter {
  operator?: "equals" | "in" | "notIn" | "not" | null;
  value?: "PENDING" | "SENT" | "DELIVERED" | "READ" | "FAILED" | null;
  values?: ("PENDING" | "SENT" | "DELIVERED" | "READ" | "FAILED")[] | null;
}

export interface MessageStatusManyFilter {
  operator?: "some" | "every" | "none";
  value?: MessageStatusEnumFilter;
}

export interface MessageDirectionEnumFilter {
  operator?: "equals" | "in" | "notIn" | "not" | null;
  value?: "INBOUND" | "OUTBOUND" | null;
  values?: ("INBOUND" | "OUTBOUND")[] | null;
}

export interface MessageDirectionManyFilter {
  operator?: "some" | "every" | "none";
  value?: MessageDirectionEnumFilter;
}

export interface EntityTagSourceTypeEnumFilter {
  operator?: "equals" | "in" | "notIn" | "not" | null;
  value?: "CONVERSATION" | "SUGGESTED_ACTION" | "PROJECT" | null;
  values?: ("CONVERSATION" | "SUGGESTED_ACTION" | "PROJECT")[] | null;
}

export interface EntityTagSourceTypeManyFilter {
  operator?: "some" | "every" | "none";
  value?: EntityTagSourceTypeEnumFilter;
}

export interface EntityTagTargetTypeEnumFilter {
  operator?: "equals" | "in" | "notIn" | "not" | null;
  value?: "PROJECT" | "SHIFT" | "ADMIN_USER" | "CONVERSATION_LABEL" | "CAMPAIGN" | null;
  values?: ("PROJECT" | "SHIFT" | "ADMIN_USER" | "CONVERSATION_LABEL" | "CAMPAIGN")[] | null;
}

export interface EntityTagTargetTypeManyFilter {
  operator?: "some" | "every" | "none";
  value?: EntityTagTargetTypeEnumFilter;
}

export interface ConversationFilterKeys {
  id?: StringFilter;
  channel?: MessageChannelEnumFilter;
  lastMessageAt?: DateFilter;
  createdAt?: DateFilter;
  updatedAt?: DateFilter;
  isArchived?: BooleanFilter;
  organizationId?: StringFilter;
  "participants.messageContact.displayName"?: StringFilter;
  "participants.messageContact.phoneNumber"?: StringFilter;
  "participants.messageContact.email"?: StringFilter;
  "messages.body"?: StringFilter;
  "messages.status"?: MessageStatusManyFilter;
  "messages.direction"?: MessageDirectionManyFilter;
  "entityTags.sourceType"?: EntityTagSourceTypeManyFilter;
  "entityTags.targetType"?: EntityTagTargetTypeManyFilter;
}

export interface ConversationSort {
  field?: "lastMessageAt" | "createdAt" | "updatedAt" | "participants.unreadCount";
  order?: "asc" | "desc";
}

export interface ConversationInclude {
  participants?: Include;
  messages?: Include;
  suggestedActions?: Include;
  entityTags?: Include;
  windows?: Include;
}

export interface ConversationAggregateKeys {
  unreadMessages?: Aggregate;
}

export interface ConversationParticipantWithContact {
  id: string;
  /** @format date-time */
  createdAt: string;
  conversationId: string;
  messageContactId: string;
  role?: object;
  /** @format date-time */
  joinedAt: string;
  lastReadAt?: object;
  unreadCount: number;
  /** Whether this participant is active in the conversation */
  isActive: boolean;
  /** Whether this participant can receive messages */
  canReceive: boolean;
  /** Per-participant conversation title (what this participant sees) */
  displayTitle?: object;
  /** Per-participant conversation avatar (what this participant sees) */
  displayAvatar?: object;
  phoneNumber?: object;
  displayName: string;
  avatarUrl?: object;
  participantType?: object;
  side?: object;
  userId?: object;
}

export interface MessageSender {
  id: string;
  displayName?: object;
  /** Used by frontend to calculate message direction */
  side?: "ORGANIZATION" | "CONTACT" | null;
}

export interface MessageSummary {
  id: string;
  body?: object;
  /** @format date-time */
  createdAt: string;
  status: string;
  senderId: string;
  sender?: MessageSender;
  media?: any[];
}

export interface ConversationAssignedAdminUser {
  id: string;
  name: string;
  image: object;
}

export interface WindowEndpoint {
  id: string;
  /** Endpoint identifier (e.g., phone number) */
  identifier: string;
  /** Friendly display name */
  displayName?: object;
}

export interface ConversationWindowWithTimeRemaining {
  id: string;
  /** @format date-time */
  createdAt: string;
  conversationId: string;
  channel: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  /** The endpoint that opened this window */
  endpointId: string;
  endpoint?: WindowEndpoint;
  /**
   * When the window was opened (inbound message timestamp)
   *
   * @format date-time
   */
  openedAt: string;
  /**
   * When the window was manually closed (null = auto-expires at openedAt + 24h)
   *
   * @format date-time
   */
  closedAt?: string | null;
  /** Whether the window is currently open (calculated) */
  isOpen: boolean;
  /** Seconds remaining until the window closes (0 if closed) */
  timeRemainingSeconds: number;
}

export interface ConversationWithPreview {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  isArchived: boolean;
  type?: "DIRECT" | "GROUP" | "BROADCAST" | "DISTRIBUTION";
  title?: object;
  lastMessageAt?: object;
  lastMessagePreview?: object;
  organizationId: string;
  participants?: ConversationParticipantWithContact[];
  /** Messages in the conversation (slim format in ConversationWithPreview) */
  messages?: MessageSummary[];
  agentWorking?: boolean;
  suggestedActions?: any[];
  suggestedMessage?: object;
  /** Unread message count for the requesting user */
  unreadCount: number;
  assignedAdminUser?: ConversationAssignedAdminUser;
  entityTags?: any[];
  /**
   * The conversation title for the requesting user (convenience field from their participant
   * record)
   */
  displayTitle?: object;
  /**
   * The conversation avatar for the requesting user (convenience field from their participant
   * record)
   */
  displayAvatar?: object;
  /** Most recent service windows (up to 5) for timeline display */
  windows?: ConversationWindowWithTimeRemaining[];
  /** Whether free-form messages can be sent (true if any service window is open for WhatsApp) */
  canSendFreeform?: boolean;
}

export interface PaginatedConversation {
  items: ConversationWithPreview[];
  count: number;
}

export interface ConversationCreateInput {
  type?: "DIRECT" | "GROUP" | "BROADCAST" | "DISTRIBUTION";
  title?: string;
  /** Message contact IDs to add as participants */
  participantIds: string[];
  /** Entity target type (PROJECT or CAMPAIGN) for linking conversation */
  entityTargetType?: "PROJECT" | "SHIFT" | "ADMIN_USER" | "CONVERSATION_LABEL" | "CAMPAIGN";
  /** ID of the project or campaign to link to this conversation */
  entityTargetId?: string;
  /**
   * Whether to add all managers as participants. If false, only the requesting user is added.
   * Defaults to true.
   *
   * @default true
   */
  includeAllManagers?: boolean;
}

export interface ProjectBroadcastCreateInput {
  /** ID of the project to create a broadcast conversation for */
  projectId: string;
  /** Optional custom title for the broadcast conversation. Defaults to "Broadcast: {projectName}" */
  title?: string;
}

export interface ConversationUpdateInput {
  isArchived?: boolean;
}

export interface SendSuggestedMessageInput {
  /**
   * The message text to send (may be edited from the suggested message)
   *
   * @example
   *   Hallo! Ik werk voor De Helpende Hand...
   */
  message: string;
  /**
   * The channel to send the message through (WHATSAPP or BOOMER)
   *
   * @example
   *   BOOMER;
   */
  channel: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
}

export interface MessageFilterKeys {
  id?: StringFilter;
  conversationId?: StringFilter;
  body?: StringFilter;
  status?: MessageStatusEnumFilter;
  direction?: MessageDirectionEnumFilter;
  channel?: MessageChannelEnumFilter;
  createdAt?: DateFilter;
  updatedAt?: DateFilter;
  sentAt?: DateFilter;
  deliveredAt?: DateFilter;
  readAt?: DateFilter;
  senderId?: StringFilter;
  "sender.messageContact.displayName"?: StringFilter;
  "sender.messageContact.phoneNumber"?: StringFilter;
  "sender.messageContact.email"?: StringFilter;
  "sender.messageContact.userId"?: StringFilter;
  "conversation.channel"?: StringFilter;
  media?: ExistFilter;
  "recipients.participant.messageContact.userId"?: StringFilter;
}

export interface MessageSort {
  field?: "createdAt" | "updatedAt" | "sentAt" | "status" | "sender.displayName";
  order?: "asc" | "desc";
}

export interface MessageInclude {
  sender?: Include;
  conversation?: Include;
  media?: Include;
  recipients?: Include;
}

export interface MessageWithSender {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  body?: object;
  status: "PENDING" | "SENT" | "DELIVERED" | "READ" | "FAILED";
  channel: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  conversationId: string;
  senderId: string;
  templateType?: object;
  /** Template structure including buttons, headers, etc. */
  templateComponents?: object;
  errorCode?: object;
  errorMessage?: object;
  sentAt?: object;
  deliveredAt?: object;
  readAt?: object;
  failedAt?: object;
  sender?: object;
  conversation?: object;
  media?: any[];
  recipients?: any[];
  isRead?: boolean;
}

export interface PaginatedMessage {
  items: MessageWithSender[];
  count: number;
}

export interface MessageCreateInput {
  conversationId: string;
  body?: string;
  /**
   * Message template ID to send as WhatsApp template message. When provided, the template will be
   * resolved and sent instead of a regular message. Only supported for DIRECT conversations.
   */
  messageTemplateId?: string;
  /**
   * Shift ID to use for resolving shift variables (shiftDate, shiftStartTime, etc.). Also
   * auto-resolves project variables from the shift. Only used with messageTemplateId.
   */
  shiftId?: string;
  /**
   * Project ID to use for resolving project variables. Only needed if template uses project
   * variables without shift variables. If shiftId is provided, project is auto-resolved from the
   * shift. Only used with messageTemplateId.
   */
  projectId?: string;
  /**
   * Availability slot ID to use for resolving availability slot variables. Only used with
   * messageTemplateId.
   */
  availabilitySlotId?: string;
  /**
   * Manual text values for template variables. Keys are variable names (e.g., "shiftDate"), values
   * are the text to use. These override any auto-resolved values. When provided for all variables
   * of an entity type, skips entity selection requirement. Variable names must be alphanumeric with
   * underscores, values are sanitized for security.
   *
   * @example
   *   { "shiftDate": "tomorrow", "shiftStartTime": "09:00", "projectName": "Special Event" }
   */
  variableOverrides?: object;
  channel: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  /** @default "OUTBOUND" */
  direction: "INBOUND" | "OUTBOUND";
  metadata?: object;
  /** Media URLs to attach (if supported by channel) */
  mediaUrls?: string[];
  /**
   * Target user IDs for DISTRIBUTION conversations. Only these users will receive the message in
   * their DIRECT conversations.
   */
  targetUserIds?: string[];
}

export interface MessageUpdateInput {
  status?: "PENDING" | "SENT" | "DELIVERED" | "READ" | "FAILED";
}

export interface MarkReadInput {
  messageIds: string[];
}

export interface PermissionResponse {
  /**
   * List of all available permissions
   *
   * @example
   *   {undefined}
   *   "PROJECT.CREATE", "EMPLOYEE.READ";
   */
  permissions: (
    | "ORGANIZATION.READ"
    | "ORGANIZATION.UPDATE"
    | "ORGANIZATION.CREATE"
    | "ORGANIZATION.ARCHIVE"
    | "ORGANIZATION.UNARCHIVE"
    | "ORGANIZATION.IMPORT"
    | "ORGANIZATION.EXPORT"
    | "ORGANIZATION.DELETE"
    | "PROJECT.CREATE"
    | "PROJECT.READ"
    | "PROJECT.UPDATE"
    | "PROJECT.DELETE"
    | "PROJECT.ARCHIVE"
    | "PROJECT.UNARCHIVE"
    | "PROJECT.IMPORT"
    | "PROJECT.EXPORT"
    | "AVAILABILITY_SLOT.CREATE"
    | "AVAILABILITY_SLOT.READ"
    | "AVAILABILITY_SLOT.UPDATE"
    | "AVAILABILITY_SLOT.DELETE"
    | "SHIFT.CREATE"
    | "SHIFT.READ"
    | "SHIFT.UPDATE"
    | "SHIFT.DELETE"
    | "SHIFT_DECLARATION.CREATE"
    | "SHIFT_DECLARATION.READ"
    | "SHIFT_DECLARATION.UPDATE"
    | "SHIFT_DECLARATION.DELETE"
    | "POSITION.CREATE"
    | "POSITION.READ"
    | "POSITION.UPDATE"
    | "POSITION.DELETE"
    | "APPLICATION.CREATE"
    | "APPLICATION.READ"
    | "APPLICATION.UPDATE"
    | "APPLICATION.DELETE"
    | "EMPLOYEE.CREATE"
    | "EMPLOYEE.READ"
    | "EMPLOYEE.UPDATE"
    | "EMPLOYEE.DELETE"
    | "EMPLOYEE.ARCHIVE"
    | "EMPLOYEE.UNARCHIVE"
    | "EMPLOYEE.IMPORT"
    | "EMPLOYEE.EXPORT"
    | "ADMIN_OWNER.CREATE"
    | "ADMIN_OWNER.READ"
    | "ADMIN_OWNER.UPDATE"
    | "ADMIN_OWNER.DELETE"
    | "ADMIN_OWNER.ARCHIVE"
    | "ADMIN_OWNER.UNARCHIVE"
    | "ADMIN_OWNER.IMPORT"
    | "ADMIN_OWNER.EXPORT"
    | "ADMIN_MANAGER.CREATE"
    | "ADMIN_MANAGER.READ"
    | "ADMIN_MANAGER.UPDATE"
    | "ADMIN_MANAGER.DELETE"
    | "ADMIN_MANAGER.ARCHIVE"
    | "ADMIN_MANAGER.UNARCHIVE"
    | "ADMIN_MANAGER.IMPORT"
    | "ADMIN_MANAGER.EXPORT"
    | "RELATION_OWNER.CREATE"
    | "RELATION_OWNER.READ"
    | "RELATION_OWNER.UPDATE"
    | "RELATION_OWNER.DELETE"
    | "RELATION_OWNER.ARCHIVE"
    | "RELATION_OWNER.UNARCHIVE"
    | "RELATION_OWNER.IMPORT"
    | "RELATION_OWNER.EXPORT"
    | "RELATION_MANAGER.CREATE"
    | "RELATION_MANAGER.READ"
    | "RELATION_MANAGER.UPDATE"
    | "RELATION_MANAGER.DELETE"
    | "RELATION_MANAGER.ARCHIVE"
    | "RELATION_MANAGER.UNARCHIVE"
    | "RELATION_MANAGER.IMPORT"
    | "RELATION_MANAGER.EXPORT"
    | "TEAM.CREATE"
    | "TEAM.READ"
    | "TEAM.UPDATE"
    | "TEAM.DELETE"
    | "TEAM.ARCHIVE"
    | "TEAM.UNARCHIVE"
    | "TEAM.IMPORT"
    | "TEAM.EXPORT"
    | "USER_FUNCTION.CREATE"
    | "USER_FUNCTION.READ"
    | "USER_FUNCTION.UPDATE"
    | "USER_FUNCTION.DELETE"
    | "USER_FUNCTION.ARCHIVE"
    | "USER_FUNCTION.UNARCHIVE"
    | "USER_FUNCTION.IMPORT"
    | "USER_FUNCTION.EXPORT"
    | "RELATION.CREATE"
    | "RELATION.READ"
    | "RELATION.UPDATE"
    | "RELATION.DELETE"
    | "RELATION.ARCHIVE"
    | "RELATION.UNARCHIVE"
    | "RELATION.IMPORT"
    | "RELATION.EXPORT"
    | "REPORT.ORGANIZATION.READ"
    | "REPORT.RELATION.READ"
    | "REPORT.PROJECT.READ"
    | "REPORT.EMPLOYEE.READ"
    | "REPORT.HOURS.READ"
    | "RATE.READ"
    | "RATE.UPDATE"
    | "RATE.DELETE"
    | "RATE.CREATE"
    | "INVOICE.PROJECT.READ"
    | "INVOICE.PROJECT.UPDATE"
    | "INVOICE.PROJECT.DELETE"
    | "INVOICE.PROJECT.CREATE"
    | "INVOICE.PROJECT.EXPORT"
    | "INVOICE.PROJECT.IMPORT"
    | "INVOICE.PROJECT.ARCHIVE"
    | "INVOICE.FREELANCER.READ"
    | "INVOICE.FREELANCER.UPDATE"
    | "INVOICE.FREELANCER.DELETE"
    | "INVOICE.FREELANCER.CREATE"
    | "INVOICE.FREELANCER.EXPORT"
    | "INVOICE.FREELANCER.IMPORT"
    | "INVOICE.FREELANCER.ARCHIVE"
    | "INVOICE.SUBSCRIPTION.READ"
    | "INVOICE.SUBSCRIPTION.UPDATE"
    | "INVOICE.SUBSCRIPTION.DELETE"
    | "INVOICE.SUBSCRIPTION.CREATE"
    | "INVOICE.SUBSCRIPTION.EXPORT"
    | "INVOICE.SUBSCRIPTION.IMPORT"
    | "INVOICE.SUBSCRIPTION.ARCHIVE"
    | "NOTIFICATION.SEND"
    | "RECRUITMENT_CAMPAIGN.CREATE"
    | "RECRUITMENT_CAMPAIGN.READ"
    | "RECRUITMENT_CAMPAIGN.UPDATE"
    | "RECRUITMENT_CAMPAIGN.DELETE"
    | "RECRUITMENT_CAMPAIGN.SEND"
    | "MESSAGE.READ"
    | "MESSAGE.CREATE"
    | "MESSAGE.UPDATE"
    | "MESSAGE.DELETE"
    | "MESSAGE.MARK_AS_READ"
    | "CONVERSATION.READ"
    | "CONVERSATION.CREATE"
    | "CONVERSATION.UPDATE"
    | "CONVERSATION.DELETE"
    | "ENTITY_TAG.READ"
    | "ENTITY_TAG.CREATE"
    | "ENTITY_TAG.UPDATE"
    | "ENTITY_TAG.DELETE"
    | "INTEGRATION_PROVIDER.CREATE"
    | "INTEGRATION_PROVIDER.READ"
    | "INTEGRATION_PROVIDER.UPDATE"
    | "INTEGRATION_PROVIDER.DELETE"
  )[];
}

export interface PermissionItem {
  /**
   * The name of the permission
   *
   * @example
   *   PROJECT.CREATE;
   */
  name:
    | "ORGANIZATION.READ"
    | "ORGANIZATION.UPDATE"
    | "ORGANIZATION.CREATE"
    | "ORGANIZATION.ARCHIVE"
    | "ORGANIZATION.UNARCHIVE"
    | "ORGANIZATION.IMPORT"
    | "ORGANIZATION.EXPORT"
    | "ORGANIZATION.DELETE"
    | "PROJECT.CREATE"
    | "PROJECT.READ"
    | "PROJECT.UPDATE"
    | "PROJECT.DELETE"
    | "PROJECT.ARCHIVE"
    | "PROJECT.UNARCHIVE"
    | "PROJECT.IMPORT"
    | "PROJECT.EXPORT"
    | "AVAILABILITY_SLOT.CREATE"
    | "AVAILABILITY_SLOT.READ"
    | "AVAILABILITY_SLOT.UPDATE"
    | "AVAILABILITY_SLOT.DELETE"
    | "SHIFT.CREATE"
    | "SHIFT.READ"
    | "SHIFT.UPDATE"
    | "SHIFT.DELETE"
    | "SHIFT_DECLARATION.CREATE"
    | "SHIFT_DECLARATION.READ"
    | "SHIFT_DECLARATION.UPDATE"
    | "SHIFT_DECLARATION.DELETE"
    | "POSITION.CREATE"
    | "POSITION.READ"
    | "POSITION.UPDATE"
    | "POSITION.DELETE"
    | "APPLICATION.CREATE"
    | "APPLICATION.READ"
    | "APPLICATION.UPDATE"
    | "APPLICATION.DELETE"
    | "EMPLOYEE.CREATE"
    | "EMPLOYEE.READ"
    | "EMPLOYEE.UPDATE"
    | "EMPLOYEE.DELETE"
    | "EMPLOYEE.ARCHIVE"
    | "EMPLOYEE.UNARCHIVE"
    | "EMPLOYEE.IMPORT"
    | "EMPLOYEE.EXPORT"
    | "ADMIN_OWNER.CREATE"
    | "ADMIN_OWNER.READ"
    | "ADMIN_OWNER.UPDATE"
    | "ADMIN_OWNER.DELETE"
    | "ADMIN_OWNER.ARCHIVE"
    | "ADMIN_OWNER.UNARCHIVE"
    | "ADMIN_OWNER.IMPORT"
    | "ADMIN_OWNER.EXPORT"
    | "ADMIN_MANAGER.CREATE"
    | "ADMIN_MANAGER.READ"
    | "ADMIN_MANAGER.UPDATE"
    | "ADMIN_MANAGER.DELETE"
    | "ADMIN_MANAGER.ARCHIVE"
    | "ADMIN_MANAGER.UNARCHIVE"
    | "ADMIN_MANAGER.IMPORT"
    | "ADMIN_MANAGER.EXPORT"
    | "RELATION_OWNER.CREATE"
    | "RELATION_OWNER.READ"
    | "RELATION_OWNER.UPDATE"
    | "RELATION_OWNER.DELETE"
    | "RELATION_OWNER.ARCHIVE"
    | "RELATION_OWNER.UNARCHIVE"
    | "RELATION_OWNER.IMPORT"
    | "RELATION_OWNER.EXPORT"
    | "RELATION_MANAGER.CREATE"
    | "RELATION_MANAGER.READ"
    | "RELATION_MANAGER.UPDATE"
    | "RELATION_MANAGER.DELETE"
    | "RELATION_MANAGER.ARCHIVE"
    | "RELATION_MANAGER.UNARCHIVE"
    | "RELATION_MANAGER.IMPORT"
    | "RELATION_MANAGER.EXPORT"
    | "TEAM.CREATE"
    | "TEAM.READ"
    | "TEAM.UPDATE"
    | "TEAM.DELETE"
    | "TEAM.ARCHIVE"
    | "TEAM.UNARCHIVE"
    | "TEAM.IMPORT"
    | "TEAM.EXPORT"
    | "USER_FUNCTION.CREATE"
    | "USER_FUNCTION.READ"
    | "USER_FUNCTION.UPDATE"
    | "USER_FUNCTION.DELETE"
    | "USER_FUNCTION.ARCHIVE"
    | "USER_FUNCTION.UNARCHIVE"
    | "USER_FUNCTION.IMPORT"
    | "USER_FUNCTION.EXPORT"
    | "RELATION.CREATE"
    | "RELATION.READ"
    | "RELATION.UPDATE"
    | "RELATION.DELETE"
    | "RELATION.ARCHIVE"
    | "RELATION.UNARCHIVE"
    | "RELATION.IMPORT"
    | "RELATION.EXPORT"
    | "REPORT.ORGANIZATION.READ"
    | "REPORT.RELATION.READ"
    | "REPORT.PROJECT.READ"
    | "REPORT.EMPLOYEE.READ"
    | "REPORT.HOURS.READ"
    | "RATE.READ"
    | "RATE.UPDATE"
    | "RATE.DELETE"
    | "RATE.CREATE"
    | "INVOICE.PROJECT.READ"
    | "INVOICE.PROJECT.UPDATE"
    | "INVOICE.PROJECT.DELETE"
    | "INVOICE.PROJECT.CREATE"
    | "INVOICE.PROJECT.EXPORT"
    | "INVOICE.PROJECT.IMPORT"
    | "INVOICE.PROJECT.ARCHIVE"
    | "INVOICE.FREELANCER.READ"
    | "INVOICE.FREELANCER.UPDATE"
    | "INVOICE.FREELANCER.DELETE"
    | "INVOICE.FREELANCER.CREATE"
    | "INVOICE.FREELANCER.EXPORT"
    | "INVOICE.FREELANCER.IMPORT"
    | "INVOICE.FREELANCER.ARCHIVE"
    | "INVOICE.SUBSCRIPTION.READ"
    | "INVOICE.SUBSCRIPTION.UPDATE"
    | "INVOICE.SUBSCRIPTION.DELETE"
    | "INVOICE.SUBSCRIPTION.CREATE"
    | "INVOICE.SUBSCRIPTION.EXPORT"
    | "INVOICE.SUBSCRIPTION.IMPORT"
    | "INVOICE.SUBSCRIPTION.ARCHIVE"
    | "NOTIFICATION.SEND"
    | "RECRUITMENT_CAMPAIGN.CREATE"
    | "RECRUITMENT_CAMPAIGN.READ"
    | "RECRUITMENT_CAMPAIGN.UPDATE"
    | "RECRUITMENT_CAMPAIGN.DELETE"
    | "RECRUITMENT_CAMPAIGN.SEND"
    | "MESSAGE.READ"
    | "MESSAGE.CREATE"
    | "MESSAGE.UPDATE"
    | "MESSAGE.DELETE"
    | "MESSAGE.MARK_AS_READ"
    | "CONVERSATION.READ"
    | "CONVERSATION.CREATE"
    | "CONVERSATION.UPDATE"
    | "CONVERSATION.DELETE"
    | "ENTITY_TAG.READ"
    | "ENTITY_TAG.CREATE"
    | "ENTITY_TAG.UPDATE"
    | "ENTITY_TAG.DELETE"
    | "INTEGRATION_PROVIDER.CREATE"
    | "INTEGRATION_PROVIDER.READ"
    | "INTEGRATION_PROVIDER.UPDATE"
    | "INTEGRATION_PROVIDER.DELETE";
  /**
   * The value of the permission (true to grant, false to revoke)
   *
   * @example
   *   true;
   */
  value: boolean;
}

export interface UpdateUserPermissionInput {
  /**
   * The permissions to update
   *
   * @example
   *   {undefined}
   *   {"name":"PROJECT.CREATE","value":true},{"name":"PROJECT.READ","value":false}
   */
  permissions: PermissionItem[];
}

export interface ErrorCodesResponseDto {
  /** All available error codes */
  errorCodes: (
    | "APPLICATION_CAPACITY_EXCEEDED"
    | "SLOT_CAPACITY_FULL"
    | "APPLICATION_NO_OPEN_SHIFTS"
    | "APPLICATION_ALREADY_EXISTS"
    | "APPLICATION_NOT_FOUND"
    | "APPLICATION_CANNOT_CREATE"
    | "SLOT_CAPACITY_REDUCTION_BLOCKED"
    | "SLOT_NOT_FOUND"
    | "SLOT_CANNOT_CREATE"
    | "SLOT_DIFFERENT_ORGANIZATION"
    | "PROJECT_NOT_FOUND"
    | "PROJECT_CANNOT_CREATE"
    | "FORBIDDEN"
    | "UNAUTHORIZED"
    | "VALIDATION_ERROR"
    | "INTERNAL_ERROR"
    | "SHIFT_NO_OPEN_SHIFTS"
    | "WHATSAPP_WINDOW_CLOSED"
    | "WHATSAPP_WINDOW_EXPIRED"
  )[];
}

export interface InvitationTypeEnumFilter {
  operator?: "equals" | "in" | "notIn" | "not" | null;
  value?:
    | "ADMIN_OWNER"
    | "ADMIN_MANAGER"
    | "RELATION_OWNER"
    | "RELATION_MANAGER"
    | "EMPLOYEE"
    | null;
  values?:
    | ("ADMIN_OWNER" | "ADMIN_MANAGER" | "RELATION_OWNER" | "RELATION_MANAGER" | "EMPLOYEE")[]
    | null;
}

export interface InvitationFilterKeys {
  email?: StringFilter;
  name?: StringFilter;
  invitationType?: InvitationTypeEnumFilter;
  "relation.id"?: StringFilter;
}

export interface InvitationSort {
  field?:
    | "id"
    | "firstname"
    | "lastname"
    | "createdAt"
    | "updatedAt"
    | "email"
    | "status"
    | "expiresAt"
    | "invitationType"
    | "inviterId";
  order?: "asc" | "desc";
}

export interface Invitation {
  /** Unique identifier of the invitation */
  id: string;
  /**
   * Creation date of the invitation
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the invitation
   *
   * @format date-time
   */
  updatedAt: string;
  /** Invitation token */
  token: string;
  /** Email of the invited user */
  email: string;
  /** Name of the invited user */
  name: string;
  /** First name of the invited user */
  firstname: string;
  /** Last name of the invited user */
  lastname: string;
  /** Role of the invited user */
  role?: object | null;
  /** Type of the invitation */
  invitationType:
    | "ADMIN_OWNER"
    | "ADMIN_MANAGER"
    | "RELATION_OWNER"
    | "RELATION_MANAGER"
    | "EMPLOYEE";
  /** Link to accept the invitation */
  invitationLink: string;
  /**
   * Expiration date of the invitation
   *
   * @format date-time
   */
  expiresAt: string;
}

export interface PaginatedInvitation {
  /** Total number of items */
  totalAmount: number;
  items?: Invitation[];
}

export interface InvitationInput {
  email: string;
  firstname: string;
  lastname: string;
  invitationType:
    | "ADMIN_OWNER"
    | "ADMIN_MANAGER"
    | "RELATION_OWNER"
    | "RELATION_MANAGER"
    | "EMPLOYEE";
  frontendUrl: string;
  sendEmail: boolean;
  permissions: (
    | "ORGANIZATION.READ"
    | "ORGANIZATION.UPDATE"
    | "ORGANIZATION.CREATE"
    | "ORGANIZATION.ARCHIVE"
    | "ORGANIZATION.UNARCHIVE"
    | "ORGANIZATION.IMPORT"
    | "ORGANIZATION.EXPORT"
    | "ORGANIZATION.DELETE"
    | "PROJECT.CREATE"
    | "PROJECT.READ"
    | "PROJECT.UPDATE"
    | "PROJECT.DELETE"
    | "PROJECT.ARCHIVE"
    | "PROJECT.UNARCHIVE"
    | "PROJECT.IMPORT"
    | "PROJECT.EXPORT"
    | "AVAILABILITY_SLOT.CREATE"
    | "AVAILABILITY_SLOT.READ"
    | "AVAILABILITY_SLOT.UPDATE"
    | "AVAILABILITY_SLOT.DELETE"
    | "SHIFT.CREATE"
    | "SHIFT.READ"
    | "SHIFT.UPDATE"
    | "SHIFT.DELETE"
    | "SHIFT_DECLARATION.CREATE"
    | "SHIFT_DECLARATION.READ"
    | "SHIFT_DECLARATION.UPDATE"
    | "SHIFT_DECLARATION.DELETE"
    | "POSITION.CREATE"
    | "POSITION.READ"
    | "POSITION.UPDATE"
    | "POSITION.DELETE"
    | "APPLICATION.CREATE"
    | "APPLICATION.READ"
    | "APPLICATION.UPDATE"
    | "APPLICATION.DELETE"
    | "EMPLOYEE.CREATE"
    | "EMPLOYEE.READ"
    | "EMPLOYEE.UPDATE"
    | "EMPLOYEE.DELETE"
    | "EMPLOYEE.ARCHIVE"
    | "EMPLOYEE.UNARCHIVE"
    | "EMPLOYEE.IMPORT"
    | "EMPLOYEE.EXPORT"
    | "ADMIN_OWNER.CREATE"
    | "ADMIN_OWNER.READ"
    | "ADMIN_OWNER.UPDATE"
    | "ADMIN_OWNER.DELETE"
    | "ADMIN_OWNER.ARCHIVE"
    | "ADMIN_OWNER.UNARCHIVE"
    | "ADMIN_OWNER.IMPORT"
    | "ADMIN_OWNER.EXPORT"
    | "ADMIN_MANAGER.CREATE"
    | "ADMIN_MANAGER.READ"
    | "ADMIN_MANAGER.UPDATE"
    | "ADMIN_MANAGER.DELETE"
    | "ADMIN_MANAGER.ARCHIVE"
    | "ADMIN_MANAGER.UNARCHIVE"
    | "ADMIN_MANAGER.IMPORT"
    | "ADMIN_MANAGER.EXPORT"
    | "RELATION_OWNER.CREATE"
    | "RELATION_OWNER.READ"
    | "RELATION_OWNER.UPDATE"
    | "RELATION_OWNER.DELETE"
    | "RELATION_OWNER.ARCHIVE"
    | "RELATION_OWNER.UNARCHIVE"
    | "RELATION_OWNER.IMPORT"
    | "RELATION_OWNER.EXPORT"
    | "RELATION_MANAGER.CREATE"
    | "RELATION_MANAGER.READ"
    | "RELATION_MANAGER.UPDATE"
    | "RELATION_MANAGER.DELETE"
    | "RELATION_MANAGER.ARCHIVE"
    | "RELATION_MANAGER.UNARCHIVE"
    | "RELATION_MANAGER.IMPORT"
    | "RELATION_MANAGER.EXPORT"
    | "TEAM.CREATE"
    | "TEAM.READ"
    | "TEAM.UPDATE"
    | "TEAM.DELETE"
    | "TEAM.ARCHIVE"
    | "TEAM.UNARCHIVE"
    | "TEAM.IMPORT"
    | "TEAM.EXPORT"
    | "USER_FUNCTION.CREATE"
    | "USER_FUNCTION.READ"
    | "USER_FUNCTION.UPDATE"
    | "USER_FUNCTION.DELETE"
    | "USER_FUNCTION.ARCHIVE"
    | "USER_FUNCTION.UNARCHIVE"
    | "USER_FUNCTION.IMPORT"
    | "USER_FUNCTION.EXPORT"
    | "RELATION.CREATE"
    | "RELATION.READ"
    | "RELATION.UPDATE"
    | "RELATION.DELETE"
    | "RELATION.ARCHIVE"
    | "RELATION.UNARCHIVE"
    | "RELATION.IMPORT"
    | "RELATION.EXPORT"
    | "REPORT.ORGANIZATION.READ"
    | "REPORT.RELATION.READ"
    | "REPORT.PROJECT.READ"
    | "REPORT.EMPLOYEE.READ"
    | "REPORT.HOURS.READ"
    | "RATE.READ"
    | "RATE.UPDATE"
    | "RATE.DELETE"
    | "RATE.CREATE"
    | "INVOICE.PROJECT.READ"
    | "INVOICE.PROJECT.UPDATE"
    | "INVOICE.PROJECT.DELETE"
    | "INVOICE.PROJECT.CREATE"
    | "INVOICE.PROJECT.EXPORT"
    | "INVOICE.PROJECT.IMPORT"
    | "INVOICE.PROJECT.ARCHIVE"
    | "INVOICE.FREELANCER.READ"
    | "INVOICE.FREELANCER.UPDATE"
    | "INVOICE.FREELANCER.DELETE"
    | "INVOICE.FREELANCER.CREATE"
    | "INVOICE.FREELANCER.EXPORT"
    | "INVOICE.FREELANCER.IMPORT"
    | "INVOICE.FREELANCER.ARCHIVE"
    | "INVOICE.SUBSCRIPTION.READ"
    | "INVOICE.SUBSCRIPTION.UPDATE"
    | "INVOICE.SUBSCRIPTION.DELETE"
    | "INVOICE.SUBSCRIPTION.CREATE"
    | "INVOICE.SUBSCRIPTION.EXPORT"
    | "INVOICE.SUBSCRIPTION.IMPORT"
    | "INVOICE.SUBSCRIPTION.ARCHIVE"
    | "NOTIFICATION.SEND"
    | "RECRUITMENT_CAMPAIGN.CREATE"
    | "RECRUITMENT_CAMPAIGN.READ"
    | "RECRUITMENT_CAMPAIGN.UPDATE"
    | "RECRUITMENT_CAMPAIGN.DELETE"
    | "RECRUITMENT_CAMPAIGN.SEND"
    | "MESSAGE.READ"
    | "MESSAGE.CREATE"
    | "MESSAGE.UPDATE"
    | "MESSAGE.DELETE"
    | "MESSAGE.MARK_AS_READ"
    | "CONVERSATION.READ"
    | "CONVERSATION.CREATE"
    | "CONVERSATION.UPDATE"
    | "CONVERSATION.DELETE"
    | "ENTITY_TAG.READ"
    | "ENTITY_TAG.CREATE"
    | "ENTITY_TAG.UPDATE"
    | "ENTITY_TAG.DELETE"
    | "INTEGRATION_PROVIDER.CREATE"
    | "INTEGRATION_PROVIDER.READ"
    | "INTEGRATION_PROVIDER.UPDATE"
    | "INTEGRATION_PROVIDER.DELETE"
  )[];
  /**
   * The relationId for the invitation. Only valid for ADMIN_MANAGER and ADMIN_OWNER roles. For
   * RELATION_OWNER or RELATION_MANAGER, it will always be connected to their own relationId. It can
   * be left undefined, and the backend will insert the appropriate relationId based on the
   * inviter's role and permissions.
   */
  relationId: string | null;
}

export interface EmployeeWithDefaultAccountInput {
  /**
   * The email address of the employee
   *
   * @example
   *   john.doe@example.com
   */
  email: string;
  /**
   * The first name of the employee
   *
   * @example
   *   John;
   */
  firstname: string;
  /**
   * The last name of the employee
   *
   * @example
   *   Doe;
   */
  lastname: string;
  /**
   * The address line of the employee
   *
   * @example
   *   123 Main St
   */
  addressLine?: string;
  /**
   * The city of the employee
   *
   * @example
   *   New York
   */
  city?: string;
  /**
   * The state of the employee
   *
   * @example
   *   NY;
   */
  state?: string;
  /**
   * The zip code of the employee
   *
   * @example
   *   10001;
   */
  zipCode?: string;
  /**
   * The country code of the employee
   *
   * @example
   *   US;
   */
  countryCode?: string;
  /**
   * The phone number of the employee
   *
   * @example
   *   +1234567890;
   */
  phone?: string;
  /**
   * The date of birth of the employee
   *
   * @example
   *   1990-01-01
   */
  dayOfBirth?: string;
  /**
   * The relation ID of the employee
   *
   * @example
   *   123;
   */
  relationId?: string;
}

export type InvitationManyInput = object;

export interface ThemeConfig {
  /** Unique identifier of the theme */
  id: string;
  /** Configuration of the theme */
  config: object;
}

export interface AppConfig {
  customUrlScheme: string;
  appId: string;
}

export interface Organization {
  /** Address line of the entity */
  addressLine?: string | null;
  /** City of the entity */
  city?: string | null;
  /** State of the entity */
  state?: string | null;
  /** Zip code of the entity */
  zipCode?: string | null;
  /** Country code of the entity */
  countryCode?: string | null;
  /** Unique identifier of the organization */
  id: number;
  /** Name of the organization */
  name: string;
  /**
   * Creation date of the organization
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Update date of the organization
   *
   * @format date-time
   */
  updatedAt: string;
  /** Email of the organization */
  email: string;
  /** Phone of the organization */
  phone: string;
  /** Invoice email of the organization */
  invoiceEmail: string;
  /** Slug of the organization */
  slug: string;
  /** KVK of the organization */
  kvk: string;
  /** BTW of the organization */
  btw: string;
  /** Bank of the organization */
  bank: string;
  /** Default sales rate of the organization */
  defaultSalesRate: Rate;
  organizationProcurementRates: OrganizationProcurementRate[];
  appConfig: AppConfig;
  /** Employee accounts enabled of the organization */
  employeeAccountsEnabled: boolean;
  /** Revoke period of applications */
  revokePeriod: number;
  /** Organization context for LLM agents */
  context?: string | null;
}

export interface OrganizationUpdateInput {
  /** Address line of the entity */
  addressLine?: string | null;
  /** City of the entity */
  city?: string | null;
  /** State of the entity */
  state?: string | null;
  /** Zip code of the entity */
  zipCode?: string | null;
  /** Country code of the entity */
  countryCode?: string | null;
  /** Email of the entity */
  email?: string | null;
  /** Phone of the entity */
  phone?: string | null;
  /** Invoice email of the entity */
  invoiceEmail?: string | null;
  /** KVK of the entity */
  kvk?: string | null;
  /** BTW of the entity */
  btw?: string | null;
  /** Bank of the entity */
  bank?: string | null;
  /** Organization context for LLM agents */
  context?: string | null;
}

export interface OrganizationCreateInput {
  name: string;
  startUrl: string;
  adminUrl: string;
  slug: string;
}

export interface EmployeeBase {
  /** Address line of the entity */
  addressLine?: string | null;
  /** City of the entity */
  city?: string | null;
  /** State of the entity */
  state?: string | null;
  /** Zip code of the entity */
  zipCode?: string | null;
  /** Country code of the entity */
  countryCode?: string | null;
  /** Unique identifier of the employee */
  id?: string;
  /**
   * Creation date of the app user
   *
   * @format date-time
   */
  createdAt?: string | null;
  /**
   * Last update date of the app user
   *
   * @format date-time
   */
  updatedAt?: string | null;
  /**
   * Day of birth of the app user
   *
   * @format date-time
   */
  dayOfBirth?: string | null;
  /** Phone number of the app user */
  phone?: string | null;
  /** Note for the app user */
  note?: string | null;
  /** Phone country of the app user */
  phoneCountry?: string | null;
  /** Archive status of the employee in this organization */
  isArchived?: boolean | null;
  /** Functions */
  functions: UserFunction[];
  /** Teams of the employee */
  teams: Team[];
}

export interface AdminUserBase {
  /** Unique identifier of the admin user */
  id: string;
  /**
   * Creation date of the admin user
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the admin user
   *
   * @format date-time
   */
  updatedAt: string;
  /** Role of the admin user */
  role: "OWNER" | "MANAGER";
  /** Archive status of the admin user in this organization */
  isArchived: boolean;
}

export interface RelationUserBase {
  /** Unique identifier of the admin user */
  id: string;
  /**
   * Creation date of the admin user
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the admin user
   *
   * @format date-time
   */
  updatedAt: string;
  /** Role of the admin user */
  role: "OWNER" | "MANAGER";
  /** Relation of the admin user */
  relationId: string;
  /** Archive status of the relation user in this organization */
  isArchived: boolean;
}

export interface SuperAdminBase {
  /** Unique identifier of the admin user */
  id: string;
  /**
   * Creation date of the admin user
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the admin user
   *
   * @format date-time
   */
  updatedAt: string;
  /** Archived status of the example */
  isArchived: boolean;
}

export interface Me {
  id: string;
  name: string;
  firstname: string;
  lastname: string;
  email: string;
  organization?: {
    id?: string;
    name?: string;
    /** @format date-time */
    createdAt?: string;
    slug?: string;
  };
  organizationId: object;
  activeOrganizationId?: object;
  permissions: string[];
  organizations: {
    isArchived?: boolean;
    organizationId?: string;
  }[];
  isArchived: boolean;
  employee: EmployeeBase;
  adminUser: AdminUserBase;
  relationUser: RelationUserBase;
  superAdmin: SuperAdminBase;
  image?: string;
}

export interface UpdateMeInput {
  firstname?: string;
  lastname?: string;
  name?: string;
  email?: string;
  phone?: string;
  addressLine?: string;
  city?: string;
  state?: string;
  zipCode?: string;
}

export interface AdminUserRoleEnumFilter {
  operator?: "equals" | "in" | "notIn" | "not" | null;
  value?: "OWNER" | "MANAGER" | null;
  values?: ("OWNER" | "MANAGER")[] | null;
}

export interface AdminUserFilterKeys {
  id?: StringFilter;
  createdAt?: DateFilter;
  updatedAt?: DateFilter;
  role?: AdminUserRoleEnumFilter;
  isArchived?: BooleanFilter;
  "user.name"?: StringFilter;
  "user.email"?: StringFilter;
}

export interface AdminUserSort {
  field?: "id" | "createdAt" | "updatedAt" | "role";
  order?: "asc" | "desc";
}

export interface AdminUser {
  /** Unique identifier of the admin user */
  id: string;
  /**
   * Creation date of the admin user
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the admin user
   *
   * @format date-time
   */
  updatedAt: string;
  /** Role of the admin user */
  role: "OWNER" | "MANAGER";
  /** Archive status of the admin user in this organization */
  isArchived: boolean;
  user: UserBase;
}

export interface PaginatedAdminUser {
  /** Total number of items */
  totalAmount: number;
  items?: AdminUser[];
}

export interface UpdateOneInputUserInput {
  update: UserInput;
}

export interface AdminUserUpdateInput {
  role?: "OWNER" | "MANAGER";
  user: UpdateOneInputUserInput;
}

export interface RelationUserRoleEnumFilter {
  operator?: "equals" | "in" | "notIn" | "not" | null;
  value?: "OWNER" | "MANAGER" | null;
  values?: ("OWNER" | "MANAGER")[] | null;
}

export interface RelationUserFilterKeys {
  id?: StringFilter;
  createdAt?: DateFilter;
  updatedAt?: DateFilter;
  role?: RelationUserRoleEnumFilter;
  isArchived?: BooleanFilter;
  "user.name"?: StringFilter;
  "user.email"?: StringFilter;
  "relation.id"?: StringFilter;
}

export interface RelationUserSort {
  field?: "id" | "createdAt" | "updatedAt" | "role";
  order?: "asc" | "desc";
}

export interface RelationUser {
  /** Unique identifier of the admin user */
  id: string;
  /**
   * Creation date of the admin user
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Last update date of the admin user
   *
   * @format date-time
   */
  updatedAt: string;
  /** Role of the admin user */
  role: "OWNER" | "MANAGER";
  /** Relation of the admin user */
  relationId: string;
  /** Archive status of the relation user in this organization */
  isArchived: boolean;
  user: UserBase;
}

export interface PaginatedRelationUser {
  /** Total number of items */
  totalAmount: number;
  items?: RelationUser[];
}

export interface RelationUserUpdateInput {
  role?: "OWNER" | "MANAGER";
  user: UpdateOneInputUserInput;
}

export interface EmployeeRate {
  /** Unique identifier of the rate */
  id: string;
  hourlyRate: number;
}

export interface FreelanceEmployee {
  id: string;
  addressLine: string;
  city: string;
  state: string;
  zipCode: string;
  countryCode: string;
  kvk: string;
  btw: string;
  bank: string;
  employee: EmployeeBase;
  procurementRate: EmployeeRate;
}

export interface FreelanceEmployeeInput {
  addressLine: string;
  city: string;
  state: string;
  zipCode: string;
  countryCode: string;
  kvk: string;
  btw: string;
  bank: string;
  rateAmount: number;
}

export interface UserOrganization {
  /** Note for the user in this organization */
  note: string;
}

export interface UserOrganizationUpdateInput {
  /** Note for the user in this organization */
  note: string;
}

export interface UserFunctionFilterKeys {
  name?: StringFilter;
  isArchived?: BooleanFilter;
  "members.id"?: StringManyFilter;
}

export interface UserFunctionSort {
  field?: "id" | "name" | "createdAt" | "updatedAt";
  order?: "asc" | "desc";
}

export interface PaginatedUserFunction {
  /** Total number of items */
  totalAmount: number;
  items?: UserFunction[];
}

export interface UserFunctionCreateInput {
  name: string;
}

export interface UserFunctionUpdateInput {
  name: string;
}

export interface RelationFilterKeys {
  name?: StringFilter;
  email?: StringFilter;
  phone?: StringFilter;
  isArchived?: BooleanFilter;
}

export interface RelationSort {
  field?: "id" | "name" | "email" | "phone" | "createdAt" | "updatedAt";
  order?: "asc" | "desc";
}

export interface PaginatedRelation {
  /** Total number of items */
  totalAmount: number;
  items?: Relation[];
}

export interface RelationCreateInput {
  name: string;
  email: string;
  phone: string;
  /** @format binary */
  image?: File;
}

export interface RelationUpdateInput {
  /** Address line of the entity */
  addressLine?: string | null;
  /** City of the entity */
  city?: string | null;
  /** State of the entity */
  state?: string | null;
  /** Zip code of the entity */
  zipCode?: string | null;
  /** Country code of the entity */
  countryCode?: string | null;
  name: string;
  /** Email of the entity */
  email?: string | null;
  phone: string;
  /** Invoice email of the entity */
  invoiceEmail?: string | null;
  /** KVK of the entity */
  kvk?: string | null;
  /** BTW of the entity */
  btw?: string | null;
  /** Bank of the entity */
  bank?: string | null;
  /** @format binary */
  image?: File;
}

export interface Contact {
  /** Unique identifier of the contact */
  id: string;
  /** Name of the contact */
  name: string;
  /** Email of the contact */
  email: string;
}

export interface ContactCreateUpdateInput {
  /** Name of the contact */
  name: string;
  /** Email of the contact */
  email: string;
}

export interface CustomFieldValue {
  text?: string | null;
  number?: number | null;
  /** @format date-time */
  date?: string | null;
  select?: string | null;
  multiSelect?: string[] | null;
  boolean?: boolean | null;
  file?: string | null;
}

export interface ValueOption {
  label: string;
  value: string;
}

export interface CustomFieldDefinition {
  id: string;
  isArchived: boolean;
  for: "PROJECT" | "RELATION" | "EMPLOYEE";
  name: string;
  description?: string;
  required?: boolean;
  type: "TEXT" | "NUMBER" | "DATE" | "SELECT" | "MULTI_SELECT" | "BOOLEAN" | "FILE";
  defaultValue?: CustomFieldValue;
  options?: ValueOption[];
}

export interface CustomField {
  id: string;
  customFieldId?: string | null;
  customFieldDefinition: CustomFieldDefinition;
  value: CustomFieldValue | null;
}

export interface CustomFieldValueInput {
  text?: string | null;
  number?: number | null;
  /** @format date-time */
  date?: string | null;
  select?: string | null;
  multiSelect?: string[] | null;
  boolean?: boolean | null;
}

export interface CustomFieldValueFileInput {
  /** @format binary */
  file: File;
}

export interface CreateCustomFieldDefinitionInput {
  name: string;
  for: "PROJECT" | "RELATION" | "EMPLOYEE";
  description?: string;
  required?: boolean;
  type: "TEXT" | "NUMBER" | "DATE" | "SELECT" | "MULTI_SELECT" | "BOOLEAN" | "FILE";
  defaultValue?: CustomFieldValue | null;
  options?: ValueOption[];
}

export interface UpdateCustomFieldDefinitionInput {
  name: string;
  description?: string;
  required?: boolean;
  defaultValue?: CustomFieldValue | null;
  options?: ValueOption[];
}

export interface Document {
  /** ID of the document */
  id: string;
  /** Name of the document */
  name: string;
  /**
   * Updated at of the document
   *
   * @format date-time
   */
  updatedAt: string;
  /** Extension of the document */
  extension: string;
  /** Path of the document */
  path: string;
}

export interface PaginatedDocument {
  /** Total number of items */
  totalAmount: number;
  items?: Document[];
}

export interface DocumentCreateInput {
  /** @format binary */
  file?: File;
}

export interface StatusEnumFilter {
  operator?: "equals" | "in" | "notIn" | "not" | null;
  value?: "DRAFT" | "PUBLISHED" | null;
  values?: ("DRAFT" | "PUBLISHED")[] | null;
}

export interface AvailabilitySlotFilterKeys {
  startAt?: DateFilter;
  "userFunction.name"?: StringFilter;
  userFunction?: ExistFilter;
  "project.id"?: StringFilter;
  "position.name"?: StringFilter;
  status?: StatusEnumFilter;
}

export interface AvailabilitySlotSort {
  field?: "id" | "startAt" | "position.name" | "userFunction.name";
  order?: "asc" | "desc";
}

export interface AvailabilitySlotInclude {
  project?: Include;
  userFunction?: Include;
  position?: Include;
  applications?: Include;
  campaignTargets?: Include;
}

export interface AvailabilitySlotAggregateKeys {
  acceptedApplications?: Aggregate;
  campaignInvitations?: Aggregate;
}

export interface PaginatedAvailabilitySlot {
  /** Total number of items */
  totalAmount: number;
  items?: AvailabilitySlot[];
}

export interface AvailabilitySlotBulkCreateInput {
  /** Array of availability slots to create */
  slots: AvailabilitySlotCreateInput[];
}

export interface AvailabilitySlotUpdateInput {
  /** UserFunction ID */
  userFunctionId?: string | null;
  /** Position ID */
  positionId?: string | null;
  projectId?: string;
  startAt?: string;
  endAt?: string;
  date?: string | null;
  capacity?: number;
  /** Status of the slot */
  status?: "DRAFT" | "PUBLISHED";
  allowReserves?: boolean;
}

export interface AvailabilitySlotBulkDeleteInput {
  /**
   * Array of availability slot IDs to delete
   *
   * @example
   *   {undefined}
   *   "uuid-1", "uuid-2", "uuid-3";
   */
  ids: string[];
}

export interface InvoiceLine {
  /** The id of the invoice line */
  id: string;
  /**
   * The created at date of the invoice line
   *
   * @format date-time
   */
  createdAt: string;
  /** The description of the invoice line */
  description: string;
  /**
   * The date of the invoice line
   *
   * @format date-time
   */
  date: string;
  /** The quantity of the invoice line */
  quantity: number;
  /** The unit price of the invoice line */
  unitPrice: number;
  /** The total amount of the invoice line */
  totalAmount: number;
  /** The VAT rate of the invoice line */
  vatRate: number;
  /** The VAT amount of the invoice line */
  vatAmount: number;
  /** The discount amount of the invoice line */
  discountAmount: number;
  /** The discount percentage of the invoice line */
  discountPercentage: number;
  /** The net amount of the invoice line */
  netAmount: number;
  /** The function name */
  functionName: string;
  /** The item type */
  itemType: "HOURS" | "BONUS_HOURS" | "EXPENSE" | "FIXED_FEE" | "OTHER";
  /** Invoice ID */
  invoiceId: string;
}

export interface Invoice {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  type: "SUBSCRIPTION" | "PROJECT" | "FREELANCER";
  invoiceNumber: string;
  kenmerk: string;
  /** @format date-time */
  invoiceDate: string;
  /** @format date-time */
  dueDate: string;
  discountAmount: number;
  discountPercentage: number;
  totalExclVat: number;
  totalVat: number;
  totalInclVat: number;
  currency: string;
  fileName: string;
  status: "GENERATED" | "SENT" | "PAID";
  toName: string;
  toContactPersonName: string;
  toContactEmail: string;
  toAddress: string;
  toZipCode: string;
  toCity: string;
  fromName: string;
  fromPersonName: string;
  fromPersonEmail: string;
  fromAddress: string;
  fromZipCode: string;
  fromCity: string;
  fromKvk: string;
  fromVAT: string;
  fromBank: string;
  invoiceLineItems: InvoiceLine[];
  projectId: string;
  relationId: string;
  employeeId: string;
  userId: string;
  /** Project associated with the invoice */
  project?: Project | null;
  /** Employee associated with the invoice */
  employee?: Employee | null;
  /** Relation associated with the invoice */
  relation?: Relation | null;
}

export interface ProjectBillingItem {
  id: string;
  project: Project;
  relationInvoice: Invoice | null;
  employeeInvoice: Invoice | null;
  /** @format date-time */
  billDate: string;
  relation: Relation | null;
  plannedShifts: number;
  acceptedShifts: number;
  freelanceEmployeeWagePaymentStatus: "UNAVAILABLE" | "PENDING" | "GENERATED" | "SENT" | "PAID";
  totalHoursWorkedIncludingBonus: number;
  confirmedRevenueWithBonus: number;
  potentialRevenue: number;
  totalProcurementCostAmount: number;
  totalExpenseClaimCostAmount: number;
  /** Total amount already invoiced for this project */
  totalInvoicedAmount: number;
  /** @format date-time */
  billExpirationDate: string;
  billFileName: string | null;
}

export interface PaginatedBillingList {
  /** Total number of items */
  totalAmount: number;
  items: ProjectBillingItem[];
}

export interface BillingSummary {
  totalProjects: number;
  totalHours: number;
  confirmedRevenueWithBonus: number;
  totalProcurementRevenue: number;
  totalExpenseClaims: number;
  totalInvoicedRevenue: number;
}

export interface InvoiceFilterKeys {
  id?: StringFilter;
  type?: StringFilter;
  status?: StringFilter;
  invoiceNumber?: StringFilter;
  invoiceDate?: DateFilter;
  dueDate?: DateFilter;
  projectId?: StringFilter;
  relationId?: StringFilter;
  employeeId?: StringFilter;
  toName?: StringFilter;
  totalInclVat?: StringFilter;
  createdAt?: DateFilter;
  updatedAt?: DateFilter;
}

export interface InvoiceSort {
  field?:
    | "id"
    | "createdAt"
    | "updatedAt"
    | "invoiceDate"
    | "dueDate"
    | "invoiceNumber"
    | "totalInclVat"
    | "status"
    | "type"
    | "toName"
    | "toContactPersonName"
    | "toContactEmail"
    | "toAddress"
    | "toZipCode"
    | "toCity"
    | "fromName";
  order?: "asc" | "desc";
}

export interface InvoiceIncludeKeys {
  invoiceLineItems?: boolean;
  project?: boolean;
  relation?: boolean;
  employee?: boolean;
}

export interface PaginatedInvoice {
  data: Invoice[];
  totalCount: number;
}

export interface InvoiceLineInput {
  /** Id */
  id?: string | null;
  /** The quantity of the line item */
  quantity: number;
  /** The description of the line item */
  description: string;
  /** The unit price of the line item */
  unitPrice: number;
  /** The VAT rate of the line item */
  vatRate: number;
  /** The total amount of the line item */
  totalAmount: number;
}

export interface InvoiceInput {
  /** The id of the invoice */
  id?: string;
  /** The reference of the invoice */
  reference?: string;
  type: "SUBSCRIPTION" | "PROJECT" | "FREELANCER";
  /** The invoice number */
  invoiceNumber: string;
  /** The invoice date */
  invoiceDate: string;
  /** The due date */
  dueDate: string;
  /**
   * The discount amount
   *
   * @default 0
   */
  discountAmount?: number;
  /**
   * The discount percentage
   *
   * @default 0
   */
  discountPercentage?: number;
  /** The total excl VAT */
  totalExclVat: number;
  /** The total VAT */
  totalVat: number;
  /** The total incl VAT */
  totalInclVat: number;
  /**
   * The currency
   *
   * @default "EUR"
   */
  currency?: string;
  /** The status of the invoice */
  status?: "GENERATED" | "SENT" | "PAID";
  /** The recipient name */
  toName?: string;
  /** The recipient contact person name */
  toContactPersonName?: string;
  /** The recipient contact email */
  toContactEmail?: string;
  /** The recipient address */
  toAddress?: string;
  /** The recipient zip code */
  toZipCode?: string;
  /** The recipient city */
  toCity?: string;
  /** The sender name */
  fromName?: string;
  /** The sender person name */
  fromPersonName?: string;
  /** The sender person email */
  fromPersonEmail?: string;
  /** The sender address */
  fromAddress?: string;
  /** The sender zip code */
  fromZipCode?: string;
  /** The sender city */
  fromCity?: string;
  /** The sender KVK number */
  fromKvk?: string;
  /** The sender VAT number */
  fromVAT?: string;
  /** The sender bank details */
  fromBank?: string;
  /** The invoice line items */
  invoiceLineItems: InvoiceLineInput[];
}

export interface PreInvoiceTotals {
  totalExclVat: number;
  totalVat: number;
  totalInclVat: number;
  vatRate: number;
  /** @default 0 */
  discountAmount: number;
  /** @default 0 */
  discountPercentage: number;
}

export interface PreInvoiceLine {
  /**
   * The date of the invoice line
   *
   * @format date-time
   */
  date: string;
  /** The user function of the invoice line */
  userFunction: string;
  /** The description of the invoice line */
  description: string;
  /** The hours of the invoice line */
  quantity: number;
  /** The bonus hours of the invoice line */
  bonusHours: number;
  /** The VAT rate of the invoice line */
  vatRate: number;
  /** The unit price of the invoice line */
  unitPrice: number;
  /** The item type of the invoice line */
  itemType: "HOURS" | "BONUS_HOURS" | "EXPENSE" | "FIXED_FEE" | "OTHER";
}

export interface PreInvoiceProject {
  type: "SUBSCRIPTION" | "PROJECT" | "FREELANCER";
  invoiceNumber: string;
  reference?: string;
  /** @format date-time */
  invoiceDate: string;
  /** @format date-time */
  dueDate: string;
  status: "GENERATED" | "SENT" | "PAID";
  /** @default "EUR" */
  currency: string;
  exchangeRate?: number;
  toName?: string;
  toContactPersonName?: string;
  toContactEmail?: string;
  toAddress?: string;
  toZipCode?: string;
  toCity?: string;
  fromName?: string;
  fromPersonName?: string;
  fromPersonEmail?: string;
  fromAddress?: string;
  fromZipCode?: string;
  fromCity?: string;
  fromKvk?: string;
  fromVAT?: string;
  fromBank?: string;
  projectId?: string;
  relationId?: string;
  employeeId?: string;
  totals: PreInvoiceTotals;
  shiftLineItems: PreInvoiceLine[];
  bonusLineItems: PreInvoiceLine[];
  otherLineItems: PreInvoiceLine[];
}

export interface FullEntryUpdateInput {
  /** The ID of the shift to update */
  shiftId: string;
  /** The break time of the shift */
  breakTime: number;
  /** The start time of the shift */
  startAt: string;
  /** The end time of the shift */
  endAt: string;
}

export interface ShiftDeclaration {
  /** Unique identifier of the shift */
  id: string;
  /** Relevant projectId */
  projectId?: string | null;
  /** Relevant employeeId */
  employeeId?: string | null;
  /**
   * Creation date of the shift
   *
   * @format date-time
   */
  createdAt?: string | null;
  /**
   * Last update date of the shift
   *
   * @format date-time
   */
  updatedAt: string;
  /**
   * Start date/time of the shift
   *
   * @format date-time
   */
  startAt: string;
  /**
   * End date/time of the shift
   *
   * @format date-time
   */
  endAt: string;
  /** Time zone of the project */
  timeZone?: string | null;
  /** Note of the shift */
  note?: string | null;
  /** Changelog of the shift */
  changelog?: string | null;
  /** Relevant UserFunction */
  userFunction?: UserFunction | null;
  /** Relevant Position */
  position?: Position | null;
  /** Relevant Employee */
  employee?: Employee | null;
  /** Relevant project */
  project?: Project | null;
  /** Shift time entry of the shift declaration */
  shiftTimeEntry?: ShiftTimeEntry | null;
  /** Whether the employee can clock in for this shift */
  canClockIn: boolean;
  /** Whether the employee can clock out for this shift */
  canClockOut: boolean;
  /** Whether the employee can enter break time for this shift */
  canEnterBreakTime: boolean;
  /** Status message indicating current state and available actions */
  statusMessage: string;
}

export interface PaginatedShiftDeclaration {
  /** Total number of items */
  totalAmount: number;
  items?: ShiftDeclaration[];
  /** Time zone of the project */
  timeZone: string;
  isProjectFinalized: boolean;
}

export interface ShiftDeclarationFilterKeys {
  startAt?: DateFilter;
  endAt?: DateFilter;
  "employee.user.name"?: StringFilter;
}

export interface ShiftDeclarationSort {
  field?:
    | "id"
    | "startAt"
    | "endAt"
    | "employee.user.name"
    | "userFunction.name"
    | "position.name"
    | "shiftTimeEntry.startAt"
    | "shiftTimeEntry.endAt"
    | "shiftTimeEntry.status";
  order?: "asc" | "desc";
}

export interface ShiftTimeEntryUpdateInput {
  type: "START_AT" | "END_AT";
  time: string;
}

export interface BreakTimeUpdateInput {
  minutes: number;
}

export interface StatusUpdateInput {
  status: string;
}

export interface RatingUpdateInput {
  /**
   * @min 1
   * @max 5
   */
  rating: number;
}

export interface BonusUpdateInput {
  /** @min 0 */
  bonus: number;
}

export interface QRClockInInput {
  /** The ID of the project */
  projectId: string;
  /** The ID of the shift to clock in to */
  shiftId: string;
  /** The QR code data scanned by the employee */
  qrCodeData: string;
}

export interface QRClockOutInput {
  /** The ID of the project */
  projectId: string;
  /** The ID of the shift to clock out from */
  shiftId: string;
  /** The QR code data scanned by the employee */
  qrCodeData: string;
}

export interface ClockBreakTimeInput {
  /** The ID of the shift */
  shiftId: string;
  /**
   * Break time in minutes
   *
   * @min 0
   */
  breakTimeMinutes: number;
}

export interface ValidatedTimeEntry {
  email: string;
  /** @format date-time */
  date: string;
  /** @format date-time */
  startAt: string;
  /** @format date-time */
  endAt: string;
  breakTimeMinutes: number;
  bonus: number;
  /** Expense amount for the time entry (can be null) */
  expenseAmount?: number | null;
  /** Rating for the time entry (1-5, can be null) */
  rating?: number | null;
  /** Position/role for the time entry (can be null) */
  position?: string | null;
}

export interface TimeEntryValidationError {
  field:
    | "email"
    | "date"
    | "position"
    | "startAt"
    | "endAt"
    | "breakTimeMinutes"
    | "bonusHours"
    | "expenseAmount"
    | "rating";
  errorCode: string;
  exampleAllowedValue?: string;
}

export interface TimeEntryValidationResult {
  rowIndex: number;
  timeEntry: ValidatedTimeEntry | null;
  errors: TimeEntryValidationError[];
}

export interface ExpenseClaimCreateInput {
  /** Amount can be negative for refunds or credits */
  amount: number;
  type: "CAR" | "PUBLIC_TRANSPORT" | "OTHER";
  status: "PENDING" | "ACCEPTED" | "REJECTED";
  note?: string;
  /** @format binary */
  document: File;
}

export interface ExpenseClaimUpdateInput {
  /** Amount can be negative for refunds or credits */
  amount: number;
  type: "CAR" | "PUBLIC_TRANSPORT" | "OTHER";
  status: "PENDING" | "ACCEPTED" | "REJECTED";
  note?: string;
  /** @format binary */
  document?: File;
}

export interface PaginatedPosition {
  /** Total number of items */
  totalAmount: number;
  items?: Position[];
}

export interface PositionUpdateInput {
  name?: string;
  projectId?: string;
}

export interface TwilioConfigEntity {
  id: string;
  accountSid: string;
  /** Masked auth token (last 4 chars visible) */
  authToken: string;
  spendingLimit?: number;
  monthlyLimit?: number;
}

export interface MetaWhatsAppConfigEntity {
  id: string;
  businessAccountId: string;
  /** Masked access token (last 4 chars visible) */
  accessToken: string;
  /** Masked app secret (last 4 chars visible) */
  appSecret?: string;
}

export interface SendgridConfigEntity {
  id: string;
  /** Masked API key (last 4 chars visible) */
  apiKey: string;
}

export interface IntegrationEndpointEntity {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  providerId: string;
  /** Phone number or email address */
  identifier: string;
  displayName?: object;
  channel?: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  /** Provider-specific endpoint configuration */
  endpointConfig?: object;
  priority: number;
  isActive: boolean;
  messagesSent: number;
  messagesReceived: number;
  lastUsedAt?: object;
  webhookUrl?: object;
}

export interface IntegrationProviderEntity {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  organizationId: string;
  providerType: "TWILIO" | "META_WHATSAPP" | "SENDGRID" | "TELEGRAM_BOT" | "BOOMER";
  category: "MESSAGING" | "HR" | "PAYROLL" | "CRM" | "ANALYTICS";
  twilioConfig?: TwilioConfigEntity;
  metaWhatsAppConfig?: MetaWhatsAppConfigEntity;
  sendgridConfig?: SendgridConfigEntity;
  endpoints?: IntegrationEndpointEntity[];
}

export interface TwilioConfigInput {
  /**
   * Twilio Account SID
   *
   * @example
   *   ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx;
   */
  accountSid: string;
  /**
   * Twilio Auth Token
   *
   * @example
   *   your_auth_token_here;
   */
  authToken: string;
  /** Spending limit in dollars */
  spendingLimit?: number;
  /** Monthly spending limit in dollars */
  monthlyLimit?: number;
}

export interface EndpointCreateInput {
  /** Phone number (e.g., +31612345678) or email address */
  identifier: string;
  /** Friendly display name */
  displayName?: string;
  /** Message channel (WHATSAPP, SMS, EMAIL) */
  channel: "WHATSAPP" | "SMS" | "EMAIL" | "TELEGRAM" | "WEBCHAT" | "BOOMER";
  /** Provider-specific endpoint configuration (e.g., phoneNumberSid for Twilio) */
  endpointConfig?: object;
  /** Webhook URL for inbound messages */
  webhookUrl?: string;
  /** Webhook secret for signature validation */
  webhookSecret?: string;
}

export interface TwilioProviderCreateInput {
  config: TwilioConfigInput;
  /** Optional endpoints to create with the provider */
  endpoints?: EndpointCreateInput[];
}

export interface MetaWhatsAppConfigInput {
  /** Meta Business Account ID */
  businessAccountId: string;
  /** Meta Access Token */
  accessToken: string;
  /** App Secret for webhook validation */
  appSecret?: string;
}

export interface MetaWhatsAppProviderCreateInput {
  config: MetaWhatsAppConfigInput;
  /** Optional endpoints to create with the provider */
  endpoints?: EndpointCreateInput[];
}

export interface SendgridConfigInput {
  /** SendGrid API Key */
  apiKey: string;
}

export interface SendgridProviderCreateInput {
  config: SendgridConfigInput;
  /** Optional endpoints to create with the provider */
  endpoints?: EndpointCreateInput[];
}

export interface TwilioConfigUpdateInput {
  /** Twilio Account SID */
  accountSid?: string;
  /** Twilio Auth Token */
  authToken?: string;
  /** Spending limit in dollars */
  spendingLimit?: number;
  /** Monthly spending limit in dollars */
  monthlyLimit?: number;
}

export interface MetaWhatsAppConfigUpdateInput {
  /** Meta Business Account ID */
  businessAccountId?: string;
  /** Meta Access Token */
  accessToken?: string;
  /** App Secret for webhook validation */
  appSecret?: string;
}

export interface SendgridConfigUpdateInput {
  /** SendGrid API Key */
  apiKey?: string;
}

export interface WebhookUrlEntity {
  /**
   * The webhook URL to configure in the provider dashboard
   *
   * @example
   *   https://api.pre-dev.heyboomer.nl/webhooks/twilio/whatsapp
   */
  webhookUrl?: object;
  /** The provider type */
  providerType: "TWILIO" | "META_WHATSAPP" | "SENDGRID" | "TELEGRAM_BOT";
}

export interface TwilioVerifyCredentialsInput {
  /**
   * Twilio Account SID
   *
   * @example
   *   ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx;
   */
  accountSid: string;
  /**
   * Twilio Auth Token
   *
   * @example
   *   your_auth_token_here;
   */
  authToken: string;
}

export interface MetaConfigEntity {
  /**
   * Meta/Facebook App ID
   *
   * @example
   *   123456789012345;
   */
  appId: string;
  /**
   * Meta Graph API version
   *
   * @example
   *   v20.0
   */
  graphApiVersion: string;
  /**
   * Meta configuration ID for embedded signup
   *
   * @example
   *   123456789012345;
   */
  configurationId: string;
}

export interface MetaEventsInput {
  /**
   * Event type from Meta embedded signup
   *
   * @example
   *   FINISH;
   */
  type: string;
  /**
   * Phone number ID returned on successful signup
   *
   * @example
   *   123456789012345;
   */
  phone_number_id?: string;
  /**
   * WhatsApp Business Account ID returned on successful signup
   *
   * @example
   *   123456789012345;
   */
  waba_id?: string;
  /** Additional event data */
  data?: object;
}

export interface MetaTokenExchangeInput {
  /**
   * Authorization code from embedded signup completion
   *
   * @example
   *   AQB...
   */
  code: string;
  /**
   * WhatsApp Business Account ID from embedded signup. Required for setup.
   *
   * @example
   *   123456789012345;
   */
  wabaId: string;
  /**
   * The redirect URI used when initiating the OAuth flow. Must match EXACTLY (including trailing
   * slashes, protocol, etc.) the redirect_uri that was used in the initial OAuth request. For
   * embedded signup, this should be the exact value of window.location.href at the time the Meta
   * SDK was initialized, without any query parameters or hash fragments that may have been added
   * later. This domain must be configured in the Meta App settings under App Domains and Valid
   * OAuth Redirect URIs. IMPORTANT: The redirect_uri must match character-for-character what was
   * sent to Meta in the initial OAuth request.
   *
   * @example
   *   https://admin.heyboomer.localhost/settings/organization/integrations
   */
  redirectUri: string;
}

export interface MetaTokenExchangeResponseEntity {
  /**
   * Whether the token exchange was successful
   *
   * @example
   *   true;
   */
  success: boolean;
  /**
   * The created or updated provider ID
   *
   * @example
   *   uuid - here;
   */
  providerId: string;
  /**
   * WhatsApp Business Account ID
   *
   * @example
   *   123456789012345;
   */
  wabaId: string;
}

export interface MetaManualSetupInput {
  /**
   * WhatsApp Business Account ID
   *
   * @example
   *   123456789012345;
   */
  wabaId: string;
  /**
   * System User Access Token with WhatsApp Business Management permissions. This should be a
   * permanent token (not a short-lived OAuth token).
   *
   * @example
   *   EAABsbCS...
   */
  accessToken: string;
}

export interface MetaManualSetupResponseEntity {
  /**
   * Whether the setup was successful
   *
   * @example
   *   true;
   */
  success: boolean;
  /**
   * The created or updated provider ID
   *
   * @example
   *   uuid - here;
   */
  providerId: string;
  /**
   * WhatsApp Business Account ID
   *
   * @example
   *   123456789012345;
   */
  wabaId: string;
  /**
   * Whether this was a new provider or an existing one was updated
   *
   * @example
   *   false;
   */
  isNewProvider: boolean;
}

export interface MetaSetupInput {
  /**
   * Provider ID from token exchange
   *
   * @example
   *   uuid - here;
   */
  providerId: string;
  /**
   * WhatsApp Business Account ID. If not provided, will use the one from provider config.
   *
   * @example
   *   123456789012345;
   */
  wabaId?: string;
}

export interface EndpointUpdateInput {
  /** Friendly display name */
  displayName?: string;
  /** Provider-specific endpoint configuration */
  endpointConfig?: object;
  /** Whether the endpoint is active */
  isActive?: boolean;
  /** Webhook URL for inbound messages */
  webhookUrl?: string;
  /** Webhook secret for signature validation */
  webhookSecret?: string;
}

export interface MonthlyActivityItem {
  /**
   * Month in YYYY-MM format
   *
   * @example
   *   2025-01
   */
  month: string;
  /**
   * Number of active employees in this month
   *
   * @example
   *   45;
   */
  activeEmployees: number;
}

export interface EmployeeReport {
  /**
   * Total number of current (non-archived) employees
   *
   * @example
   *   125;
   */
  totalCurrentEmployees: number;
  /**
   * Total number of active employees in the current month
   *
   * @example
   *   42;
   */
  totalActiveEmployees: number;
  /** Monthly activity data for the last 12 months */
  monthlyActivity: MonthlyActivityItem[];
}

export interface TotalCurrentEmployees {
  /**
   * Total number of current (non-archived) employees
   *
   * @example
   *   125;
   */
  total: number;
}

export interface TotalActiveEmployees {
  /**
   * Total number of active employees in the current month
   *
   * @example
   *   42;
   */
  total: number;
}

export interface MonthlyActivityResponse {
  /** Monthly activity data for the last 12 months */
  monthlyActivity: MonthlyActivityItem[];
}

export interface TrendMetric {
  /**
   * Current value
   *
   * @example
   *   150;
   */
  current: number;
  /**
   * Last month value
   *
   * @example
   *   125;
   */
  lastMonth: number;
}

export interface HoursReport {
  /** Planned hours for current month with trend */
  plannedHours: TrendMetric;
  /** Registered hours for current month with trend */
  registeredHours: TrendMetric;
  /**
   * Count of finished shifts without time entries in current month
   *
   * @example
   *   5;
   */
  finishedShiftsWithoutTimeEntries: number;
  /**
   * Percentage of registered hours vs planned hours
   *
   * @example
   *   85;
   */
  hoursPercentage: number;
  /**
   * Count of unregistered shifts from last month
   *
   * @example
   *   3;
   */
  lastMonthUnregisteredShifts: number;
  /** Average hours per shift with trend */
  averageHoursPerShift: TrendMetric;
  /** Average break time per shift in minutes with trend */
  averageBreakTimePerShift: TrendMetric;
}

export interface MonthlyHoursComparisonItem {
  /**
   * Month in YYYY-MM format
   *
   * @example
   *   2024-09
   */
  month: string;
  /**
   * Total planned hours for the month
   *
   * @example
   *   1200;
   */
  plannedHours: number;
  /**
   * Total registered hours for the month
   *
   * @example
   *   1050;
   */
  registeredHours: number;
}

export interface MonthlyHoursComparisonResponse {
  /** Monthly hours comparison data for the last 12 months */
  monthlyHoursComparison: MonthlyHoursComparisonItem[];
}

export interface ShiftMetrics {
  /** Average hours per shift with trend */
  averageHours: TrendMetric;
  /** Average break time per shift in minutes with trend */
  averageBreakTime: TrendMetric;
  /** Average declaration cost per shift with trend (only ACCEPTED expense claims) */
  averageDeclarationCost: TrendMetric;
}

export interface NotRegisteredMetrics {
  /**
   * Count of unregistered shifts from last month (no trend)
   *
   * @example
   *   3;
   */
  lastMonthUnregistered: number;
  /**
   * Count of finished/past shifts without time entries in current month (no trend)
   *
   * @example
   *   5;
   */
  currentMonthFinishedUnregistered: number;
  /**
   * Count of shift time entries that are not accepted in current month
   *
   * @example
   *   8;
   */
  notAcceptedCurrentMonth: number;
  /**
   * Count of shift time entries that are not accepted in last month
   *
   * @example
   *   12;
   */
  notAcceptedLastMonth: number;
}

export interface MonthOverviewMetrics {
  /** Total registered hours for current month and last month */
  totalRegisteredHours: {
    /**
     * Total registered hours for the entire current month
     *
     * @example
     *   1200;
     */
    totalForMonth?: number;
    /**
     * Total registered hours for the entire last month
     *
     * @example
     *   1050;
     */
    totalForLastMonth?: number;
  };
  /** Total planned hours for current month with last month comparison */
  totalPlannedHours: TrendMetric;
  /** Total accepted hours for current month and last month */
  totalAcceptedHours: {
    /**
     * Total accepted hours for current month
     *
     * @example
     *   800;
     */
    current?: number;
    /**
     * Total accepted hours for last month
     *
     * @example
     *   750;
     */
    lastMonth?: number;
  };
}

export interface GroupedHoursReport {
  /** Shift-related metrics for current month */
  shiftMetrics: ShiftMetrics;
  /** Not registered shifts metrics */
  notRegisteredMetrics: NotRegisteredMetrics;
  /** Month overview metrics */
  monthOverviewMetrics: MonthOverviewMetrics;
}

export interface DailyHoursComparisonItem {
  /**
   * Day of the month (1-31)
   *
   * @example
   *   15;
   */
  day: number;
  /**
   * Planned hours for this day in current month
   *
   * @example
   *   45;
   */
  currentMonthPlanned: number;
  /**
   * Planned hours for same day in previous month
   *
   * @example
   *   38;
   */
  previousMonthPlanned: number;
  /**
   * Accepted hours for this day in current month
   *
   * @example
   *   42;
   */
  currentMonthAccepted: number;
  /**
   * Accepted hours for same day in previous month
   *
   * @example
   *   35;
   */
  previousMonthAccepted: number;
}

export interface DailyHoursComparisonResponse {
  /** Daily hours comparison data for current month vs same period last month */
  dailyComparison: DailyHoursComparisonItem[];
  /** Metadata about the comparison period */
  metadata: {
    /**
     * Current month in YYYY-MM format
     *
     * @example
     *   2024-09
     */
    currentMonth?: string;
    /**
     * Previous month in YYYY-MM format
     *
     * @example
     *   2024-08
     */
    previousMonth?: string;
    /**
     * Number of days compared (up to current day)
     *
     * @example
     *   5;
     */
    daysCompared?: number;
  };
}

export interface MessageTemplateVariableEntity {
  /** Unique identifier */
  id: string;
  /** Variable name in camelCase, used as placeholder in template text (e.g., employeeFirstName) */
  variableName: string;
  /** Human-readable name for UI display (e.g., "Employee First Name") */
  friendlyName: string;
  /** Data table this variable references */
  variableTable: "USER" | "ORGANIZATION" | "EMPLOYEE" | "SHIFT" | "PROJECT" | "CAMPAIGN";
  /** Where the variable appears in the template */
  variableScope: "BODY" | "HEADER" | "BUTTONS";
  /** Description of what this variable represents */
  description?: object;
  /** Example value used for WhatsApp template approval */
  exampleValue?: object;
  /**
   * Record creation timestamp
   *
   * @format date-time
   */
  createdAt: string;
  /**
   * Record last update timestamp
   *
   * @format date-time
   */
  updatedAt: string;
}

export interface PaginatedMessageTemplateVariable {
  items: MessageTemplateVariableEntity[];
  count: number;
}

export interface CreateEntityTagDto {
  sourceType: "CONVERSATION" | "SUGGESTED_ACTION" | "PROJECT";
  /** ID of the source entity */
  sourceId: string;
  targetType: "PROJECT" | "SHIFT" | "ADMIN_USER" | "CONVERSATION_LABEL" | "CAMPAIGN";
  /** ID of the target entity */
  targetId: string;
  /** Optional metadata for the tag */
  metadata?: object;
}

export interface EntityTag {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  isArchived: boolean;
  sourceType: "CONVERSATION" | "SUGGESTED_ACTION" | "PROJECT";
  conversationId?: object;
  sourceProjectId?: object;
  targetType: "PROJECT" | "SHIFT" | "ADMIN_USER" | "CONVERSATION_LABEL" | "CAMPAIGN";
  targetProjectId?: object;
  targetShiftId?: object;
  targetAdminUserId?: object;
  targetConversationLabel?: "CANCELLATION" | "CAMPAIGN" | "HR" | "ONBOARDING" | "GENERAL";
  targetCampaignId?: object;
  metadata?: object;
}

export interface AssignToSelfDto {
  /**
   * Type of the source entity to assign (e.g., CONVERSATION, PROJECT)
   *
   * @example
   *   CONVERSATION;
   */
  sourceType: "CONVERSATION" | "SUGGESTED_ACTION" | "PROJECT";
  /**
   * ID of the source entity to assign
   *
   * @example
   *   conv - 123;
   */
  sourceId: string;
}

export interface EntityTagFilterKeys {
  id?: StringFilter;
  sourceType?: EntityTagSourceTypeEnumFilter;
  conversationId?: StringFilter;
  sourceProjectId?: StringFilter;
  targetType?: EntityTagTargetTypeEnumFilter;
  targetProjectId?: StringFilter;
  targetShiftId?: StringFilter;
  targetAdminUserId?: StringFilter;
}

export interface EntityTagSort {
  /** @default "createdAt" */
  field?: string;
  /** @default "desc" */
  order?: "asc" | "desc";
}

export interface EntityTagInclude {
  /** Fields to include: sourceDetails, targetDetails */
  values?: string[];
}

export interface EntitySourceDetails {
  id: string;
  name: string;
  type: string;
}

export interface EntityTargetDetails {
  id: string;
  name: string;
  type: string;
}

export interface EntityTagWithDetails {
  id: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  isArchived: boolean;
  sourceType: "CONVERSATION" | "SUGGESTED_ACTION" | "PROJECT";
  sourceId: string;
  sourceDetails?: EntitySourceDetails;
  targetType: "PROJECT" | "SHIFT" | "ADMIN_USER" | "CONVERSATION_LABEL" | "CAMPAIGN";
  targetId: string;
  targetDetails?: EntityTargetDetails;
  metadata: object;
}

export interface PaginatedEntityTags {
  items: EntityTagWithDetails[];
  total: number;
}

export interface UpdateEntityTagDto {
  /** Updated metadata for the tag */
  metadata: object;
}

export interface EntityTagOption {
  /** ID of the entity */
  id: string;
  /** Display name of the entity */
  name: string;
  /** Target id of the entity */
  targetId: string;
  /** Description or additional info */
  description?: string;
  /** Avatar/image URL if applicable */
  avatarUrl?: string;
  /** Additional metadata about the entity */
  metadata?: object;
  /** Whether this entity is already tagged in current context */
  alreadyTagged?: boolean;
}

export interface AssignShiftsDto {
  /** Array of shifts to assign employees to */
  shifts: ShiftAssignmentDto[];
}

export interface UnassignShiftDto {
  /** Shift ID */
  shiftId: string;
  /** Employee ID (for reference, not validated) */
  employeeId: string;
}

export interface UnassignShiftsDto {
  /** Array of shift-employee pairs to unassign */
  shifts: UnassignShiftDto[];
}

export interface PlanningResult {
  /**
   * The number of shifts assigned
   *
   * @example
   *   10;
   */
  assignedCount: number;
  /** The paginated shifts that were planned */
  paginatedShifts: PaginatedShift;
}

export interface RegistrationDto {
  /**
   * Full name of the person registering
   *
   * @example
   *   John Doe
   */
  fullName?: string;
  /**
   * Email address of the person registering
   *
   * @example
   *   john.doe@example.com
   */
  email?: string;
  /**
   * Phone number of the person registering
   *
   * @example
   *   +31612345678;
   */
  phone?: string;
  /**
   * Motivation or message from the person registering
   *
   * @example
   *   I would like to join the platform to find work opportunities
   */
  motivation?: string;
  /**
   * Organization slug for the registration
   *
   * @example
   *   boomer - preview;
   */
  organizationSlug?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** Set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** Request path */
  path: string;
  /** Content type of request body */
  type?: ContentType;
  /** Query params */
  query?: QueryParamsType;
  /** Format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat | null;
  /** Request body */
  body?: unknown;
  /** Base url */
  baseUrl?: string;
  /** Request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
  Stream = "text/event-stream",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "include",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};

    const stringify = (obj: any, prefix = ""): string => {
      const parts: string[] = [];

      Object.entries(obj).forEach(([key, value]) => {
        const fullKey = prefix ? `${prefix}[${key}]` : key;

        if (value === null || value === undefined) {
          return;
        } else if (typeof value === "object" && !Array.isArray(value)) {
          parts.push(stringify(value, fullKey));
        } else if (Array.isArray(value)) {
          value.forEach((arrayValue, index) => {
            if (typeof arrayValue === "object" && arrayValue !== null) {
              parts.push(stringify(arrayValue, `${fullKey}[${index}]`));
            } else {
              // Only encode if not using CapacitorHttp
              const encodedValue = Capacitor.isPluginAvailable("CapacitorHttp")
                ? String(arrayValue)
                : encodeURIComponent(String(arrayValue));
              parts.push(`${fullKey}[]=${encodedValue}`);
            }
          });
        } else {
          // Only encode if not using CapacitorHttp
          const encodedValue = Capacitor.isPluginAvailable("CapacitorHttp")
            ? String(value)
            : encodeURIComponent(String(value));
          parts.push(`${fullKey}=${encodedValue}`);
        }
      });

      return parts.join("&");
    };

    return stringify(query);
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string" ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        const propertyContent = property instanceof Array ? property : [property];

        for (const formItem of propertyContent) {
          const isFileType = formItem instanceof Blob || formItem instanceof File;
          formData.append(
            key,
            isFileType
              ? formItem
              : typeof formItem === "object" && formItem !== null
                ? JSON.stringify(formItem)
                : String(formItem),
          );
        }
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
    [ContentType.Stream]: (input: any) => input,
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData && type !== ContentType.Stream
            ? { "Content-Type": type }
            : {}),
          ...(type && type === ContentType.Stream
            ? { Accept: type, "Content-Type": ContentType.Json }
            : {}),
        },
        signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
        body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e: any) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @version 0.9.13
 * @title api
 * @contact
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name AppControllerGetHello
   * @request GET:/
   */
  appControllerGetHello = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/`,
      method: "GET",
      ...params,
    });

  health = {
    /**
     * No description
     *
     * @name AppControllerHealthCheck
     * @request GET:/health
     */
    healthCheck: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/health`,
        method: "GET",
        ...params,
      }),
  };
  api = {
    /**
     * No description
     *
     * @tags Auth
     * @name BetterAuthControllerSigninEmployee
     * @request POST:/api/auth/sign-in/employee
     */
    signinEmployee: (data: SigninInput, params: RequestParams = {}) =>
      this.request<SigninResponse, any>({
        path: `/api/auth/sign-in/employee`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name BetterAuthControllerSigninAdmin
     * @request POST:/api/auth/sign-in/admin
     */
    signinAdmin: (data: SigninInput, params: RequestParams = {}) =>
      this.request<SigninResponse, any>({
        path: `/api/auth/sign-in/admin`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name BetterAuthControllerSignOut
     * @request POST:/api/auth/sign-out
     */
    signOut: (
      query: {
        currentURL: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SignoutResponse, any>({
        path: `/api/auth/sign-out`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name BetterAuthControllerGetSession
     * @request GET:/api/auth/get-session
     */
    getSession: (
      query: {
        currentURL: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SessionResponse, any>({
        path: `/api/auth/get-session`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name BetterAuthControllerAcceptInviteEmployee
     * @request POST:/api/auth/accept-invite/employee
     */
    acceptInviteEmployee: (data: AcceptEmployeeInviteInput, params: RequestParams = {}) =>
      this.request<AcceptInviteResponse, any>({
        path: `/api/auth/accept-invite/employee`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name BetterAuthControllerAcceptInviteRelation
     * @request POST:/api/auth/accept-invite/relation
     */
    acceptInviteRelation: (data: AcceptRelationInviteInput, params: RequestParams = {}) =>
      this.request<AcceptInviteResponse, any>({
        path: `/api/auth/accept-invite/relation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name BetterAuthControllerAcceptInviteAdmin
     * @request POST:/api/auth/accept-invite/admin
     */
    acceptInviteAdmin: (data: AcceptAdminInviteInput, params: RequestParams = {}) =>
      this.request<AcceptInviteResponse, any>({
        path: `/api/auth/accept-invite/admin`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name BetterAuthControllerSwitchOrganization
     * @request POST:/api/auth/switch-organization
     */
    switchOrganization: (data: SwitchOrganizationInput, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          organizationId?: string;
          organization?: {
            id?: string;
            name?: string;
            slug?: string;
          };
        },
        void
      >({
        path: `/api/auth/switch-organization`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name BetterAuthControllerValidateResetToken
     * @request POST:/api/auth/validate-reset-token
     */
    validateResetToken: (data: ValidateResetTokenInput, params: RequestParams = {}) =>
      this.request<ValidateResetTokenResponse, any>({
        path: `/api/auth/validate-reset-token`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Queue Management
     * @name QueueControllerGetQueueMetrics
     * @summary Get queue metrics
     * @request GET:/api/queues/metrics
     */
    getQueueMetrics: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/queues/metrics`,
        method: "GET",
        ...params,
      }),
  };
  notification = {
    /**
     * No description
     *
     * @tags Notification
     * @name NotificationControllerSendMessage
     * @request POST:/notification/send
     */
    sendMessage: (data: SendMessageDto, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/notification/send`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name NotificationControllerSendMessageToEmployee
     * @request POST:/notification/send/employee/{id}
     */
    sendMessageToEmployee: (id: string, data: SendMessageDto, params: RequestParams = {}) =>
      this.request<boolean, any>({
        path: `/notification/send/employee/${id}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name NotificationControllerAddDevice
     * @request POST:/notification/add-device
     */
    addDevice: (data: AddDeviceDto, params: RequestParams = {}) =>
      this.request<UserDevice, any>({
        path: `/notification/add-device`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name NotificationControllerGetDevices
     * @request GET:/notification/devices
     */
    getDevices: (params: RequestParams = {}) =>
      this.request<UserDevicesDto, any>({
        path: `/notification/devices`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Notification
     * @name NotificationControllerDeleteDevice
     * @request DELETE:/notification/device/{deviceIdentifier}
     */
    deleteDevice: (deviceIdentifier: string, params: RequestParams = {}) =>
      this.request<UserDevice, any>({
        path: `/notification/device/${deviceIdentifier}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  notifications = {
    /**
     * Returns a list of all available notification types that can be sent by the system
     *
     * @tags Notification Info
     * @name NotificationInfoControllerGetAllTypes
     * @summary Get all notification types
     * @request GET:/notifications/info/types
     */
    getAllTypes: (params: RequestParams = {}) =>
      this.request<NotificationTypeResponse, any>({
        path: `/notifications/info/types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * Returns detailed information about each notification type including when it's sent and what
     * metadata it contains
     *
     * @tags Notification Info
     * @name NotificationInfoControllerGetDescriptions
     * @summary Get detailed notification descriptions
     * @request GET:/notifications/info/descriptions
     */
    getDescriptions: (params: RequestParams = {}) =>
      this.request<NotificationDescriptionsResponse, any>({
        path: `/notifications/info/descriptions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * Returns notification types grouped by their category (shift, application, expense,
     * time_entry)
     *
     * @tags Notification Info
     * @name NotificationInfoControllerGetByCategory
     * @summary Get notifications grouped by category
     * @request GET:/notifications/info/categories
     */
    getByCategory: (params: RequestParams = {}) =>
      this.request<NotificationCategoriesResponse, any>({
        path: `/notifications/info/categories`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  agentTraces = {
    /**
     * Returns paginated list of agent traces for debugging. Only accessible by super admins.
     *
     * @tags Agent Traces (Debug)
     * @name AgentTraceControllerGetAll
     * @summary Get all agent traces (paginated)
     * @request GET:/agent-traces
     * @secure
     */
    getAll: (
      query?: {
        /** Page number (1-indexed) */
        page?: number;
        /** Number of items per page (max 100) */
        limit?: number;
        /** Filter by conversation ID */
        conversationId?: string;
        /** Filter by organization ID */
        organizationId?: string;
        /** Filter by trace status */
        status?: "IN_PROGRESS" | "COMPLETED" | "FAILED";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/agent-traces`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * Returns a single agent trace with all its steps decompressed. Only accessible by super
     * admins.
     *
     * @tags Agent Traces (Debug)
     * @name AgentTraceControllerGet
     * @summary Get agent trace by ID with all steps
     * @request GET:/agent-traces/{id}
     * @secure
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/agent-traces/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * Returns all agent traces for a specific conversation. Only accessible by super admins.
     *
     * @tags Agent Traces (Debug)
     * @name AgentTraceControllerGetByConversation
     * @summary Get all traces for a conversation
     * @request GET:/agent-traces/conversation/{conversationId}
     * @secure
     */
    getByConversation: (
      conversationId: string,
      query?: {
        /** Number of traces to return (max 50) */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/agent-traces/conversation/${conversationId}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),
  };
  ai = {
    /**
     * No description
     *
     * @tags AI
     * @name AiControllerGetTokenUsageStats
     * @summary Get token usage statistics
     * @request GET:/ai/token-usage/stats
     */
    getTokenUsageStats: (
      query?: {
        userId?: string;
        organizationId?: string;
        conversationId?: string;
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/ai/token-usage/stats`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI
     * @name AiControllerGetTokenUsageDetails
     * @summary Get detailed token usage records
     * @request GET:/ai/token-usage/details
     */
    getTokenUsageDetails: (
      query?: {
        userId?: string;
        organizationId?: string;
        conversationId?: string;
        /** @format date-time */
        startDate?: string;
        /** @format date-time */
        endDate?: string;
        limit?: number;
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/ai/token-usage/details`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AI
     * @name AiControllerGetDailyTokenUsage
     * @summary Get daily token usage for charting
     * @request GET:/ai/token-usage/daily
     */
    getDailyTokenUsage: (
      query?: {
        days?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/ai/token-usage/daily`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  file = {
    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetPublicUrlBySlug
     * @request GET:/file/public/by-slug/{key}
     */
    getPublicUrlBySlug: (
      key: string,
      query: {
        slug: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<SignedUrl, any>({
        path: `/file/public/by-slug/${key}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetPublicUrl
     * @request GET:/file/public/{key}
     */
    getPublicUrl: (key: string, params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/file/public/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetProjectUrl
     * @request GET:/file/project/{projectId}/{key}
     */
    getProjectUrl: (projectId: string, key: string, params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/file/project/${projectId}/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetExpenseClaimUrl
     * @request GET:/file/expense-claim/{projectId}/{expenseClaimId}/{key}
     */
    getExpenseClaimUrl: (
      projectId: string,
      expenseClaimId: string,
      key: string,
      params: RequestParams = {},
    ) =>
      this.request<SignedUrl, any>({
        path: `/file/expense-claim/${projectId}/${expenseClaimId}/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetProjectRelationInvoiceUrl
     * @request GET:/file/project/{projectId}/invoice/{key}
     */
    getProjectRelationInvoiceUrl: (projectId: string, key: string, params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/file/project/${projectId}/invoice/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetFreelancerInvoiceUrl
     * @request GET:/file/project/{projectId}/freelancer-invoice/{key}
     */
    getFreelancerInvoiceUrl: (projectId: string, key: string, params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/file/project/${projectId}/freelancer-invoice/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetRelationUrl
     * @request GET:/file/relation/{relationId}/{key}
     */
    getRelationUrl: (relationId: string, key: string, params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/file/relation/${relationId}/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetUserUrl
     * @request GET:/file/user/{userId}/{key}
     */
    getUserUrl: (userId: string, key: string, params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/file/user/${userId}/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerUpdateUserUrl
     * @request POST:/file/user/{userId}/{key}
     */
    updateUserUrl: (
      userId: string,
      key: string,
      data: {
        /** @format binary */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<SignedUrl, void>({
        path: `/file/user/${userId}/${key}`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetRelationDocumentUrl
     * @request GET:/file/relation/{relationId}/document/{key}
     */
    getRelationDocumentUrl: (relationId: string, key: string, params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/file/relation/${relationId}/document/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetProjectDocumentUrl
     * @request GET:/file/project/{projectId}/document/{key}
     */
    getProjectDocumentUrl: (projectId: string, key: string, params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/file/project/${projectId}/document/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetMeUrl
     * @request GET:/file/me/{key}
     */
    getMeUrl: (key: string, params: RequestParams = {}) =>
      this.request<SignedUrl, any>({
        path: `/file/me/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerUploadConversationMedia
     * @request POST:/file/conversation/{conversationId}/media
     */
    uploadConversationMedia: (
      conversationId: string,
      data: {
        /**
         * Media file (image, video, audio, or PDF)
         *
         * @format binary
         */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<MediaUploadResponse, void>({
        path: `/file/conversation/${conversationId}/media`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags File
     * @name FileControllerGetConversationMedia
     * @request GET:/file/conversation/{conversationId}/media/{key}
     */
    getConversationMedia: (conversationId: string, key: string, params: RequestParams = {}) =>
      this.request<SignedUrl, void>({
        path: `/file/conversation/${conversationId}/media/${key}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  project = {
    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerGetAll
     * @request GET:/project
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: ProjectFilterKeys;
        sort?: ProjectSort;
        pagination?: PaginationFilter;
        include?: ProjectIncludeKeys;
        aggregate?: ProjectAggregateKeys;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedProject, any>({
        path: `/project`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerCreate
     * @request POST:/project
     */
    create: (data: ProjectCreateInput, params: RequestParams = {}) =>
      this.request<ProjectCreateInput, any>({
        path: `/project`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerGetProjectsByDayRange
     * @request GET:/project/by-day-range
     */
    getProjectsByDayRange: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: ProjectFilterKeys;
        sort?: ProjectSort;
        pagination?: PaginationFilter;
        include?: ProjectIncludeKeys;
        aggregate?: ProjectAggregateKeys;
      },
      params: RequestParams = {},
    ) =>
      this.request<ProjectDays, any>({
        path: `/project/by-day-range`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerExportAll
     * @request GET:/project/export/{format}
     */
    exportAll: (
      format: string,
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: ProjectFilterKeys;
        sort?: ProjectSort;
        pagination?: PaginationFilter;
        include?: ProjectIncludeKeys;
        aggregate?: ProjectAggregateKeys;
        /** Export format (default: csv) */
        format?: "csv" | "json" | "xlsx";
      },
      params: RequestParams = {},
    ) =>
      this.request<File, any>({
        path: `/project/export/${format}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerGet
     * @request GET:/project/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<Project, any>({
        path: `/project/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerUpdate
     * @request PATCH:/project/{id}
     */
    update: (id: string, data: ProjectUpdateInput, params: RequestParams = {}) =>
      this.request<ProjectUpdateInput, any>({
        path: `/project/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerDelete
     * @request DELETE:/project/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/project/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerDuplicate
     * @request POST:/project/{id}/duplicate
     */
    duplicate: (id: string, data: ProjectDuplicateInput, params: RequestParams = {}) =>
      this.request<Project, any>({
        path: `/project/${id}/duplicate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerUpdateSettings
     * @request PATCH:/project/{id}/settings
     */
    updateSettings: (id: string, data: ProjectSettingsUpdateInput, params: RequestParams = {}) =>
      this.request<ProjectSettingsUpdateInput, any>({
        path: `/project/${id}/settings`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerUpdateAddress
     * @request PATCH:/project/{id}/address
     */
    updateAddress: (id: string, data: ProjectAddressUpdateInput, params: RequestParams = {}) =>
      this.request<ProjectAddressUpdateInput, any>({
        path: `/project/${id}/address`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerArchive
     * @request PATCH:/project/{id}/archive
     */
    archive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/project/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Project
     * @name ProjectControllerUnarchive
     * @request PATCH:/project/{id}/unarchive
     */
    unarchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/project/${id}/unarchive`,
        method: "PATCH",
        ...params,
      }),
  };
  additionalField = {
    /**
     * No description
     *
     * @tags Additional Field
     * @name AdditionalFieldControllerGetAll
     * @request GET:/additional-field/{projectId}
     */
    getAll: (projectId: string, params: RequestParams = {}) =>
      this.request<AdditionalField[], any>({
        path: `/additional-field/${projectId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Additional Field
     * @name AdditionalFieldControllerCreate
     * @request POST:/additional-field/{projectId}
     */
    create: (projectId: string, data: AdditionalFieldInput, params: RequestParams = {}) =>
      this.request<AdditionalField, any>({
        path: `/additional-field/${projectId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Additional Field
     * @name AdditionalFieldControllerUpdate
     * @request PATCH:/additional-field/{projectId}/{id}
     */
    update: (
      id: string,
      projectId: string,
      data: AdditionalFieldInput,
      params: RequestParams = {},
    ) =>
      this.request<AdditionalField, any>({
        path: `/additional-field/${projectId}/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Additional Field
     * @name AdditionalFieldControllerDelete
     * @request DELETE:/additional-field/{projectId}/{id}
     */
    delete: (id: string, projectId: string, params: RequestParams = {}) =>
      this.request<AdditionalField, any>({
        path: `/additional-field/${projectId}/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  shift = {
    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerGetExampleFile
     * @request GET:/shift/example-file
     */
    getExampleFile: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/shift/example-file`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerValidateShifts
     * @request POST:/shift/validate-shifts
     */
    validateShifts: (
      data: {
        /** @format binary */
        file?: File;
        projectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ShiftValidationResult[], any>({
        path: `/shift/validate-shifts`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerCreateImportedShifts
     * @request POST:/shift/import-shifts
     */
    createImportedShifts: (
      data: {
        shifts: ShiftValidationResult[];
        projectId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/shift/import-shifts`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerGetAll
     * @request GET:/shift
     */
    getAll: (
      query?: {
        /** Filter supporting simple object or logical operations (AND/OR) for ShiftFilterKeys */
        filter?:
          | ShiftFilterKeys
          | (
              | {
                  AND?: ShiftFilterKeys[];
                }
              | {
                  OR?: ShiftFilterKeys[];
                }
            )[];
        sort?: ShiftSort;
        pagination?: PaginationFilter;
        include?: ShiftInclude;
        aggregate?: ShiftAggregateKeys;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedShift, any>({
        path: `/shift`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerCreate
     * @request POST:/shift
     */
    create: (data: ShiftCreateInput, params: RequestParams = {}) =>
      this.request<ShiftCreateInput, any>({
        path: `/shift`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerGetAllByProject
     * @request GET:/shift/project/{id}
     */
    getAllByProject: (
      id: string,
      query?: {
        /** Filter supporting simple object or logical operations (AND/OR) for ShiftFilterKeys */
        filter?:
          | ShiftFilterKeys
          | (
              | {
                  AND?: ShiftFilterKeys[];
                }
              | {
                  OR?: ShiftFilterKeys[];
                }
            )[];
        sort?: ShiftSort;
        pagination?: PaginationFilter;
        include?: ShiftInclude;
        aggregate?: ShiftAggregateKeys;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedShift, any>({
        path: `/shift/project/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerGetUserShiftOverview
     * @request GET:/shift/user/{userId}/overview
     */
    getUserShiftOverview: (
      userId: string,
      query: {
        limit: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<UserShiftOverview, any>({
        path: `/shift/user/${userId}/overview`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerCreateBulk
     * @request POST:/shift/bulk
     */
    createBulk: (data: ShiftBulkCreateInput, params: RequestParams = {}) =>
      this.request<Shift[], any>({
        path: `/shift/bulk`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerDeleteBulk
     * @request DELETE:/shift/bulk
     */
    deleteBulk: (data: ShiftBulkDeleteInput, params: RequestParams = {}) =>
      this.request<
        {
          /** Number of deleted shifts */
          count?: number;
        },
        any
      >({
        path: `/shift/bulk`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerConvertToSlots
     * @request POST:/shift/convert-to-slots
     */
    convertToSlots: (data: ShiftConvertToSlotsInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift/convert-to-slots`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerGet
     * @request GET:/shift/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<Shift, any>({
        path: `/shift/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerUpdate
     * @request PATCH:/shift/{id}
     */
    update: (id: string, data: ShiftUpdateInput, params: RequestParams = {}) =>
      this.request<ShiftUpdateInput, any>({
        path: `/shift/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerDelete
     * @request DELETE:/shift/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerUpdateNote
     * @request PATCH:/shift/{id}/note
     */
    updateNote: (id: string, data: ShiftNoteUpdateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift/${id}/note`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerExportAll
     * @request GET:/shift/export/{format}
     */
    exportAll: (
      format: string,
      query?: {
        /** Filter supporting simple object or logical operations (AND/OR) for ShiftFilterKeys */
        filter?:
          | ShiftFilterKeys
          | (
              | {
                  AND?: ShiftFilterKeys[];
                }
              | {
                  OR?: ShiftFilterKeys[];
                }
            )[];
        sort?: ShiftSort;
        pagination?: PaginationFilter;
        include?: ShiftInclude;
        aggregate?: ShiftAggregateKeys;
        /** Export format (default: csv) */
        format?: "csv" | "json" | "xlsx";
      },
      params: RequestParams = {},
    ) =>
      this.request<File, any>({
        path: `/shift/export/${format}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift
     * @name ShiftControllerExportByProject
     * @request GET:/shift/project/{id}/export/{format}
     */
    exportByProject: (
      id: string,
      format: string,
      query?: {
        /** Filter supporting simple object or logical operations (AND/OR) for ShiftFilterKeys */
        filter?:
          | ShiftFilterKeys
          | (
              | {
                  AND?: ShiftFilterKeys[];
                }
              | {
                  OR?: ShiftFilterKeys[];
                }
            )[];
        sort?: ShiftSort;
        pagination?: PaginationFilter;
        include?: ShiftInclude;
        aggregate?: ShiftAggregateKeys;
        /** Export format (default: csv) */
        format?: "csv" | "json" | "xlsx";
      },
      params: RequestParams = {},
    ) =>
      this.request<File, any>({
        path: `/shift/project/${id}/export/${format}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  planner = {
    /**
     * Retrieves the current status of a solver job including progress, state, and result (if
     * completed).
     *
     * @tags Planner
     * @name PlannerControllerGetJobStatus
     * @summary Get solver job status
     * @request GET:/planner/jobs/{id}/status
     */
    getJobStatus: (id: string, params: RequestParams = {}) =>
      this.request<SolverJobStatusResponseDto, void>({
        path: `/planner/jobs/${id}/status`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * Cancels a running or pending solver job. The job will be removed from the queue.
     *
     * @tags Planner
     * @name PlannerControllerCancelJob
     * @summary Cancel a solver job
     * @request DELETE:/planner/jobs/{id}
     */
    cancelJob: (id: string, params: RequestParams = {}) =>
      this.request<SolverJobCancellationResponseDto, void>({
        path: `/planner/jobs/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * Plans a workforce planning problem for a project. Returns a job ID that can be used to track
     * progress via WebSocket events or polling the status endpoint.
     *
     * @tags Planner
     * @name PlannerControllerPlan
     * @summary Plan a workforce planning problem
     * @request POST:/planner/{id}
     */
    plan: (id: string, data: PlanningOptionsDto, params: RequestParams = {}) =>
      this.request<SolverJobSubmissionResponseDto, any>({
        path: `/planner/${id}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Checks which optimization factors are available for the project based on available data
     * (employee teams, zip codes, ages, applications).
     *
     * @tags Planner
     * @name PlannerControllerGetAvailableFactors
     * @summary Get available optimization factors for a project
     * @request GET:/planner/projects/{id}/available-factors
     */
    getAvailableFactors: (id: string, params: RequestParams = {}) =>
      this.request<AvailableFactorsResponseDto, any>({
        path: `/planner/projects/${id}/available-factors`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Planner
     * @name PlannerControllerReset
     * @request POST:/planner/{id}/reset
     */
    reset: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/planner/${id}/reset`,
        method: "POST",
        ...params,
      }),

    /**
     * Returns a paginated list of all planning versions for the specified project.
     *
     * @tags Planner
     * @name PlannerControllerListVersions
     * @summary List all planning versions for a project
     * @request GET:/planner/projects/{id}/versions
     */
    listVersions: (
      id: string,
      query: {
        page: string;
        limit: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ListPlanningVersionsResponseDto, any>({
        path: `/planner/projects/${id}/versions`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * Deletes all planning versions for a project. This is for testing purposes only. Resets the
     * HEAD pointer.
     *
     * @tags Planner
     * @name PlannerControllerDeleteAllVersions
     * @summary Delete all planning versions for a project
     * @request DELETE:/planner/projects/{id}/versions
     */
    deleteAllVersions: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          deleted_count?: number;
        },
        any
      >({
        path: `/planner/projects/${id}/versions`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * Returns detailed information about a specific planning version including the full snapshot
     * with enriched shift data.
     *
     * @tags Planner
     * @name PlannerControllerGetVersion
     * @summary Get a single planning version with snapshot
     * @request GET:/planner/projects/{projectId}/versions/{versionId}
     */
    getVersion: (projectId: string, versionId: string, params: RequestParams = {}) =>
      this.request<GetPlanningVersionResponseDto, void>({
        path: `/planner/projects/${projectId}/versions/${versionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * Deletes a planning version. Only generated (non-approved) versions that are not HEAD can be
     * deleted.
     *
     * @tags Planner
     * @name PlannerControllerDeleteVersion
     * @summary Delete/reject a planning version
     * @request DELETE:/planner/projects/{projectId}/versions/{versionId}
     */
    deleteVersion: (projectId: string, versionId: string, params: RequestParams = {}) =>
      this.request<DeleteVersionResponseDto, void>({
        path: `/planner/projects/${projectId}/versions/${versionId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * Updates the name and/or description of a planning version. Only generated (non-approved)
     * versions can be updated. Snapshot is immutable.
     *
     * @tags Planner
     * @name PlannerControllerUpdateVersion
     * @summary Update a planning version
     * @request PATCH:/planner/projects/{projectId}/versions/{versionId}
     */
    updateVersion: (
      projectId: string,
      versionId: string,
      data: UpdateVersionRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<UpdateVersionResponseDto, void>({
        path: `/planner/projects/${projectId}/versions/${versionId}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Fetches multiple planning versions with their full snapshots in a single request.
     *
     * @tags Planner
     * @name PlannerControllerBulkFetchVersions
     * @summary Bulk fetch multiple planning versions
     * @request POST:/planner/projects/{id}/versions/bulk
     */
    bulkFetchVersions: (
      id: string,
      data: BulkFetchVersionsRequestDto,
      params: RequestParams = {},
    ) =>
      this.request<BulkFetchVersionsResponseDto, any>({
        path: `/planner/projects/${id}/versions/bulk`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Approves a planning version, making it the HEAD version and applying all assignments to
     * shifts.
     *
     * @tags Planner
     * @name PlannerControllerApproveVersion
     * @summary Approve a planning version
     * @request POST:/planner/projects/{projectId}/versions/{versionId}/approve
     */
    approveVersion: (projectId: string, versionId: string, params: RequestParams = {}) =>
      this.request<ApproveVersionResponseDto, void>({
        path: `/planner/projects/${projectId}/versions/${versionId}/approve`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * Reverts the HEAD version to a previous version in the chain. This will delete all versions
     * that come after the target version and apply the target version as the new HEAD.
     *
     * @tags Planner
     * @name PlannerControllerRevertVersion
     * @summary Revert HEAD to a previous planning version
     * @request POST:/planner/projects/{projectId}/versions/{versionId}/revert
     */
    revertVersion: (projectId: string, versionId: string, params: RequestParams = {}) =>
      this.request<RevertVersionResponseDto, void>({
        path: `/planner/projects/${projectId}/versions/${versionId}/revert`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  application = {
    /**
     * No description
     *
     * @tags Application
     * @name ApplicationControllerGetAll
     * @request GET:/application
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: ApplicationFilterKeys;
        sort?: ApplicationSort;
        pagination?: PaginationFilter;
        include?: ApplicationInclude;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedApplication, any>({
        path: `/application`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationControllerCreate
     * @request POST:/application
     */
    create: (data: ApplicationCreateInput, params: RequestParams = {}) =>
      this.request<ApplicationCreateInput, any>({
        path: `/application`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationControllerGetAllByAvailabilitySlot
     * @request GET:/application/slot/{id}
     */
    getAllByAvailabilitySlot: (
      id: string,
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: ApplicationFilterKeys;
        sort?: ApplicationSort;
        pagination?: PaginationFilter;
        include?: ApplicationInclude;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedApplication, any>({
        path: `/application/slot/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationControllerCreateEmployeeApplication
     * @request POST:/application/employee
     */
    createEmployeeApplication: (data: ApplicationCreateEmployeeInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/application/employee`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationControllerRevokeEmployeeApplication
     * @request POST:/application/employee/revoke
     */
    revokeEmployeeApplication: (
      query: {
        /**
         * The unique identifier of the resource
         *
         * @example
         *   1;
         *
         * @min 1
         */
        id: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/application/employee/revoke`,
        method: "POST",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationControllerGet
     * @request GET:/application/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<Application, any>({
        path: `/application/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationControllerUpdate
     * @request PATCH:/application/{id}
     */
    update: (id: string, data: ApplicationUpdateInput, params: RequestParams = {}) =>
      this.request<ApplicationUpdateInput, any>({
        path: `/application/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Application
     * @name ApplicationControllerDelete
     * @request DELETE:/application/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/application/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  appUser = {
    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerGetExampleFile
     * @request GET:/app-user/example-file
     */
    getExampleFile: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/app-user/example-file`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerValidateEmployees
     * @request POST:/app-user/validate-employees
     */
    validateEmployees: (
      data: {
        /** @format binary */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<EmployeeValidationResult[], any>({
        path: `/app-user/validate-employees`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerCreateImportedEmployees
     * @request POST:/app-user/import-employees
     */
    createImportedEmployees: (
      data: {
        employees: EmployeeValidationResult[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          count?: number;
          employees?: any[];
        },
        any
      >({
        path: `/app-user/import-employees`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerGetAll
     * @request GET:/app-user
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: EmployeeFilterKeys;
        sort?: EmployeeSort;
        pagination?: PaginationFilter;
        include?: EmployeeInclude;
        aggregate?: EmployeeAggregateKeys;
        includeFunctions?: boolean;
        includeTeams?: boolean;
        includeMessageContact?: boolean;
        /** Include signed URLs for user profile images */
        includeSignedUrls?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEmployee, any>({
        path: `/app-user`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerGetAvailableEmployees
     * @request GET:/app-user/available
     */
    getAvailableEmployees: (
      query: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: EmployeeAvailableFilterKeys;
        sort?: object;
        pagination?: PaginationFilter;
        /** @format date-time */
        startDate: string;
        /** @format date-time */
        endDate: string;
        projectId: string;
        functionId?: string;
        /** @default false */
        withApplicationCheck?: boolean;
        /**
         * Latitude for distance-based filtering
         *
         * @example
         *   52.3676;
         */
        latitude?: number;
        /**
         * Longitude for distance-based filtering
         *
         * @example
         *   4.9041;
         */
        longitude?: number;
        include?: EmployeeInclude;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAvailableEmployee, any>({
        path: `/app-user/available`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerGet
     * @request GET:/app-user/{id}
     */
    get: (
      id: string,
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: EmployeeFilterKeys;
        sort?: EmployeeSort;
        pagination?: PaginationFilter;
        include?: EmployeeInclude;
        aggregate?: EmployeeAggregateKeys;
        includeFunctions?: boolean;
        includeTeams?: boolean;
        includeMessageContact?: boolean;
        /** Include signed URLs for user profile images */
        includeSignedUrls?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<Employee, any>({
        path: `/app-user/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerUpdate
     * @request PATCH:/app-user/{id}
     */
    update: (id: string, data: EmployeeInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/app-user/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerDelete
     * @request DELETE:/app-user/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/app-user/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerArchive
     * @request PATCH:/app-user/{id}/archive
     */
    archive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/app-user/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerUnarchive
     * @request PATCH:/app-user/{id}/unarchive
     */
    unarchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/app-user/${id}/unarchive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerAddOrRemoveTeams
     * @request PATCH:/app-user/{id}/teams
     */
    addOrRemoveTeams: (id: string, data: AddOrRemoveInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/app-user/${id}/teams`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Employee
     * @name EmployeeControllerAddOrRemoveFunctions
     * @request PATCH:/app-user/{id}/functions
     */
    addOrRemoveFunctions: (id: string, data: AddOrRemoveInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/app-user/${id}/functions`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  rate = {
    /**
     * No description
     *
     * @tags Rate
     * @name RateControllerUpdateRate
     * @request PUT:/rate/{rateId}
     */
    updateRate: (rateId: string, data: UpdateRateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/rate/${rateId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  userFunctionRate = {
    /**
     * No description
     *
     * @tags User Function Rate
     * @name UserFunctionRateControllerGetProcurementRates
     * @request GET:/user-function-rate/{functionId}
     */
    getProcurementRates: (functionId: string, params: RequestParams = {}) =>
      this.request<UserFunctionProcurementRate[], any>({
        path: `/user-function-rate/${functionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Function Rate
     * @name UserFunctionRateControllerGetSalesRates
     * @request GET:/user-function-rate/{functionId}/sales-rates
     */
    getSalesRates: (functionId: string, params: RequestParams = {}) =>
      this.request<UserFunctionSalesRate[], any>({
        path: `/user-function-rate/${functionId}/sales-rates`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  organizationRate = {
    /**
     * No description
     *
     * @tags Organization Rate
     * @name OrganizationRateControllerCreateProcurementRate
     * @request POST:/organization-rate/procurement-rate
     */
    createProcurementRate: (data: CreateProcurementRateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organization-rate/procurement-rate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization Rate
     * @name OrganizationRateControllerValidateProcurementRate
     * @request POST:/organization-rate/validate
     */
    validateProcurementRate: (data: CreateProcurementRateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organization-rate/validate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization Rate
     * @name OrganizationRateControllerGetProcurementRates
     * @request GET:/organization-rate/procurement-rates
     */
    getProcurementRates: (params: RequestParams = {}) =>
      this.request<OrganizationProcurementRate[], any>({
        path: `/organization-rate/procurement-rates`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization Rate
     * @name OrganizationRateControllerGetSalesRates
     * @request GET:/organization-rate/sales-rates
     */
    getSalesRates: (params: RequestParams = {}) =>
      this.request<OrganizationSalesRate[], any>({
        path: `/organization-rate/sales-rates`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization Rate
     * @name OrganizationRateControllerDeleteProcurementRate
     * @request DELETE:/organization-rate/procurement-rate/{rateId}
     */
    deleteProcurementRate: (rateId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organization-rate/procurement-rate/${rateId}`,
        method: "DELETE",
        ...params,
      }),
  };
  relationRate = {
    /**
     * No description
     *
     * @tags Relation Rate
     * @name RelationRateControllerCreateSalesRate
     * @request POST:/relation-rate/sales-rate
     */
    createSalesRate: (data: CreateRelationSalesRateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/relation-rate/sales-rate`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation Rate
     * @name RelationRateControllerGetSalesRates
     * @request GET:/relation-rate/sales-rates/{relationId}
     */
    getSalesRates: (relationId: string, params: RequestParams = {}) =>
      this.request<RelationSalesRate[], any>({
        path: `/relation-rate/sales-rates/${relationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation Rate
     * @name RelationRateControllerGetAvailableUserFunctions
     * @request GET:/relation-rate/available-user-functions/{relationId}
     */
    getAvailableUserFunctions: (relationId: string, params: RequestParams = {}) =>
      this.request<UserFunction[], any>({
        path: `/relation-rate/available-user-functions/${relationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation Rate
     * @name RelationRateControllerDeleteSalesRate
     * @request DELETE:/relation-rate/sales-rate/{rateId}
     */
    deleteSalesRate: (rateId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/relation-rate/sales-rate/${rateId}`,
        method: "DELETE",
        ...params,
      }),
  };
  team = {
    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerGetAll
     * @request GET:/team
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: TeamFilterKeys;
        sort?: TeamSort;
        pagination?: PaginationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedTeam, any>({
        path: `/team`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerCreate
     * @request POST:/team
     */
    create: (data: TeamCreateInput, params: RequestParams = {}) =>
      this.request<TeamCreateInput, any>({
        path: `/team`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerGet
     * @request GET:/team/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<Team, any>({
        path: `/team/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerUpdate
     * @request PATCH:/team/{id}
     */
    update: (id: string, data: TeamUpdateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/team/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerDelete
     * @request DELETE:/team/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/team/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerArchive
     * @request PATCH:/team/{id}/archive
     */
    archive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/team/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerUnarchive
     * @request PATCH:/team/{id}/unarchive
     */
    unarchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/team/${id}/unarchive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Team
     * @name TeamControllerAddOrRemoveMembers
     * @request PATCH:/team/{id}/members
     */
    addOrRemoveMembers: (id: string, data: AddOrRemoveInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/team/${id}/members`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  messaging = {
    /**
     * No description
     *
     * @tags Messaging
     * @name MessagingControllerGetAvailableChannels
     * @summary Get available messaging channels
     * @request GET:/messaging/channels
     */
    getAvailableChannels: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/messaging/channels`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Messaging
     * @name MessagingControllerGetConversations
     * @summary Get user conversations
     * @request GET:/messaging/conversations
     */
    getConversations: (
      query?: {
        offset?: number;
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/messaging/conversations`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Messaging
     * @name MessagingControllerGetMessages
     * @summary Get messages for a conversation
     * @request GET:/messaging/conversations/{conversationId}/messages
     */
    getMessages: (
      conversationId: string,
      query?: {
        offset?: number;
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/messaging/conversations/${conversationId}/messages`,
        method: "GET",
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Messaging
     * @name MessagingControllerSendMessage
     * @summary Send a message
     * @request POST:/messaging/send
     */
    sendMessage: (data: SendMessageDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/messaging/send`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Messaging
     * @name MessagingControllerGetContacts
     * @summary Get messaging contacts
     * @request GET:/messaging/contacts
     */
    getContacts: (
      query?: {
        search?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/messaging/contacts`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  suggestedAction = {
    /**
     * Returns all available action types and their translation keys for frontend display
     *
     * @tags Suggested Action
     * @name SuggestedActionControllerGetActionTypes
     * @summary Get all suggested action types with translation keys
     * @request GET:/suggested-action/types
     */
    getActionTypes: (params: RequestParams = {}) =>
      this.request<ActionTypesResponse, any>({
        path: `/suggested-action/types`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * Accepts and queues a suggested action for processing
     *
     * @tags Suggested Action
     * @name SuggestedActionControllerAccept
     * @summary Accept a suggested action
     * @request POST:/suggested-action/{id}/accept
     */
    accept: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/suggested-action/${id}/accept`,
        method: "POST",
        ...params,
      }),

    /**
     * Rejects a suggested action and marks it as cancelled
     *
     * @tags Suggested Action
     * @name SuggestedActionControllerReject
     * @summary Reject a suggested action
     * @request POST:/suggested-action/{id}/reject
     */
    reject: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/suggested-action/${id}/reject`,
        method: "POST",
        ...params,
      }),
  };
  campaign = {
    /**
     * No description
     *
     * @tags campaign
     * @name CampaignControllerGetAll
     * @request GET:/campaign
     */
    getAll: (
      query?: {
        /** Filter supporting simple object or logical operations (AND/OR) for CampaignFilterKeys */
        filter?:
          | CampaignFilterKeys
          | (
              | {
                  AND?: CampaignFilterKeys[];
                }
              | {
                  OR?: CampaignFilterKeys[];
                }
            )[];
        /** Sort configuration */
        sort?: CampaignSort;
        pagination?: PaginationFilter;
        /** Relations to include */
        include?: CampaignInclude;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedCampaign, any>({
        path: `/campaign`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * Creates a new recruitment campaign. By default, includes rounds and targets. **Default
     * includes:** rounds, targets **Available includes:** organization, invitations, rounds,
     * targets **Response includes nested objects:** - `rounds`: Array of CampaignRound objects with
     * full round details - `targets`: Array of CampaignTarget objects with nested availabilitySlot,
     * shift, and project data - `metadata`: CampaignMetadata object with strategy and filters
     *
     * @tags campaign
     * @name CampaignControllerCreate
     * @summary Create a new campaign
     * @request POST:/campaign
     */
    create: (
      query: {
        include: string[];
      },
      data: CampaignCreateInput,
      params: RequestParams = {},
    ) =>
      this.request<CampaignCreateResponse, any>({
        path: `/campaign`,
        method: "POST",
        query: query,
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Retrieves a campaign by ID. By default, includes rounds and targets. **Default includes:**
     * rounds, targets **Available includes:** organization, invitations, rounds, targets **Response
     * includes nested objects:** - `rounds`: Array of CampaignRound objects with full round
     * details
     *
     * - `targets`: Array of CampaignTarget objects with nested availabilitySlot, shift, and project
     *   data - `metadata`: CampaignMetadata object with strategy and filters **Note:** Project
     *   information is now accessed through the targets relation (targets[].project)
     *
     * @tags campaign
     * @name CampaignControllerGet
     * @summary Get campaign by ID
     * @request GET:/campaign/{id}
     */
    get: (
      id: string,
      query: {
        include: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<CampaignGetResponse, any>({
        path: `/campaign/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags campaign
     * @name CampaignControllerUpdate
     * @request PATCH:/campaign/{id}
     */
    update: (id: string, data: CampaignUpdateInput, params: RequestParams = {}) =>
      this.request<Campaign, any>({
        path: `/campaign/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags campaign
     * @name CampaignControllerDelete
     * @request DELETE:/campaign/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<Campaign, any>({
        path: `/campaign/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * Activates the campaign and schedules the first round of recruitment messages
     *
     * @tags campaign
     * @name CampaignControllerStartCampaign
     * @summary Start a recruitment campaign
     * @request POST:/campaign/{id}/start
     */
    startCampaign: (id: string, params: RequestParams = {}) =>
      this.request<Campaign, any>({
        path: `/campaign/${id}/start`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * Deactivates the campaign and cancels all pending recruitment jobs
     *
     * @tags campaign
     * @name CampaignControllerStopCampaign
     * @summary Stop a recruitment campaign
     * @request POST:/campaign/{id}/stop
     */
    stopCampaign: (id: string, params: RequestParams = {}) =>
      this.request<Campaign, any>({
        path: `/campaign/${id}/stop`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * Returns basic recruitment statistics. Detailed application tracking is handled externally.
     *
     * @tags campaign
     * @name CampaignControllerGetStats
     * @summary Get recruitment statistics for a campaign
     * @request GET:/campaign/{id}/stats
     */
    getStats: (id: string, params: RequestParams = {}) =>
      this.request<CampaignStats, any>({
        path: `/campaign/${id}/stats`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * Returns all scheduled recruitment rounds and their status
     *
     * @tags campaign
     * @name CampaignControllerGetJobs
     * @summary Get scheduled jobs for a campaign
     * @request GET:/campaign/{id}/jobs
     */
    getJobs: (id: string, params: RequestParams = {}) =>
      this.request<CampaignJob[], any>({
        path: `/campaign/${id}/jobs`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * Cancels a scheduled recruitment round job
     *
     * @tags campaign
     * @name CampaignControllerCancelRound
     * @summary Cancel a specific recruitment round
     * @request DELETE:/campaign/{id}/rounds/{roundNumber}
     */
    cancelRound: (id: string, roundNumber: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/campaign/${id}/rounds/${roundNumber}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * Accepts a campaign invitation for an employee. **Process:** - Validates invitation exists and
     * is in PENDING or SENT state - Checks if target (shift/slot) is still available - For SHIFT:
     * assigns employee to the shift - For AVAILABILITY_SLOT: creates an Application with ACCEPTED
     * status - Updates invitation status to ACCEPTED **Note:** Can be called by the employee
     * themselves, admins, or programmatically (e.g., by the AI agent)
     *
     * @tags campaign
     * @name CampaignControllerAcceptInvitation
     * @summary Accept a campaign invitation
     * @request POST:/campaign/invitations/{id}/accept
     */
    acceptInvitation: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/campaign/invitations/${id}/accept`,
        method: "POST",
        ...params,
      }),

    /**
     * Declines a campaign invitation for an employee. **Process:** - Validates invitation exists
     * and is not already accepted - Updates invitation status to DECLINED - Does not modify shift
     * or availability slot assignments **Note:** Can be called by the employee themselves, admins,
     * or programmatically (e.g., by the AI agent)
     *
     * @tags campaign
     * @name CampaignControllerDeclineInvitation
     * @summary Decline a campaign invitation
     * @request POST:/campaign/invitations/{id}/decline
     */
    declineInvitation: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/campaign/invitations/${id}/decline`,
        method: "POST",
        ...params,
      }),
  };
  deeplink = {
    /**
     * Redirects to the appropriate app or web URL based on platform detection
     *
     * @tags Deeplink
     * @name DeeplinkControllerHandleAppDeeplink
     * @summary Handle app deep link
     * @request GET:/deeplink/{slug}/{path}
     */
    handleAppDeeplink: (
      slug: string,
      path: string,
      query?: {
        /** Additional query parameters */
        params?: object;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/deeplink/${slug}/${path}`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  messageTemplate = {
    /**
     * No description
     *
     * @tags message-template
     * @name MessageTemplateControllerGetAll
     * @request GET:/message-template
     */
    getAll: (
      query?: {
        /**
         * Filter supporting simple object or logical operations (AND/OR) for
         * MessageTemplateFilterKeys
         */
        filter?:
          | MessageTemplateFilterKeys
          | (
              | {
                  AND?: MessageTemplateFilterKeys[];
                }
              | {
                  OR?: MessageTemplateFilterKeys[];
                }
            )[];
        sort?: MessageTemplateSort;
        pagination?: PaginationFilter;
        include?: MessageTemplateInclude;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedMessageTemplate, any>({
        path: `/message-template`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * Creates a new message template and submits it to configured providers for approval. Returns
     * immediately with the template and pending provider statuses. **Channel parameter:** - If not
     * specified: Creates template for all WhatsApp providers (Twilio, Meta, Boomer) - WHATSAPP:
     * Creates template for Twilio and Meta WhatsApp providers - BOOMER: Creates template for
     * internal Boomer chat only (no external approval needed) - SMS: Creates template for Twilio
     * SMS endpoints - EMAIL: Creates template for SendGrid provider Templates for external
     * providers (WhatsApp, SMS) require approval before use.
     *
     * @tags message-template
     * @name MessageTemplateControllerCreate
     * @summary Create message template
     * @request POST:/message-template
     */
    create: (data: CreateTemplateInput, params: RequestParams = {}) =>
      this.request<MessageTemplateEntity, any>({
        path: `/message-template`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Fuzzy search for templates by name and text using PostgreSQL trigram similarity. Returns
     * results sorted by relevance score.
     *
     * @tags message-template
     * @name MessageTemplateControllerSearch
     * @summary Search templates
     * @request GET:/message-template/search
     */
    search: (
      query: {
        /**
         * Search query for fuzzy matching against template name and text
         *
         * @example
         *   invite;
         *
         * @minLength 2
         */
        query: string;
        /**
         * Maximum number of results to return
         *
         * @default 20
         * @min 1
         * @max 100
         */
        limit?: number;
        /**
         * Minimum similarity threshold (0.0 to 1.0)
         *
         * @default 0.1
         */
        threshold?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<MessageTemplateSearchResponse, any>({
        path: `/message-template/search`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * Fetches all templates from configured WhatsApp providers (Twilio, Meta) and syncs them with
     * the database. Updates existing template statuses, creates new templates found on providers,
     * and marks templates as failed if they no longer exist on the provider or have invalid
     * variables.
     *
     * @tags message-template
     * @name MessageTemplateControllerRefresh
     * @summary Refresh templates from providers
     * @request POST:/message-template/refresh
     */
    refresh: (params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
          summary?: {
            providersChecked?: number;
            templatesUpdated?: number;
            templatesCreated?: number;
            templatesFailed?: number;
            errors?: string[];
          };
        },
        any
      >({
        path: `/message-template/refresh`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * Returns the complete template/folder structure optimized for client-side autocomplete.
     * Includes pre-computed indexes for instant filtering by ID, parent, and path.
     *
     * @tags message-template
     * @name MessageTemplateControllerGetStructure
     * @summary Get template structure for autocomplete
     * @request GET:/message-template/structure
     */
    getStructure: (params: RequestParams = {}) =>
      this.request<TemplateStructureResponseEntity, any>({
        path: `/message-template/structure`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * Analyzes a template to determine what entities (shift, project, availability slot) are
     * required for sending from a conversation. Returns information about required selections,
     * auto-resolved entities, variables, and any warnings. **Use this endpoint to:** - Determine if
     * a template can be sent directly or needs entity selection - Get the list of variables for
     * manual text entry - Check for warnings about campaign-only templates
     *
     * @tags message-template
     * @name MessageTemplateControllerAnalyzeContext
     * @summary Analyze template context requirements
     * @request GET:/message-template/{id}/analyze-context
     */
    analyzeContext: (id: string, params: RequestParams = {}) =>
      this.request<AnalyzeContextResultDto, any>({
        path: `/message-template/${id}/analyze-context`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * Returns a single template or folder by ID.
     *
     * @tags message-template
     * @name MessageTemplateControllerGetById
     * @summary Get single template or folder
     * @request GET:/message-template/{id}
     */
    getById: (id: string, params: RequestParams = {}) =>
      this.request<MessageTemplateEntity, any>({
        path: `/message-template/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * Updates a template or folder name, description, or sort order.
     *
     * @tags message-template
     * @name MessageTemplateControllerUpdate
     * @summary Update template or folder
     * @request PATCH:/message-template/{id}
     */
    update: (id: string, data: UpdateTemplateInput, params: RequestParams = {}) =>
      this.request<MessageTemplateEntity, any>({
        path: `/message-template/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Deletes a template or folder. Deleting a folder cascades to all its contents.
     *
     * @tags message-template
     * @name MessageTemplateControllerDelete
     * @summary Delete template or folder
     * @request DELETE:/message-template/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          success?: boolean;
        },
        any
      >({
        path: `/message-template/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * Creates a new folder within the template hierarchy.
     *
     * @tags message-template
     * @name MessageTemplateControllerCreateFolder
     * @summary Create folder
     * @request POST:/message-template/folder
     */
    createFolder: (data: CreateFolderInput, params: RequestParams = {}) =>
      this.request<MessageTemplateEntity, any>({
        path: `/message-template/folder`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Moves a template or folder to a different parent folder. Updates paths for the item and all
     * descendants.
     *
     * @tags message-template
     * @name MessageTemplateControllerMove
     * @summary Move template or folder
     * @request POST:/message-template/{id}/move
     */
    move: (id: string, data: MoveTemplateInput, params: RequestParams = {}) =>
      this.request<MessageTemplateEntity, any>({
        path: `/message-template/${id}/move`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Analyzes template text and buttons to identify variables and determine required context.
     * Returns information about each variable, what data tables are required for the template to
     * work, and warnings about variables that need specific context when sending.
     *
     * @tags message-template
     * @name MessageTemplateControllerValidateVariables
     * @summary Validate template variables
     * @request POST:/message-template/validate-variables
     */
    validateVariables: (data: ValidateTemplateVariablesInput, params: RequestParams = {}) =>
      this.request<ValidateTemplateVariablesResult, any>({
        path: `/message-template/validate-variables`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  organizationSettings = {
    /**
     * No description
     *
     * @tags Organization Settings
     * @name OrganizationSettingsControllerGetFeatureFlags
     * @request GET:/organization-settings/feature-flags
     */
    getFeatureFlags: (params: RequestParams = {}) =>
      this.request<FeatureFlagsResponse, any>({
        path: `/organization-settings/feature-flags`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization Settings
     * @name OrganizationSettingsControllerUpdateFeatureFlags
     * @request PUT:/organization-settings/{organizationId}
     */
    updateFeatureFlags: (
      organizationId: string,
      data: UpdateFeatureFlagsDto,
      params: RequestParams = {},
    ) =>
      this.request<FeatureFlagsResponse, any>({
        path: `/organization-settings/${organizationId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  conversationCrud = {
    /**
     * Returns the number of conversations that have at least one unread message for the current
     * user
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerGetUnreadConversationsCount
     * @summary Get count of conversations with unread messages
     * @request GET:/conversation-crud/unread-count
     * @secure
     */
    getUnreadConversationsCount: (params: RequestParams = {}) =>
      this.request<
        {
          /** Number of conversations with unread messages */
          count?: number;
        },
        any
      >({
        path: `/conversation-crud/unread-count`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerGetAll
     * @summary Get all conversations with complex query support
     * @request GET:/conversation-crud
     * @secure
     */
    getAll: (
      query?: {
        /** Filter supporting simple object or logical operations (AND/OR) for ConversationFilterKeys */
        filter?:
          | ConversationFilterKeys
          | (
              | {
                  AND?: ConversationFilterKeys[];
                }
              | {
                  OR?: ConversationFilterKeys[];
                }
            )[];
        sort?: ConversationSort;
        pagination?: PaginationFilter;
        include?: ConversationInclude;
        aggregate?: ConversationAggregateKeys;
        /**
         * Filter conversations by assigned admin user IDs (shorthand for entityTags filter)
         *
         * @example
         *   {undefined}
         *   "admin-user-id-1", "admin-user-id-2";
         */
        targetAdminUserId?: string[];
        /**
         * Filter conversations by linked project IDs (shorthand for entityTags filter)
         *
         * @example
         *   {undefined}
         *   "project-id-1", "project-id-2";
         */
        targetProjectId?: string[];
        /**
         * Filter conversations by conversation label tags (CANCELLATION, CAMPAIGN, HR, ONBOARDING,
         * GENERAL)
         *
         * @example
         *   {undefined}
         *   "CANCELLATION", "CAMPAIGN";
         */
        targetConversationLabel?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedConversation, any>({
        path: `/conversation-crud`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerCreate
     * @summary Create new conversation
     * @request POST:/conversation-crud
     * @secure
     */
    create: (data: ConversationCreateInput, params: RequestParams = {}) =>
      this.request<ConversationWithPreview, any>({
        path: `/conversation-crud`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerGet
     * @summary Get single conversation by ID
     * @request GET:/conversation-crud/{id}
     * @secure
     */
    get: (
      id: string,
      query?: {
        /** Filter supporting simple object or logical operations (AND/OR) for ConversationFilterKeys */
        filter?:
          | ConversationFilterKeys
          | (
              | {
                  AND?: ConversationFilterKeys[];
                }
              | {
                  OR?: ConversationFilterKeys[];
                }
            )[];
        sort?: ConversationSort;
        pagination?: PaginationFilter;
        include?: ConversationInclude;
        aggregate?: ConversationAggregateKeys;
        /**
         * Filter conversations by assigned admin user IDs (shorthand for entityTags filter)
         *
         * @example
         *   {undefined}
         *   "admin-user-id-1", "admin-user-id-2";
         */
        targetAdminUserId?: string[];
        /**
         * Filter conversations by linked project IDs (shorthand for entityTags filter)
         *
         * @example
         *   {undefined}
         *   "project-id-1", "project-id-2";
         */
        targetProjectId?: string[];
        /**
         * Filter conversations by conversation label tags (CANCELLATION, CAMPAIGN, HR, ONBOARDING,
         * GENERAL)
         *
         * @example
         *   {undefined}
         *   "CANCELLATION", "CAMPAIGN";
         */
        targetConversationLabel?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<ConversationWithPreview, any>({
        path: `/conversation-crud/${id}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerUpdate
     * @summary Update conversation
     * @request PATCH:/conversation-crud/{id}
     * @secure
     */
    update: (id: string, data: ConversationUpdateInput, params: RequestParams = {}) =>
      this.request<ConversationWithPreview, any>({
        path: `/conversation-crud/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerDelete
     * @summary Archive conversation (soft delete)
     * @request DELETE:/conversation-crud/{id}
     * @secure
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/conversation-crud/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * Creates a DIRECT conversation for an employee with all organization managers as participants.
     * If a direct conversation already exists for the employee, returns the existing one. This
     * endpoint is only available to employees.
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerCreateEmployeeDirectConversation
     * @summary Create a direct conversation between employee and company managers
     * @request POST:/conversation-crud/employee-direct
     * @secure
     */
    createEmployeeDirectConversation: (params: RequestParams = {}) =>
      this.request<ConversationWithPreview, any>({
        path: `/conversation-crud/employee-direct`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Creates a BROADCAST conversation linked to a project. All employees assigned to shifts in the
     * project are automatically added as participants. If a BROADCAST conversation already exists
     * for the project, returns the existing one.
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerCreateProjectBroadcast
     * @summary Create a BROADCAST conversation for a project
     * @request POST:/conversation-crud/project-broadcast
     * @secure
     */
    createProjectBroadcast: (data: ProjectBroadcastCreateInput, params: RequestParams = {}) =>
      this.request<ConversationWithPreview, any>({
        path: `/conversation-crud/project-broadcast`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerMarkAllRead
     * @summary Mark all messages in conversation as read
     * @request POST:/conversation-crud/{id}/mark-read
     * @secure
     */
    markAllRead: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/conversation-crud/${id}/mark-read`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * Triggers full agent processing pipeline using the most recent employee message. Invalidates
     * suggested actions created after that message and runs the full agent pipeline.
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerAgentReload
     * @summary Reload agent processing for conversation
     * @request POST:/conversation-crud/{id}/agent-reload
     * @secure
     */
    agentReload: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          status?: "processing" | "error";
          error?: string | null;
        },
        any
      >({
        path: `/conversation-crud/${id}/agent-reload`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Sends the suggested message (optionally edited). Tracks analytics if message was edited. Adds
     * message to conversation cache.
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerSendSuggestedMessage
     * @summary Send the suggested message for a conversation
     * @request POST:/conversation-crud/{id}/suggested-message
     * @secure
     */
    sendSuggestedMessage: (
      id: string,
      data: SendSuggestedMessageInput,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/conversation-crud/${id}/suggested-message`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Removes the current suggested message (accept or reject flow); does not emit a conversation
     * update event.
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerClearSuggestedMessage
     * @summary Clear the suggested message for a conversation
     * @request DELETE:/conversation-crud/{id}/suggested-message
     * @secure
     */
    clearSuggestedMessage: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/conversation-crud/${id}/suggested-message`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * Returns the time remaining in the 24-hour sliding window. The window is calculated from the
     * last employee-sent message.
     *
     * @tags Conversation CRUD
     * @name ConversationCrudControllerGetConversationWindow
     * @summary Get conversation window status
     * @request GET:/conversation-crud/{id}/conversation-window
     * @secure
     */
    getConversationWindow: (id: string, params: RequestParams = {}) =>
      this.request<
        {
          /** Seconds remaining in the conversation window */
          timeRemainingSeconds?: number;
          /**
           * Timestamp when the window started (last employee message)
           *
           * @format date-time
           */
          windowStartTime?: string | null;
        },
        any
      >({
        path: `/conversation-crud/${id}/conversation-window`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  messageCrud = {
    /**
     * No description
     *
     * @tags Message CRUD
     * @name MessageCrudControllerGetAll
     * @summary Get all messages with complex query support
     * @request GET:/message-crud
     * @secure
     */
    getAll: (
      query?: {
        /** Filter supporting simple object or logical operations (AND/OR) for MessageFilterKeys */
        filter?:
          | MessageFilterKeys
          | (
              | {
                  AND?: MessageFilterKeys[];
                }
              | {
                  OR?: MessageFilterKeys[];
                }
            )[];
        sort?: MessageSort;
        pagination?: PaginationFilter;
        include?: MessageInclude;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedMessage, any>({
        path: `/message-crud`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message CRUD
     * @name MessageCrudControllerCreate
     * @summary Create new message
     * @request POST:/message-crud
     * @secure
     */
    create: (data: MessageCreateInput, params: RequestParams = {}) =>
      this.request<MessageWithSender, any>({
        path: `/message-crud`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message CRUD
     * @name MessageCrudControllerGet
     * @summary Get single message by ID
     * @request GET:/message-crud/{id}
     * @secure
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<MessageWithSender, any>({
        path: `/message-crud/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message CRUD
     * @name MessageCrudControllerUpdate
     * @summary Update message
     * @request PATCH:/message-crud/{id}
     * @secure
     */
    update: (id: string, data: MessageUpdateInput, params: RequestParams = {}) =>
      this.request<MessageWithSender, any>({
        path: `/message-crud/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message CRUD
     * @name MessageCrudControllerDelete
     * @summary Delete message
     * @request DELETE:/message-crud/{id}
     * @secure
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/message-crud/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Message CRUD
     * @name MessageCrudControllerMarkAsRead
     * @summary Mark multiple messages as read
     * @request POST:/message-crud/mark-read
     * @secure
     */
    markAsRead: (data: MarkReadInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/message-crud/mark-read`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  permissions = {
    /**
     * No description
     *
     * @tags Permissions
     * @name PermissionControllerGetAll
     * @request GET:/permissions
     */
    getAll: (params: RequestParams = {}) =>
      this.request<PermissionResponse, any>({
        path: `/permissions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name PermissionControllerGetMyPermissions
     * @request GET:/permissions/my-permissions
     */
    getMyPermissions: (params: RequestParams = {}) =>
      this.request<PermissionResponse, any>({
        path: `/permissions/my-permissions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name PermissionControllerGetPermissionsForUser
     * @request GET:/permissions/user/{id}
     */
    getPermissionsForUser: (id: string, params: RequestParams = {}) =>
      this.request<PermissionResponse, any>({
        path: `/permissions/user/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name PermissionControllerUpdatePermissionsForUser
     * @request PATCH:/permissions/user/{id}
     */
    updatePermissionsForUser: (
      id: string,
      data: UpdateUserPermissionInput,
      params: RequestParams = {},
    ) =>
      this.request<PermissionResponse, any>({
        path: `/permissions/user/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  errorCodes = {
    /**
     * No description
     *
     * @tags Error Codes
     * @name ErrorCodesControllerGetAll
     * @request GET:/error-codes
     */
    getAll: (params: RequestParams = {}) =>
      this.request<ErrorCodesResponseDto, any>({
        path: `/error-codes`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  redirect = {
    /**
     * No description
     *
     * @tags Redirect
     * @name RedirectControllerHandleRedirect
     * @request GET:/redirect/forgot-password
     */
    handleRedirect: (
      query: {
        /** The email of the user */
        email: string;
        /** The token of the user */
        token: string;
        /**
         * Optional app slug to redirect to. If not provided, will use cookie or fallback to
         * organization config
         */
        appSlug?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/redirect/forgot-password`,
        method: "GET",
        query: query,
        ...params,
      }),
  };
  invitation = {
    /**
     * No description
     *
     * @tags Invitation
     * @name InviteControllerGetAll
     * @request GET:/invitation
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: InvitationFilterKeys;
        sort?: InvitationSort;
        pagination?: PaginationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInvitation, any>({
        path: `/invitation`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitation
     * @name InviteControllerInvite
     * @request POST:/invitation
     */
    invite: (data: InvitationInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invitation`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitation
     * @name InviteControllerCreateEmployeeWithDefaultAccount
     * @request POST:/invitation/create-employee-with-default-account
     */
    createEmployeeWithDefaultAccount: (
      data: EmployeeWithDefaultAccountInput,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/invitation/create-employee-with-default-account`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitation
     * @name InviteControllerInviteMany
     * @request POST:/invitation/many
     */
    inviteMany: (data: InvitationManyInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invitation/many`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitation
     * @name InviteControllerValidateInvitation
     * @request GET:/invitation/validate/{token}
     */
    validateInvitation: (token: string, params: RequestParams = {}) =>
      this.request<Invitation, any>({
        path: `/invitation/validate/${token}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitation
     * @name InviteControllerResend
     * @request POST:/invitation/resend/{id}
     */
    resend: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invitation/resend/${id}`,
        method: "POST",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invitation
     * @name InviteControllerDelete
     * @request DELETE:/invitation/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invitation/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  organizationConfig = {
    /**
     * No description
     *
     * @tags Organization Config
     * @name OrganizationConfigControllerUploadAsset
     * @request POST:/organization-config/asset
     */
    uploadAsset: (
      data: {
        /** @format binary */
        file?: File;
        assetType?:
          | "android-chrome-192x192.png"
          | "android-chrome-512x512.png"
          | "apple-touch-icon.png"
          | "favicon-16x16.png"
          | "favicon-32x32.png"
          | "favicon-48x48.png"
          | "favicon.ico"
          | "maskable.png"
          | "mstile-150x150.png"
          | "safari-pinned-tab.svg";
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/organization-config/asset`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization Config
     * @name OrganizationConfigControllerGetAssetUrls
     * @request GET:/organization-config/assets
     */
    getAssetUrls: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/organization-config/assets`,
        method: "GET",
        ...params,
      }),
  };
  themeConfig = {
    /**
     * No description
     *
     * @tags Theme Config
     * @name ThemeConfigControllerGet
     * @request GET:/theme-config
     */
    get: (params: RequestParams = {}) =>
      this.request<ThemeConfig, any>({
        path: `/theme-config`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Theme Config
     * @name ThemeConfigControllerGetBySlug
     * @request GET:/theme-config/by-slug
     */
    getBySlug: (
      query: {
        slug: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ThemeConfig, any>({
        path: `/theme-config/by-slug`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),
  };
  organization = {
    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetMyOrganization
     * @request GET:/organization/my-organization
     */
    getMyOrganization: (params: RequestParams = {}) =>
      this.request<Organization, any>({
        path: `/organization/my-organization`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerUpdateMyOrganization
     * @request PATCH:/organization/my-organization
     */
    updateMyOrganization: (data: OrganizationUpdateInput, params: RequestParams = {}) =>
      this.request<Organization, any>({
        path: `/organization/my-organization`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerGetById
     * @request GET:/organization/{id}
     */
    getById: (id: string, params: RequestParams = {}) =>
      this.request<Organization, any>({
        path: `/organization/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerUpdate
     * @request PATCH:/organization/{id}
     */
    update: (id: string, data: OrganizationUpdateInput, params: RequestParams = {}) =>
      this.request<OrganizationUpdateInput, any>({
        path: `/organization/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organization
     * @name OrganizationControllerCreate
     * @request POST:/organization
     */
    create: (data: OrganizationCreateInput, params: RequestParams = {}) =>
      this.request<OrganizationCreateInput, any>({
        path: `/organization`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  me = {
    /**
     * No description
     *
     * @tags Me
     * @name MeControllerGetMe
     * @request GET:/me
     */
    getMe: (params: RequestParams = {}) =>
      this.request<Me, any>({
        path: `/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name MeControllerUpdateMe
     * @request PATCH:/me
     */
    updateMe: (data: UpdateMeInput, params: RequestParams = {}) =>
      this.request<Me, any>({
        path: `/me`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name MeControllerGetMyOrganizations
     * @request GET:/me/organizations
     */
    getMyOrganizations: (params: RequestParams = {}) =>
      this.request<
        {
          organizations?: {
            id?: string;
            name?: string;
            slug?: string;
            image?: string | null;
            isPrimary?: boolean;
          }[];
          activeOrganizationId?: string;
        },
        any
      >({
        path: `/me/organizations`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Me
     * @name MeControllerUpdateProfilePicture
     * @request PATCH:/me/profile-picture
     */
    updateProfilePicture: (
      data: {
        /**
         * Profile picture file (image)
         *
         * @format binary
         */
        file?: File;
      },
      params: RequestParams = {},
    ) =>
      this.request<Me, any>({
        path: `/me/profile-picture`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  adminUser = {
    /**
     * No description
     *
     * @tags AdminUser
     * @name AdminUserControllerGetAll
     * @request GET:/admin-user
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: AdminUserFilterKeys;
        sort?: AdminUserSort;
        pagination?: PaginationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAdminUser, any>({
        path: `/admin-user`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUser
     * @name AdminUserControllerGet
     * @request GET:/admin-user/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<AdminUser, any>({
        path: `/admin-user/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUser
     * @name AdminUserControllerUpdate
     * @request PATCH:/admin-user/{id}
     */
    update: (id: string, data: AdminUserUpdateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin-user/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUser
     * @name AdminUserControllerDelete
     * @request DELETE:/admin-user/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin-user/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUser
     * @name AdminUserControllerArchive
     * @request PATCH:/admin-user/{id}/archive
     */
    archive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin-user/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags AdminUser
     * @name AdminUserControllerUnarchive
     * @request PATCH:/admin-user/{id}/unarchive
     */
    unarchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/admin-user/${id}/unarchive`,
        method: "PATCH",
        ...params,
      }),
  };
  relationUser = {
    /**
     * No description
     *
     * @tags Relation User
     * @name RelationUserControllerGetAll
     * @request GET:/relation-user
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: RelationUserFilterKeys;
        sort?: RelationUserSort;
        pagination?: PaginationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRelationUser, any>({
        path: `/relation-user`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation User
     * @name RelationUserControllerGet
     * @request GET:/relation-user/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<RelationUser, any>({
        path: `/relation-user/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation User
     * @name RelationUserControllerUpdate
     * @request PATCH:/relation-user/{id}
     */
    update: (id: string, data: RelationUserUpdateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/relation-user/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation User
     * @name RelationUserControllerDelete
     * @request DELETE:/relation-user/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/relation-user/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation User
     * @name RelationUserControllerArchive
     * @request PATCH:/relation-user/{id}/archive
     */
    archive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/relation-user/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation User
     * @name RelationUserControllerUnarchive
     * @request PATCH:/relation-user/{id}/unarchive
     */
    unarchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/relation-user/${id}/unarchive`,
        method: "PATCH",
        ...params,
      }),
  };
  freelanceEmployee = {
    /**
     * No description
     *
     * @tags FreelanceEmployee
     * @name FreelanceEmployeeControllerGet
     * @request GET:/freelance-employee/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<FreelanceEmployee, any>({
        path: `/freelance-employee/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FreelanceEmployee
     * @name FreelanceEmployeeControllerUpdate
     * @request PUT:/freelance-employee/{id}
     */
    update: (id: string, data: FreelanceEmployeeInput, params: RequestParams = {}) =>
      this.request<FreelanceEmployee, any>({
        path: `/freelance-employee/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags FreelanceEmployee
     * @name FreelanceEmployeeControllerDelete
     * @request DELETE:/freelance-employee/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/freelance-employee/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  userOrganization = {
    /**
     * No description
     *
     * @tags User Organization
     * @name UserOrganizationControllerGet
     * @summary Get user organization note
     * @request GET:/user-organization/{userId}/note
     */
    get: (userId: string, params: RequestParams = {}) =>
      this.request<UserOrganization, void>({
        path: `/user-organization/${userId}/note`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Organization
     * @name UserOrganizationControllerUpdate
     * @summary Update user organization note
     * @request PATCH:/user-organization/{userId}/note
     */
    update: (userId: string, data: UserOrganizationUpdateInput, params: RequestParams = {}) =>
      this.request<UserOrganization, void>({
        path: `/user-organization/${userId}/note`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  userFunction = {
    /**
     * No description
     *
     * @tags User Function
     * @name UserFunctionControllerGetAll
     * @request GET:/user-function
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: UserFunctionFilterKeys;
        sort?: UserFunctionSort;
        pagination?: PaginationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedUserFunction, any>({
        path: `/user-function`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Function
     * @name UserFunctionControllerCreate
     * @request POST:/user-function
     */
    create: (data: UserFunctionCreateInput, params: RequestParams = {}) =>
      this.request<UserFunctionCreateInput, any>({
        path: `/user-function`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Function
     * @name UserFunctionControllerGetMyFunctions
     * @request GET:/user-function/my-functions
     */
    getMyFunctions: (params: RequestParams = {}) =>
      this.request<UserFunction[], any>({
        path: `/user-function/my-functions`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Function
     * @name UserFunctionControllerGet
     * @request GET:/user-function/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<UserFunction, any>({
        path: `/user-function/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Function
     * @name UserFunctionControllerUpdate
     * @request PATCH:/user-function/{id}
     */
    update: (id: string, data: UserFunctionUpdateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user-function/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Function
     * @name UserFunctionControllerDelete
     * @request DELETE:/user-function/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user-function/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Function
     * @name UserFunctionControllerArchive
     * @request PATCH:/user-function/{id}/archive
     */
    archive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user-function/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Function
     * @name UserFunctionControllerUnarchive
     * @request PATCH:/user-function/{id}/unarchive
     */
    unarchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user-function/${id}/unarchive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags User Function
     * @name UserFunctionControllerAddOrRemoveMembers
     * @request PATCH:/user-function/{id}/members
     */
    addOrRemoveMembers: (id: string, data: AddOrRemoveInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/user-function/${id}/members`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  relation = {
    /**
     * No description
     *
     * @tags Relation
     * @name RelationControllerGetAll
     * @request GET:/relation
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: RelationFilterKeys;
        sort?: RelationSort;
        pagination?: PaginationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedRelation, any>({
        path: `/relation`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name RelationControllerCreate
     * @request POST:/relation
     */
    create: (data: RelationCreateInput, params: RequestParams = {}) =>
      this.request<RelationCreateInput, any>({
        path: `/relation`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name RelationControllerGet
     * @request GET:/relation/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<Relation, any>({
        path: `/relation/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name RelationControllerUpdate
     * @request PATCH:/relation/{id}
     */
    update: (id: string, data: RelationUpdateInput, params: RequestParams = {}) =>
      this.request<RelationUpdateInput, any>({
        path: `/relation/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name RelationControllerDelete
     * @request DELETE:/relation/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/relation/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name RelationControllerArchive
     * @request PATCH:/relation/{id}/archive
     */
    archive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/relation/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation
     * @name RelationControllerUnarchive
     * @request PATCH:/relation/{id}/unarchive
     */
    unarchive: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/relation/${id}/unarchive`,
        method: "PATCH",
        ...params,
      }),
  };
  relationContact = {
    /**
     * No description
     *
     * @tags Relation Contact
     * @name ContactControllerGetAll
     * @request GET:/relation-contact/{relationId}
     */
    getAll: (relationId: string, params: RequestParams = {}) =>
      this.request<Contact[], any>({
        path: `/relation-contact/${relationId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation Contact
     * @name ContactControllerCreate
     * @request POST:/relation-contact/{relationId}
     */
    create: (relationId: string, data: ContactCreateUpdateInput, params: RequestParams = {}) =>
      this.request<Contact, any>({
        path: `/relation-contact/${relationId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation Contact
     * @name ContactControllerUpdate
     * @request PATCH:/relation-contact/{relationId}/{id}
     */
    update: (
      relationId: string,
      id: string,
      data: ContactCreateUpdateInput,
      params: RequestParams = {},
    ) =>
      this.request<Contact, any>({
        path: `/relation-contact/${relationId}/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Relation Contact
     * @name ContactControllerDelete
     * @request DELETE:/relation-contact/{relationId}/{id}
     */
    delete: (relationId: string, id: string, params: RequestParams = {}) =>
      this.request<Contact, any>({
        path: `/relation-contact/${relationId}/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),
  };
  customFields = {
    /**
     * No description
     *
     * @tags Custom Fields
     * @name CustomFieldsControllerGetAll
     * @request GET:/custom-fields/{entityType}/{entityId}
     */
    getAll: (entityType: string, entityId: string, params: RequestParams = {}) =>
      this.request<CustomField[], any>({
        path: `/custom-fields/${entityType}/${entityId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Fields
     * @name CustomFieldsControllerGet
     * @request GET:/custom-fields/{entityType}/{entityId}/{definitionId}
     */
    get: (entityType: string, entityId: string, definitionId: string, params: RequestParams = {}) =>
      this.request<CustomField, any>({
        path: `/custom-fields/${entityType}/${entityId}/${definitionId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Fields
     * @name CustomFieldsControllerUpdate
     * @request POST:/custom-fields/{entityType}/{entityId}/{definitionId}
     */
    update: (
      entityType: string,
      entityId: string,
      definitionId: string,
      data: CustomFieldValueInput,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/custom-fields/${entityType}/${entityId}/${definitionId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Fields
     * @name CustomFieldsControllerReset
     * @request DELETE:/custom-fields/{entityType}/{entityId}/{definitionId}
     */
    reset: (
      entityType: string,
      entityId: string,
      definitionId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/custom-fields/${entityType}/${entityId}/${definitionId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Fields
     * @name CustomFieldsControllerUploadFile
     * @request POST:/custom-fields/{entityType}/{entityId}/{definitionId}/file
     */
    uploadFile: (
      entityType: string,
      entityId: string,
      definitionId: string,
      data: CustomFieldValueFileInput,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/custom-fields/${entityType}/${entityId}/${definitionId}/file`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),
  };
  customFieldDefinitions = {
    /**
     * No description
     *
     * @tags Custom Field Definitions
     * @name CustomFieldDefinitionsControllerCreate
     * @request POST:/custom-field-definitions/{entityType}
     */
    create: (
      entityType: string,
      data: CreateCustomFieldDefinitionInput,
      params: RequestParams = {},
    ) =>
      this.request<CustomFieldDefinition, any>({
        path: `/custom-field-definitions/${entityType}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Field Definitions
     * @name CustomFieldDefinitionsControllerGetAll
     * @request GET:/custom-field-definitions/{entityType}
     */
    getAll: (entityType: string, params: RequestParams = {}) =>
      this.request<CustomFieldDefinition[], any>({
        path: `/custom-field-definitions/${entityType}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Field Definitions
     * @name CustomFieldDefinitionsControllerGet
     * @request GET:/custom-field-definitions/{entityType}/{id}
     */
    get: (entityType: string, id: string, params: RequestParams = {}) =>
      this.request<CustomFieldDefinition, any>({
        path: `/custom-field-definitions/${entityType}/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Field Definitions
     * @name CustomFieldDefinitionsControllerUpdate
     * @request PATCH:/custom-field-definitions/{entityType}/{id}
     */
    update: (
      entityType: string,
      id: string,
      data: UpdateCustomFieldDefinitionInput,
      params: RequestParams = {},
    ) =>
      this.request<CustomFieldDefinition, any>({
        path: `/custom-field-definitions/${entityType}/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Field Definitions
     * @name CustomFieldDefinitionsControllerDelete
     * @request DELETE:/custom-field-definitions/{entityType}/{id}
     */
    delete: (entityType: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/custom-field-definitions/${entityType}/${id}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Field Definitions
     * @name CustomFieldDefinitionsControllerArchive
     * @request PATCH:/custom-field-definitions/{entityType}/{id}/archive
     */
    archive: (entityType: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/custom-field-definitions/${entityType}/${id}/archive`,
        method: "PATCH",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Custom Field Definitions
     * @name CustomFieldDefinitionsControllerUnarchive
     * @request PATCH:/custom-field-definitions/{entityType}/{id}/unarchive
     */
    unarchive: (entityType: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/custom-field-definitions/${entityType}/${id}/unarchive`,
        method: "PATCH",
        ...params,
      }),
  };
  document = {
    /**
     * No description
     *
     * @tags Document
     * @name DocumentControllerGetAll
     * @request GET:/document/{entityType}/{entityId}
     */
    getAll: (entityType: string, entityId: string, params: RequestParams = {}) =>
      this.request<PaginatedDocument, any>({
        path: `/document/${entityType}/${entityId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentControllerUpload
     * @request POST:/document/{entityType}/{entityId}
     */
    upload: (
      entityType: string,
      entityId: string,
      data: DocumentCreateInput,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/document/${entityType}/${entityId}`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Document
     * @name DocumentControllerDeleteFile
     * @request DELETE:/document/{entityType}/{entityId}/{documentId}
     */
    deleteFile: (
      entityType: string,
      entityId: string,
      documentId: string,
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/document/${entityType}/${entityId}/${documentId}`,
        method: "DELETE",
        ...params,
      }),
  };
  availabilitySlot = {
    /**
     * No description
     *
     * @tags Availability Slot
     * @name AvailabilitySlotControllerGetAll
     * @request GET:/availability-slot
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: AvailabilitySlotFilterKeys;
        sort?: AvailabilitySlotSort;
        pagination?: PaginationFilter;
        include?: AvailabilitySlotInclude;
        aggregate?: AvailabilitySlotAggregateKeys;
        /**
         * Only show slots that have available capacity or allow reserves
         *
         * @default false
         */
        onlyShowOpenSlots?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAvailabilitySlot, any>({
        path: `/availability-slot`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Availability Slot
     * @name AvailabilitySlotControllerCreate
     * @request POST:/availability-slot
     */
    create: (data: AvailabilitySlotCreateInput, params: RequestParams = {}) =>
      this.request<AvailabilitySlotCreateInput, any>({
        path: `/availability-slot`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Availability Slot
     * @name AvailabilitySlotControllerGetAllByProject
     * @request GET:/availability-slot/project/{id}
     */
    getAllByProject: (
      id: string,
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: AvailabilitySlotFilterKeys;
        sort?: AvailabilitySlotSort;
        pagination?: PaginationFilter;
        include?: AvailabilitySlotInclude;
        aggregate?: AvailabilitySlotAggregateKeys;
        /**
         * Only show slots that have available capacity or allow reserves
         *
         * @default false
         */
        onlyShowOpenSlots?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedAvailabilitySlot, any>({
        path: `/availability-slot/project/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Availability Slot
     * @name AvailabilitySlotControllerCreateBulk
     * @request POST:/availability-slot/bulk
     */
    createBulk: (data: AvailabilitySlotBulkCreateInput, params: RequestParams = {}) =>
      this.request<AvailabilitySlot[], any>({
        path: `/availability-slot/bulk`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Availability Slot
     * @name AvailabilitySlotControllerDeleteBulk
     * @request DELETE:/availability-slot/bulk
     */
    deleteBulk: (data: AvailabilitySlotBulkDeleteInput, params: RequestParams = {}) =>
      this.request<
        {
          /** Number of deleted availability slots */
          count?: number;
        },
        any
      >({
        path: `/availability-slot/bulk`,
        method: "DELETE",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Availability Slot
     * @name AvailabilitySlotControllerGet
     * @request GET:/availability-slot/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<AvailabilitySlot, any>({
        path: `/availability-slot/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Availability Slot
     * @name AvailabilitySlotControllerUpdate
     * @request PATCH:/availability-slot/{id}
     */
    update: (id: string, data: AvailabilitySlotUpdateInput, params: RequestParams = {}) =>
      this.request<AvailabilitySlotUpdateInput, any>({
        path: `/availability-slot/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Availability Slot
     * @name AvailabilitySlotControllerDelete
     * @request DELETE:/availability-slot/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/availability-slot/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  billing = {
    /**
     * No description
     *
     * @tags Billing
     * @name BillingControllerGetAll
     * @request GET:/billing/billing-info
     */
    getAll: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: ProjectFilterKeys;
        sort?: ProjectSort;
        pagination?: PaginationFilter;
        include?: ProjectIncludeKeys;
        aggregate?: ProjectAggregateKeys;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedBillingList, any>({
        path: `/billing/billing-info`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name BillingControllerGetBillingSummary
     * @request GET:/billing/summary
     */
    getBillingSummary: (params: RequestParams = {}) =>
      this.request<BillingSummary, any>({
        path: `/billing/summary`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Billing
     * @name BillingControllerGet
     * @request GET:/billing/billing-info/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<ProjectBillingItem, any>({
        path: `/billing/billing-info/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  invoice = {
    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetAllProjectInvoices
     * @request GET:/invoice/project
     */
    getAllProjectInvoices: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: InvoiceFilterKeys;
        sort?: InvoiceSort;
        pagination?: PaginationFilter;
        include?: InvoiceIncludeKeys;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInvoice, any>({
        path: `/invoice/project`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetAllFreelancerInvoices
     * @request GET:/invoice/freelancer
     */
    getAllFreelancerInvoices: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: InvoiceFilterKeys;
        sort?: InvoiceSort;
        pagination?: PaginationFilter;
        include?: InvoiceIncludeKeys;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInvoice, any>({
        path: `/invoice/freelancer`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetAllSubscriptionInvoices
     * @request GET:/invoice/subscription
     */
    getAllSubscriptionInvoices: (
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: InvoiceFilterKeys;
        sort?: InvoiceSort;
        pagination?: PaginationFilter;
        include?: InvoiceIncludeKeys;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedInvoice, any>({
        path: `/invoice/subscription`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetProjectInvoiceById
     * @request GET:/invoice/project/{id}
     */
    getProjectInvoiceById: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invoice/project/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGenerateForProject
     * @request POST:/invoice/project/{id}
     */
    generateForProject: (id: string, data: InvoiceInput, params: RequestParams = {}) =>
      this.request<Invoice, any>({
        path: `/invoice/project/${id}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetFreelancerInvoiceById
     * @request GET:/invoice/freelancer/{id}
     */
    getFreelancerInvoiceById: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invoice/freelancer/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetSubscriptionInvoiceById
     * @request GET:/invoice/subscription/{id}
     */
    getSubscriptionInvoiceById: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invoice/subscription/${id}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerDownloadProjectInvoice
     * @request GET:/invoice/project/{projectId}/download/{invoiceId}
     */
    downloadProjectInvoice: (projectId: string, invoiceId: string, params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/invoice/project/${projectId}/download/${invoiceId}`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetDataForProject
     * @request GET:/invoice/project/{id}/pre-invoice
     */
    getDataForProject: (id: string, params: RequestParams = {}) =>
      this.request<PreInvoiceProject, any>({
        path: `/invoice/project/${id}/pre-invoice`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerGetSingleProjectInvoice
     * @request GET:/invoice/project/{projectId}/invoice/{invoiceId}
     */
    getSingleProjectInvoice: (projectId: string, invoiceId: string, params: RequestParams = {}) =>
      this.request<Invoice, any>({
        path: `/invoice/project/${projectId}/invoice/${invoiceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerUpdateProjectInvoice
     * @request PUT:/invoice/project/{projectId}/invoice/{invoiceId}
     */
    updateProjectInvoice: (
      projectId: string,
      invoiceId: string,
      data: InvoiceInput,
      params: RequestParams = {},
    ) =>
      this.request<Invoice, any>({
        path: `/invoice/project/${projectId}/invoice/${invoiceId}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerDeleteProjectInvoice
     * @request DELETE:/invoice/project/{projectId}/invoice/{invoiceId}
     */
    deleteProjectInvoice: (projectId: string, invoiceId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/invoice/project/${projectId}/invoice/${invoiceId}`,
        method: "DELETE",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Invoice
     * @name InvoiceControllerSendProjectInvoiceEmail
     * @request POST:/invoice/project/{projectId}/invoice/{invoiceId}/send
     */
    sendProjectInvoiceEmail: (
      invoiceId: string,
      projectId: string,
      data: {
        /**
         * Email address to send the invoice to
         *
         * @format email
         */
        recipientEmail: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/invoice/project/${projectId}/invoice/${invoiceId}/send`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  shiftDeclaration = {
    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerUpdateFullEntry
     * @request PUT:/shift-declaration/full/{id}
     */
    updateFullEntry: (id: string, data: FullEntryUpdateInput, params: RequestParams = {}) =>
      this.request<PaginatedShiftDeclaration, any>({
        path: `/shift-declaration/full/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerGetAll
     * @request GET:/shift-declaration
     */
    getAll: (
      query?: {
        /**
         * Filter supporting simple object or logical operations (AND/OR) for
         * ShiftDeclarationFilterKeys
         */
        filter?:
          | ShiftDeclarationFilterKeys
          | (
              | {
                  AND?: ShiftDeclarationFilterKeys[];
                }
              | {
                  OR?: ShiftDeclarationFilterKeys[];
                }
            )[];
        sort?: ShiftDeclarationSort;
        pagination?: PaginationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedShiftDeclaration, any>({
        path: `/shift-declaration`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerGetAllByProject
     * @request GET:/shift-declaration/{id}
     */
    getAllByProject: (
      id: string,
      query?: {
        /** Filter that supports simple, AND, and OR operations */
        filter?: ShiftDeclarationFilterKeys;
        sort?: ShiftDeclarationSort;
        pagination?: PaginationFilter;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedShiftDeclaration, any>({
        path: `/shift-declaration/${id}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerUpdateEntryTime
     * @request PUT:/shift-declaration/{id}
     */
    updateEntryTime: (id: string, data: ShiftTimeEntryUpdateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift-declaration/${id}`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerUpdateBreakTime
     * @request PUT:/shift-declaration/{id}/break-time
     */
    updateBreakTime: (id: string, data: BreakTimeUpdateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift-declaration/${id}/break-time`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerUpdateStatus
     * @request PUT:/shift-declaration/{id}/status
     */
    updateStatus: (id: string, data: StatusUpdateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift-declaration/${id}/status`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerUpdateRating
     * @request PUT:/shift-declaration/{id}/rating
     */
    updateRating: (id: string, data: RatingUpdateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift-declaration/${id}/rating`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerUpdateBonus
     * @request PUT:/shift-declaration/{id}/bonus
     */
    updateBonus: (id: string, data: BonusUpdateInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift-declaration/${id}/bonus`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerClockIn
     * @request POST:/shift-declaration/qr/clock-in
     */
    clockIn: (data: QRClockInInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift-declaration/qr/clock-in`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerClockOut
     * @request POST:/shift-declaration/qr/clock-out
     */
    clockOut: (data: QRClockOutInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift-declaration/qr/clock-out`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerClockBreakTime
     * @request POST:/shift-declaration/clock-break-time
     */
    clockBreakTime: (data: ClockBreakTimeInput, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift-declaration/clock-break-time`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ShiftDeclaration
     * @name ShiftDeclarationControllerDeleteShiftTimeEntry
     * @request DELETE:/shift-declaration/{id}/time-entry
     */
    deleteShiftTimeEntry: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/shift-declaration/${id}/time-entry`,
        method: "DELETE",
        ...params,
      }),
  };
  shiftDeclarationImport = {
    /**
     * No description
     *
     * @tags Shift Declaration Import
     * @name ShiftDeclarationImportControllerGetExampleFile
     * @request GET:/shift-declaration-import/example-file
     */
    getExampleFile: (params: RequestParams = {}) =>
      this.request<File, any>({
        path: `/shift-declaration-import/example-file`,
        method: "GET",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift Declaration Import
     * @name ShiftDeclarationImportControllerValidateTimeEntries
     * @request POST:/shift-declaration-import/validate
     */
    validateTimeEntries: (
      data: {
        /** @format binary */
        file?: File;
        projectId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<TimeEntryValidationResult[], any>({
        path: `/shift-declaration-import/validate`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Shift Declaration Import
     * @name ShiftDeclarationImportControllerImportTimeEntries
     * @request POST:/shift-declaration-import/import
     */
    importTimeEntries: (
      data: {
        timeEntries: TimeEntryValidationResult[];
        projectId: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/shift-declaration-import/import`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
  expenseClaim = {
    /**
     * No description
     *
     * @tags ExpenseClaim
     * @name ExpenseClaimControllerGetById
     * @request GET:/expense-claim/{id}
     */
    getById: (id: string, params: RequestParams = {}) =>
      this.request<ExpenseClaim, any>({
        path: `/expense-claim/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExpenseClaim
     * @name ExpenseClaimControllerCreateForShiftTimeEntry
     * @request POST:/expense-claim/{id}
     */
    createForShiftTimeEntry: (
      id: string,
      data: ExpenseClaimCreateInput,
      params: RequestParams = {},
    ) =>
      this.request<ExpenseClaim, any>({
        path: `/expense-claim/${id}`,
        method: "POST",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExpenseClaim
     * @name ExpenseClaimControllerUpdate
     * @request PATCH:/expense-claim/{id}
     */
    update: (id: string, data: ExpenseClaimUpdateInput, params: RequestParams = {}) =>
      this.request<ExpenseClaim, any>({
        path: `/expense-claim/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),
  };
  position = {
    /**
     * No description
     *
     * @tags Position
     * @name PositionControllerGetAllByProject
     * @request GET:/position/project/{id}
     */
    getAllByProject: (id: string, params: RequestParams = {}) =>
      this.request<PaginatedPosition, any>({
        path: `/position/project/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Position
     * @name PositionControllerCreate
     * @request POST:/position
     */
    create: (data: PositionCreateInput, params: RequestParams = {}) =>
      this.request<PositionCreateInput, any>({
        path: `/position`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Position
     * @name PositionControllerGet
     * @request GET:/position/{id}
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<Position, any>({
        path: `/position/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Position
     * @name PositionControllerUpdate
     * @request PATCH:/position/{id}
     */
    update: (id: string, data: PositionUpdateInput, params: RequestParams = {}) =>
      this.request<PositionUpdateInput, any>({
        path: `/position/${id}`,
        method: "PATCH",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Position
     * @name PositionControllerDelete
     * @request DELETE:/position/{id}
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/position/${id}`,
        method: "DELETE",
        ...params,
      }),
  };
  wellKnown = {
    /**
     * Returns the apple-app-site-association file for iOS universal links
     *
     * @tags Well Known
     * @name WellKnownControllerGetAppleAppSiteAssociation
     * @summary Apple App Site Association
     * @request GET:/.well-known/apple-app-site-association
     */
    getAppleAppSiteAssociation: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/.well-known/apple-app-site-association`,
        method: "GET",
        ...params,
      }),

    /**
     * Returns the assetlinks.json file for Android app links
     *
     * @tags Well Known
     * @name WellKnownControllerGetAndroidAssetLinks
     * @summary Android Asset Links
     * @request GET:/.well-known/assetlinks.json
     */
    getAndroidAssetLinks: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/.well-known/assetlinks.json`,
        method: "GET",
        ...params,
      }),

    /**
     * Returns security contact information
     *
     * @tags Well Known
     * @name WellKnownControllerGetSecurityTxt
     * @summary Security Policy
     * @request GET:/.well-known/security.txt
     */
    getSecurityTxt: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/.well-known/security.txt`,
        method: "GET",
        ...params,
      }),

    /**
     * Returns robots.txt for search engines
     *
     * @tags Well Known
     * @name WellKnownControllerGetRobotsTxt
     * @summary Robots.txt
     * @request GET:/.well-known/robots.txt
     */
    getRobotsTxt: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/.well-known/robots.txt`,
        method: "GET",
        ...params,
      }),
  };
  apps = {
    /**
     * Returns the apple-app-site-association file for iOS universal links for a specific whitelabel
     * app
     *
     * @tags App Well Known
     * @name AppWellKnownControllerGetAppleAppSiteAssociation
     * @summary Apple App Site Association for specific app
     * @request GET:/apps/{appId}/.well-known/apple-app-site-association
     */
    getAppleAppSiteAssociation: (appId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/apps/${appId}/.well-known/apple-app-site-association`,
        method: "GET",
        ...params,
      }),

    /**
     * Returns the assetlinks.json file for Android app links for a specific whitelabel app
     *
     * @tags App Well Known
     * @name AppWellKnownControllerGetAndroidAssetLinks
     * @summary Android Asset Links for specific app
     * @request GET:/apps/{appId}/.well-known/assetlinks.json
     */
    getAndroidAssetLinks: (appId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/apps/${appId}/.well-known/assetlinks.json`,
        method: "GET",
        ...params,
      }),
  };
  integrationProvider = {
    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerGetAll
     * @summary Get all integration providers for the organization
     * @request GET:/integration-provider
     * @secure
     */
    getAll: (params: RequestParams = {}) =>
      this.request<IntegrationProviderEntity[], any>({
        path: `/integration-provider`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerGet
     * @summary Get a single integration provider by ID
     * @request GET:/integration-provider/{id}
     * @secure
     */
    get: (id: string, params: RequestParams = {}) =>
      this.request<IntegrationProviderEntity, any>({
        path: `/integration-provider/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerDelete
     * @summary Archive an integration provider
     * @request DELETE:/integration-provider/{id}
     * @secure
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/integration-provider/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerCreateTwilioProvider
     * @summary Create a Twilio integration provider
     * @request POST:/integration-provider/twilio
     * @secure
     */
    createTwilioProvider: (data: TwilioProviderCreateInput, params: RequestParams = {}) =>
      this.request<IntegrationProviderEntity, any>({
        path: `/integration-provider/twilio`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerCreateMetaWhatsAppProvider
     * @summary Create a Meta WhatsApp integration provider
     * @request POST:/integration-provider/meta-whatsapp
     * @secure
     */
    createMetaWhatsAppProvider: (
      data: MetaWhatsAppProviderCreateInput,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationProviderEntity, any>({
        path: `/integration-provider/meta-whatsapp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerCreateSendgridProvider
     * @summary Create a SendGrid integration provider
     * @request POST:/integration-provider/sendgrid
     * @secure
     */
    createSendgridProvider: (data: SendgridProviderCreateInput, params: RequestParams = {}) =>
      this.request<IntegrationProviderEntity, any>({
        path: `/integration-provider/sendgrid`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerUpdateTwilioConfig
     * @summary Update Twilio configuration
     * @request PATCH:/integration-provider/{id}/config/twilio
     * @secure
     */
    updateTwilioConfig: (id: string, data: TwilioConfigUpdateInput, params: RequestParams = {}) =>
      this.request<IntegrationProviderEntity, any>({
        path: `/integration-provider/${id}/config/twilio`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerUpdateMetaWhatsAppConfig
     * @summary Update Meta WhatsApp configuration
     * @request PATCH:/integration-provider/{id}/config/meta-whatsapp
     * @secure
     */
    updateMetaWhatsAppConfig: (
      id: string,
      data: MetaWhatsAppConfigUpdateInput,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationProviderEntity, any>({
        path: `/integration-provider/${id}/config/meta-whatsapp`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerUpdateSendgridConfig
     * @summary Update SendGrid configuration
     * @request PATCH:/integration-provider/{id}/config/sendgrid
     * @secure
     */
    updateSendgridConfig: (
      id: string,
      data: SendgridConfigUpdateInput,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationProviderEntity, any>({
        path: `/integration-provider/${id}/config/sendgrid`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Returns the webhook URL that needs to be configured in the provider dashboard (e.g., Twilio
     * Console)
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerGetWebhookUrl
     * @summary Get the webhook URL for a provider
     * @request GET:/integration-provider/{id}/webhook-url
     * @secure
     */
    getWebhookUrl: (id: string, params: RequestParams = {}) =>
      this.request<WebhookUrlEntity, any>({
        path: `/integration-provider/${id}/webhook-url`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Validates Twilio Account SID and Auth Token by making a test API call
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerVerifyTwilioCredentials
     * @summary Verify Twilio credentials
     * @request POST:/integration-provider/twilio/verify-credentials
     * @secure
     */
    verifyTwilioCredentials: (data: TwilioVerifyCredentialsInput, params: RequestParams = {}) =>
      this.request<
        {
          /**
           * @example
           *   true;
           */
          valid?: boolean;
          /**
           * @example
           *   My Twilio Account
           */
          accountName?: string;
        },
        void
      >({
        path: `/integration-provider/twilio/verify-credentials`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Returns the app ID, graph API version, and configuration ID needed for the frontend Meta SDK
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerGetMetaConfig
     * @summary Get Meta embedded signup configuration
     * @request GET:/integration-provider/meta/config
     * @secure
     */
    getMetaConfig: (params: RequestParams = {}) =>
      this.request<MetaConfigEntity, any>({
        path: `/integration-provider/meta/config`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Receives events from the Meta SDK during the embedded signup flow (success, cancellation,
     * errors)
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerHandleMetaEvent
     * @summary Handle Meta embedded signup events
     * @request POST:/integration-provider/meta/events
     * @secure
     */
    handleMetaEvent: (data: MetaEventsInput, params: RequestParams = {}) =>
      this.request<
        {
          /**
           * @example
           *   true;
           */
          received?: boolean;
        },
        any
      >({
        path: `/integration-provider/meta/events`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Exchanges the authorization code from embedded signup completion for an access token and
     * creates/updates the provider. This endpoint ONLY handles token exchange. Phone number setup
     * must be done separately via the setup endpoint. IMPORTANT: The redirect_uri must match
     * EXACTLY what was used when initializing the Meta SDK. Capture window.location.href at SDK
     * initialization time (before any OAuth redirects) and pass it here.
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerExchangeMetaToken
     * @summary Exchange Meta authorization code for access token
     * @request POST:/integration-provider/meta/token-exchange
     * @secure
     */
    exchangeMetaToken: (data: MetaTokenExchangeInput, params: RequestParams = {}) =>
      this.request<MetaTokenExchangeResponseEntity, void>({
        path: `/integration-provider/meta/token-exchange`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Creates or updates a Meta WhatsApp provider with an existing WABA ID and access token. Use
     * this when you already have credentials from Business Manager or a previous setup, bypassing
     * the embedded signup flow. After calling this endpoint, use the setup endpoint to fetch phone
     * numbers and create endpoints.
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerCreateMetaProviderManually
     * @summary Manually create a Meta WhatsApp provider
     * @request POST:/integration-provider/meta/manual
     * @secure
     */
    createMetaProviderManually: (data: MetaManualSetupInput, params: RequestParams = {}) =>
      this.request<MetaManualSetupResponseEntity, void>({
        path: `/integration-provider/meta/manual`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Fetches all phone numbers associated with a WhatsApp Business Account from Meta API. This is
     * a separate step that can be retried if it fails, without redoing the embedded signup flow.
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerFetchMetaPhoneNumbers
     * @summary Fetch phone numbers from Meta API
     * @request GET:/integration-provider/meta/{providerId}/phone-numbers
     * @secure
     */
    fetchMetaPhoneNumbers: (providerId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/integration-provider/meta/${providerId}/phone-numbers`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * Completes the Meta WhatsApp setup by fetching phone numbers from Meta API, creating
     * endpoints, and subscribing to webhooks. This handles post-token-exchange setup steps and can
     * be retried if Meta API calls fail, without requiring the user to redo the embedded signup
     * flow.
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerSetupMetaWhatsApp
     * @summary Setup Meta WhatsApp endpoints
     * @request POST:/integration-provider/meta/setup
     * @secure
     */
    setupMetaWhatsApp: (data: MetaSetupInput, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/integration-provider/meta/setup`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * Subscribes the app to receive webhook notifications for a WhatsApp Business Account. Uses the
     * first endpoint's webhookUrl and webhookSecret to configure the callback. After subscribing,
     * Meta will send a GET request to verify the webhook endpoint. This can be called separately if
     * webhook subscription failed during setup.
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerSubscribeMetaWebhooks
     * @summary Subscribe to Meta WhatsApp webhooks
     * @request POST:/integration-provider/meta/{providerId}/subscribe-webhooks
     * @secure
     */
    subscribeMetaWebhooks: (providerId: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/integration-provider/meta/${providerId}/subscribe-webhooks`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerGetEndpoints
     * @summary Get all endpoints for a provider
     * @request GET:/integration-provider/{providerId}/endpoint
     * @secure
     */
    getEndpoints: (providerId: string, params: RequestParams = {}) =>
      this.request<IntegrationEndpointEntity[], any>({
        path: `/integration-provider/${providerId}/endpoint`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerCreateEndpoint
     * @summary Create an endpoint for a provider
     * @request POST:/integration-provider/{providerId}/endpoint
     * @secure
     */
    createEndpoint: (providerId: string, data: EndpointCreateInput, params: RequestParams = {}) =>
      this.request<IntegrationEndpointEntity, any>({
        path: `/integration-provider/${providerId}/endpoint`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerUpdateEndpoint
     * @summary Update an endpoint
     * @request PATCH:/integration-provider/{providerId}/endpoint/{id}
     * @secure
     */
    updateEndpoint: (
      providerId: string,
      id: string,
      data: EndpointUpdateInput,
      params: RequestParams = {},
    ) =>
      this.request<IntegrationEndpointEntity, any>({
        path: `/integration-provider/${providerId}/endpoint/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerDeleteEndpoint
     * @summary Archive an endpoint
     * @request DELETE:/integration-provider/{providerId}/endpoint/{id}
     * @secure
     */
    deleteEndpoint: (providerId: string, id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/integration-provider/${providerId}/endpoint/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * Sets the specified endpoint as the default for its channel within the organization. This will
     * set isDefault=false for all other endpoints of the same channel and set isDefault=true with
     * the highest priority (1) for the target endpoint.
     *
     * @tags Integration Provider
     * @name IntegrationProviderControllerSetEndpointAsDefault
     * @summary Set an endpoint as default for its channel
     * @request POST:/integration-provider/endpoint/{endpointId}/set-default
     * @secure
     */
    setEndpointAsDefault: (endpointId: string, params: RequestParams = {}) =>
      this.request<IntegrationEndpointEntity, void>({
        path: `/integration-provider/endpoint/${endpointId}/set-default`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  reports = {
    /**
     * No description
     *
     * @tags Reports
     * @name ReportsControllerGetEmployeeReport
     * @summary Get employee reports for the organization
     * @request GET:/reports/employees
     */
    getEmployeeReport: (params: RequestParams = {}) =>
      this.request<EmployeeReport, any>({
        path: `/reports/employees`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsControllerGetTotalCurrentEmployees
     * @summary Get total current (non-archived) employees
     * @request GET:/reports/employees/total-current
     */
    getTotalCurrentEmployees: (params: RequestParams = {}) =>
      this.request<TotalCurrentEmployees, any>({
        path: `/reports/employees/total-current`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsControllerGetTotalActiveEmployees
     * @summary Get total active employees for current month
     * @request GET:/reports/employees/total-active
     */
    getTotalActiveEmployees: (params: RequestParams = {}) =>
      this.request<TotalActiveEmployees, any>({
        path: `/reports/employees/total-active`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsControllerGetMonthlyActivity
     * @summary Get monthly activity graph data for last 12 months
     * @request GET:/reports/employees/monthly-activity
     */
    getMonthlyActivity: (params: RequestParams = {}) =>
      this.request<MonthlyActivityResponse, any>({
        path: `/reports/employees/monthly-activity`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsControllerGetHoursReport
     * @summary Get hours reports for the organization
     * @request GET:/reports/hours
     */
    getHoursReport: (params: RequestParams = {}) =>
      this.request<HoursReport, any>({
        path: `/reports/hours`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsControllerGetMonthlyHoursComparison
     * @summary Get monthly hours comparison data for last 12 months
     * @request GET:/reports/hours/monthly-comparison
     */
    getMonthlyHoursComparison: (params: RequestParams = {}) =>
      this.request<MonthlyHoursComparisonResponse, any>({
        path: `/reports/hours/monthly-comparison`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsControllerGetGroupedHoursReport
     * @summary Get grouped hours reports with shift metrics, unregistered metrics, and month overview
     * @request GET:/reports/hours/grouped
     */
    getGroupedHoursReport: (params: RequestParams = {}) =>
      this.request<GroupedHoursReport, any>({
        path: `/reports/hours/grouped`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsControllerGetDailyHoursComparison
     * @summary Get daily hours comparison for current month vs same period last month
     * @request GET:/reports/hours/daily-comparison
     */
    getDailyHoursComparison: (params: RequestParams = {}) =>
      this.request<DailyHoursComparisonResponse, any>({
        path: `/reports/hours/daily-comparison`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  messageTemplateVariable = {
    /**
     * Returns all available template variables for the organization. Use these variable names as
     * placeholders in template text (e.g., {{employeeFirstName}}).
     *
     * @tags message-template-variable
     * @name MessageTemplateVariableControllerGetAll
     * @summary Get available template variables
     * @request GET:/message-template-variable
     */
    getAll: (params: RequestParams = {}) =>
      this.request<PaginatedMessageTemplateVariable, any>({
        path: `/message-template-variable`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
  entityTags = {
    /**
     * No description
     *
     * @tags Entity Tags
     * @name EntityTagControllerCreate
     * @summary Create a new entity tag
     * @request POST:/entity-tags
     * @secure
     */
    create: (data: CreateEntityTagDto, params: RequestParams = {}) =>
      this.request<EntityTag, any>({
        path: `/entity-tags`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entity Tags
     * @name EntityTagControllerGetAll
     * @summary Get all entity tags with filtering
     * @request GET:/entity-tags
     * @secure
     */
    getAll: (
      query?: {
        /** Filter supporting simple object or logical operations (AND/OR) for EntityTagFilterKeys */
        filter?:
          | EntityTagFilterKeys
          | (
              | {
                  AND?: EntityTagFilterKeys[];
                }
              | {
                  OR?: EntityTagFilterKeys[];
                }
            )[];
        sort?: EntityTagSort;
        pagination?: PaginationFilter;
        include?: EntityTagInclude;
      },
      params: RequestParams = {},
    ) =>
      this.request<PaginatedEntityTags, any>({
        path: `/entity-tags`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * Quickly create an entity tag linking the specified source to your user account. This is a
     * convenience endpoint that automatically uses the authenticated user as the target.
     *
     * @tags Entity Tags
     * @name EntityTagControllerAssignToSelf
     * @summary Assign a conversation or entity to yourself
     * @request POST:/entity-tags/assign-to-self
     * @secure
     */
    assignToSelf: (data: AssignToSelfDto, params: RequestParams = {}) =>
      this.request<EntityTag, any>({
        path: `/entity-tags/assign-to-self`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entity Tags
     * @name EntityTagControllerGetOne
     * @summary Get a single entity tag by ID
     * @request GET:/entity-tags/{id}
     * @secure
     */
    getOne: (id: string, params: RequestParams = {}) =>
      this.request<EntityTagWithDetails, any>({
        path: `/entity-tags/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entity Tags
     * @name EntityTagControllerDelete
     * @summary Delete an entity tag
     * @request DELETE:/entity-tags/{id}
     * @secure
     */
    delete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/entity-tags/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entity Tags
     * @name EntityTagControllerUpdate
     * @summary Update entity tag metadata
     * @request PATCH:/entity-tags/{id}
     * @secure
     */
    update: (id: string, data: UpdateEntityTagDto, params: RequestParams = {}) =>
      this.request<EntityTag, any>({
        path: `/entity-tags/${id}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entity Tags
     * @name EntityTagControllerGetTagsForSource
     * @summary Get all tags for a specific source
     * @request GET:/entity-tags/source/{sourceType}/{sourceId}
     * @secure
     */
    getTagsForSource: (sourceType: string, sourceId: string, params: RequestParams = {}) =>
      this.request<EntityTag[], any>({
        path: `/entity-tags/source/${sourceType}/${sourceId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entity Tags
     * @name EntityTagControllerGetTagsForTarget
     * @summary Get all tags for a specific target
     * @request GET:/entity-tags/target/{targetType}/{targetId}
     * @secure
     */
    getTagsForTarget: (targetType: string, targetId: string, params: RequestParams = {}) =>
      this.request<EntityTag[], any>({
        path: `/entity-tags/target/${targetType}/${targetId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entity Tags
     * @name EntityTagControllerGetTargetOptions
     * @summary Get available target options for tagging
     * @request GET:/entity-tags/options/targets/{targetType}
     * @secure
     */
    getTargetOptions: (
      targetType: string,
      query?: {
        /** Search term for filtering options */
        search?: string;
        /**
         * Maximum number of options to return
         *
         * @default 20
         */
        limit?: number;
        /** IDs to exclude from results (already tagged) */
        excludeIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<EntityTagOption[], any>({
        path: `/entity-tags/options/targets/${targetType}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Entity Tags
     * @name EntityTagControllerGetSourceOptions
     * @summary Get available source options for tagging
     * @request GET:/entity-tags/options/sources/{sourceType}
     * @secure
     */
    getSourceOptions: (
      sourceType: string,
      query?: {
        /** Search term for filtering options */
        search?: string;
        /**
         * Maximum number of options to return
         *
         * @default 20
         */
        limit?: number;
        /** IDs to exclude from results (already tagged) */
        excludeIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<EntityTagOption[], any>({
        path: `/entity-tags/options/sources/${sourceType}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  demo = {
    /**
     * Assigns demo NPC employees to the provided shifts based on their functions and sends fake
     * WhatsApp invite messages. Messages are created in the database but not actually sent via the
     * provider.
     *
     * @tags demo
     * @name DemoControllerAssignShifts
     * @summary Assign demo NPC employees to shifts and send fake invites
     * @request POST:/demo/assign-shifts
     */
    assignShifts: (data: AssignShiftsDto, params: RequestParams = {}) =>
      this.request<
        {
          /** Number of shifts successfully assigned */
          assignedCount?: number;
          /** Success message */
          message?: string;
        },
        any
      >({
        path: `/demo/assign-shifts`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * Removes employee assignments from the provided shifts and broadcasts the change via
     * WebSocket.
     *
     * @tags demo
     * @name DemoControllerUnassignShifts
     * @summary Unassign employees from shifts
     * @request POST:/demo/unassign-shifts
     */
    unassignShifts: (data: UnassignShiftsDto, params: RequestParams = {}) =>
      this.request<
        {
          /** Number of shifts successfully unassigned */
          unassignedCount?: number;
          /** Success message */
          message?: string;
        },
        any
      >({
        path: `/demo/unassign-shifts`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags demo
     * @name DemoControllerPlanShifts
     * @request POST:/demo/plan-shifts/{id}
     */
    planShifts: (id: string, params: RequestParams = {}) =>
      this.request<PlanningResult, any>({
        path: `/demo/plan-shifts/${id}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * Handles registration form submissions from the mobile app. Sends notification emails to the
     * team (aron@heyboomer.nl)
     *
     * @tags demo
     * @name DemoControllerSubmitRegistration
     * @summary Submit registration form and send notification email
     * @request POST:/demo/registration/submit
     */
    submitRegistration: (data: RegistrationDto, params: RequestParams = {}) =>
      this.request<
        {
          /** Whether the registration was submitted successfully */
          success?: boolean;
          /** Success message */
          message?: string;
        },
        void
      >({
        path: `/demo/registration/submit`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
